/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable max-lines */

export const appV2EventPrefix = "HCP Mobile App (V2):";

const brazeEventPrefix = "Braze:";

/**
 * Temporary Braze custom events used for an ongoing campaign.
 * If we migrate to Knock and need to remove Braze, contact the Tempo team
 * before removing these events.
 */
export const APP_V2_BRAZE_CUSTOM_EVENTS = {
  BOOKINGS_PAGE_VIEWED: `${brazeEventPrefix} Bookings Page Viewed`,
} as const;

export const APP_V2_USER_EVENTS = {
  // Accounts Page
  OPENED_TERMS_OF_SERVICE: `${appV2EventPrefix} Opened Terms of Service`,
  OPENED_CONTACT_SUPPORT: `${appV2EventPrefix} Opened Contact Support`,

  // Auth
  SUBMIT_LOGIN_FORM_WITH_PHONE_NUMBER: `${appV2EventPrefix} Submit Login Form With Phone Number`,
  AUTO_LOGIN_FROM_URL_WITH_PHONE_NUMBER: `${appV2EventPrefix} Auto Login From URL With Phone Number`,
  SUBMIT_LOGIN_FORM_WITH_EMAIL: `${appV2EventPrefix} Submit Login Form With Email`,
  SWITCH_LOGIN_METHOD: `${appV2EventPrefix} Switch Login Method`,
  SUBMIT_SIGNUP_FORM: `${appV2EventPrefix} Submit Signup Form`,
  SWITCH_BETWEEN_LOGIN_SIGNUP: `${appV2EventPrefix} Switch Between Login and Signup`,
  SUBMIT_AUTH_OTP_FORM: `${appV2EventPrefix} Submit OTP form`,
  SUBMIT_AUTH_OTP_FORM_SUCCESS: `${appV2EventPrefix} Submit OTP form success`,
  SUBMIT_AUTH_OTP_FORM_ERROR: `${appV2EventPrefix} Submit OTP form error`,
  RESEND_OTP: `${appV2EventPrefix} Resend OTP`,
  CLOSE_VERIFY_OTP_DIALOG: `${appV2EventPrefix} Close OTP form`,
  CLOSE_LOGIN_CONFIRMATION_DIALOG: `${appV2EventPrefix} Close Login Confirmation Dialog`,
  VIEWED_PHONE_NUMBER_EXISTS_DIALOG: `${appV2EventPrefix} Viewed Phone Number Exists Dialog`,
  SELECT_PHONE_NUMBER_EXISTS_LOGIN: `${appV2EventPrefix} Phone Number Exists Login`,
  CLOSE_PHONE_NUMBER_EXISTS_DIALOG: `${appV2EventPrefix} Close Phone Number Exists Dialog`,
  SELECT_SIGN_UP_INSTEAD: `${appV2EventPrefix} Sign Up Instead`,
  CLOSE_SIGN_UP_INSTEAD_DIALOG: `${appV2EventPrefix} Close Sign Up Instead Dialog`,
  SIGN_UP_INSTEAD_DIALOG_VIEWED: `${appV2EventPrefix} Sign Up Instead Dialog Viewed`,
  VIEWED_WHATS_NEXT: `${appV2EventPrefix} Viewed What's Next information`,

  // Shift Boost
  SHIFT_BOOST_BOTTOM_SHEET_OPENED: `${appV2EventPrefix} Shift Boost Bottom Sheet Opened`,

  // Profile Update
  PROFILE_UPDATE_EMAIL_INITIATED: `${appV2EventPrefix} Profile Update Email Initiated`,
  PROFILE_UPDATE_EMAIL_COMPLETED: `${appV2EventPrefix} Profile Update Email Completed`,
  PROFILE_UPDATE_PHONE_INITIATED: `${appV2EventPrefix} Profile Update Phone Initiated`,
  PROFILE_UPDATE_PHONE_COMPLETED: `${appV2EventPrefix} Profile Update Phone Completed`,
  PROFILE_UPDATE_PROFILE_IMAGE_INITIATED: `${appV2EventPrefix} Profile Update Profile Image Initiated`,
  PROFILE_UPDATE_PROFILE_IMAGE_COMPLETED: `${appV2EventPrefix} Profile Update Profile Image Completed`,
  PROFILE_UPDATE_PROFILE_IMAGE_SELECTION_FAILURE: `${appV2EventPrefix} Profile Update Profile Image Selection Failure`,

  // Charting Reminder
  CHARTING_REMINDER_CLOCK_IN_ALREADY_HAVE_LOGIN: `${appV2EventPrefix} Charting Reminder - Clock In - I already have credentials`,
  CHARTING_REMINDER_CLOCK_IN_REQUEST_CREDENTIALS: `${appV2EventPrefix} Charting Reminder - Clock In - I will request credentials`,
  CHARTING_REMINDER_CLOCK_OUT_CONTINUE: `${appV2EventPrefix} Charting Reminder - Clock Out - I'm at 100%, continue with clock out`,
  CHARTING_REMINDER_CLOCK_OUT_CANCEL: `${appV2EventPrefix} Charting Reminder - Clock Out - Not yet, I'll finish charting`,
  CHARTING_REMINDER_VIEW_MY_LOGIN: `${appV2EventPrefix} Charting Reminder - View My Login`,
  CHARTING_REMINDER_CREDENTIALS_ACKNOWLEDGEMENT: `${appV2EventPrefix} Charting Reminder - Credentials Acknowledgement`,

  // Clock In Charting Credentials
  CLOCK_IN_CHARTING_CREDENTIALS_UPDATE_ERROR: `${appV2EventPrefix} Clock In Charting Credentials - Update Error`,
  CLOCK_IN_CHARTING_CREDENTIALS_CHAT_CHANNEL_ERROR: `${appV2EventPrefix} Clock In Charting Credentials - Chat Channel Creation Error`,

  // Charting Credentials Setup Bottom Sheet
  CHARTING_CREDENTIALS_SETUP_LOGGED_IN_WITH_EXISTING_CREDENTIALS: `${appV2EventPrefix} Charting Credentials Setup - Logged In With Existing Credentials`,
  CHARTING_CREDENTIALS_SETUP_TROUBLE_LOGGING_IN_WITH_EXISTING_CREDENTIALS: `${appV2EventPrefix} Charting Credentials Setup - Trouble Logging In With Existing Credentials`,
  CHARTING_CREDENTIALS_SETUP_SKIP_WITH_EXISTING_CREDENTIALS: `${appV2EventPrefix} Charting Credentials Setup - Skip With Existing Credentials`,
  CHARTING_CREDENTIALS_SETUP_LOGGED_IN_WITHOUT_EXISTING_CREDENTIALS: `${appV2EventPrefix} Charting Credentials Setup - Logged In Without Existing Credentials`,
  CHARTING_CREDENTIALS_SETUP_TROUBLE_LOGGING_IN_WITHOUT_EXISTING_CREDENTIALS: `${appV2EventPrefix} Charting Credentials Setup - Trouble Logging In Without Existing Credentials`,
  CHARTING_CREDENTIALS_SETUP_SKIP_WITHOUT_EXISTING_CREDENTIALS: `${appV2EventPrefix} Charting Credentials Setup - Skip Without Existing Credentials`,

  // Update Charting Credentials Bottom Sheet
  CHARTING_CREDENTIALS_UPDATE_SAVE_NEW_CREDENTIALS: `${appV2EventPrefix} Charting Credentials Update - Save New Credentials`,
  CHARTING_CREDENTIALS_UPDATE_SAVE_UNCHANGED_CREDENTIALS: `${appV2EventPrefix} Charting Credentials Update - Save Unchanged Credentials`,
  CHARTING_CREDENTIALS_UPDATE_SAVE_UPDATED_CREDENTIALS: `${appV2EventPrefix} Charting Credentials Update - Save Updated Credentials`,

  // Charting Required Card
  CHARTING_REQUIRED_CARD_REQUEST_LOGIN: `${appV2EventPrefix} Charting Required Card - Request Login`,
  CHARTING_REQUIRED_CARD_SAVE_LOGIN: `${appV2EventPrefix} Charting Required Card - Save Login`,
  CHARTING_REQUIRED_CARD_MY_LOGIN: `${appV2EventPrefix} Charting Required Card - My Login`,
  CHARTING_REQUIRED_CARD_CHAT_CHANNEL_ERROR: `${appV2EventPrefix} Charting Required Card - Chat Channel Error`,

  // Your Charting Login Bottom Sheet
  YOUR_CHARTING_LOGIN_GOT_IT: `${appV2EventPrefix} Your Charting Login - Got It`,
  YOUR_CHARTING_LOGIN_UPDATE: `${appV2EventPrefix} Your Charting Login - Update`,

  // Unable To Access Charting Bottom Sheet
  CHARTING_CREDENTIALS_UNABLE_ACCESS_MESSAGE_WORKPLACE: `${appV2EventPrefix} Charting Credentials Unable Access - Message Workplace`,
  CHARTING_CREDENTIALS_UNABLE_ACCESS_CONTACT_SUPPORT: `${appV2EventPrefix} Charting Credentials Unable Access - Contact Support`,

  // Worker Credential
  WORKER_CREDENTIAL_SHARED_MESSAGE_VIEW_LOGIN_BUTTON_CLICKED: `${appV2EventPrefix} Worker Credential Shared - Message View Login Button Clicked`,
  CHAT_DETECTED_CHARTING_CREDENTIALS_UPDATE_BUTTON_CLICKED: `${appV2EventPrefix} Chat Detected Charting Credentials - Update Button Clicked`,
  CHAT_DETECTED_CHARTING_CREDENTIALS_DISMISSED: `${appV2EventPrefix} Chat Detected Charting Credentials - Dismissed`,

  // Charting Noncompliance
  CHARTING_NONCOMPLIANCE_ACKNOWLEDGEMENT: `${appV2EventPrefix} Charting Noncompliance - acknowledgement`,
  CHARTING_NONCOMPLIANCE_SEND_EMAIL: `${appV2EventPrefix} Charting Noncompliance - send email`,
  CHARTING_NONCOMPLIANCE_TASK_COMPLETED: `${appV2EventPrefix} Charting Noncompliance - task completed`,
  CHARTING_NONCOMPLIANCE_GOT_IT: `${appV2EventPrefix} Charting Noncompliance - got it`,
  CHARTING_NONCOMPLIANCE_WORKPLACE_MESSAGED: `${appV2EventPrefix} Charting Noncompliance - workplace messaged`,
  CHARTING_NONCOMPLIANCE_WORKPLACE_MESSAGED_AFTER_REVIEW: `${appV2EventPrefix} Charting Noncompliance - workplace messaged after review`,
  CHARTING_NONCOMPLIANCE_TRY_AGAIN: `${appV2EventPrefix} Charting Noncompliance - try again`,
  CHARTING_NONCOMPLIANCE_NOT_YET: `${appV2EventPrefix} Charting Noncompliance - not yet`,
  CHARTING_NONCOMPLIANCE_INSIDE_WORKPLACE: `${appV2EventPrefix} Charting Noncompliance - inside workplace`,
  CHARTING_NONCOMPLIANCE_RESOLVE_INCOMPLETE_CHARTING: `${appV2EventPrefix} Charting Noncompliance - resolve incomplete charting`,
  CHARTING_NONCOMPLIANCE_RESOLVE_VIOLATION: `${appV2EventPrefix} Charting Noncompliance - resolve violation`,
  CHARTING_NONCOMPLIANCE_SEE_DETAILS_REVIEW: `${appV2EventPrefix} Charting Noncompliance - see details review`,

  // Rating
  IN_APP_RATING_PROMPT_REQUESTED: `${appV2EventPrefix} In-app rating prompt requested`,
  IN_APP_RATING_PROMPT_TRIGGERED: `${appV2EventPrefix} In-app rating prompt triggered`,
  IN_APP_RATING_PROMPT_NOT_TRIGGERED: `${appV2EventPrefix} In-app rating prompt not triggered`,
  IN_APP_RATING_PROMPT_ERROR: `${appV2EventPrefix} In-app rating prompt error`,
  IN_APP_RATING_PROMPT_FETCH_PAYROLL: `${appV2EventPrefix} In-app rating prompt caused fetch payroll`,

  // Open Shifts
  OPEN_SHIFTS_CALENDAR_VIEWED: `${appV2EventPrefix} Open Shift Calendar Viewed`,
  OPEN_SHIFTS_CALENDAR_DATE_SELECTED: `${appV2EventPrefix} Open Shift Calendar Date Selected`,
  OPEN_SHIFTS_CALENDAR_SELECT_PREVIOUS: `${appV2EventPrefix} Open Shift Calendar Select Previous`,
  OPEN_SHIFTS_CALENDAR_SELECT_NEXT: `${appV2EventPrefix} Open Shift Calendar Select Next`,
  OPEN_SHIFTS_CALENDAR_OPEN_FILTER_LICENSE: `${appV2EventPrefix} Open Shift Calendar Open Filter License`,
  OPEN_SHIFTS_CALENDAR_OPEN_FILTER_DISTANCE: `${appV2EventPrefix} Open Shift Calendar Open Filter Distance`,
  OPEN_SHIFTS_CALENDAR_SUBMIT_FILTER_DISTANCE_DIALOG: `${appV2EventPrefix} Open Shift Calendar Submit Filter Distance`,
  OPEN_SHIFTS_CALENDAR_SUBMIT_FILTER_LICENSE_DIALOG: `${appV2EventPrefix} Open Shift Calendar Submit Filter License`,
  OPEN_SHIFT_COLLEAGUES_VIEWED: `${appV2EventPrefix} Open shift colleagues viewed`,
  OPEN_SHIFTS_DAY_VIEW_VIEWED: `${appV2EventPrefix} Open Shifts Day View V2 Viewed`,
  OPEN_SHIFTS_DAY_VIEW_SHIFT_PERIOD_SELECTED: `${appV2EventPrefix} Open Shift Day View V2 Shift Period Selected`,
  VIEWED_NEXT_OPEN_SHIFT_PAGE: `${appV2EventPrefix} Viewed Next Open Shifts Page`,

  // Shift Discovery
  OPEN_SHIFTS_LIST_VIEWED: `${appV2EventPrefix} Open Shifts List Viewed`,
  OPEN_SHIFTS_CALENDAR_OPENED: `${appV2EventPrefix} Open Shifts calendar Opened`,
  OPEN_SHIFTS_CALENDAR_CLOSED: `${appV2EventPrefix} Open Shifts Calendar Closed`,
  OPEN_SHIFTS_CALENDAR_VIEWED_SELECTED: `${appV2EventPrefix} Open Shifts Calendar Viewed Selected Dates`,
  OPEN_SHIFTS_CALENDAR_DATE_TOGGLED: `${appV2EventPrefix} Open Shifts Calendar Date Toggled`,
  OPEN_SHIFTS_CALENDAR_DATES_CLEARED: `${appV2EventPrefix} Open Shifts Calendar Dates Cleared`,
  OPEN_SHIFTS_FILTERS_VIEWED: `${appV2EventPrefix} Open Shifts Filters Viewed`,
  OPEN_SHIFTS_FILTERS_V2_VIEWED: `${appV2EventPrefix} Open Shifts Filters V2 Viewed`,
  OPEN_SHIFTS_FILTERS_APPLIED: `${appV2EventPrefix} Open Shifts Filters Applied`,
  OPEN_SHIFTS_FILTERS_CLOSED: `${appV2EventPrefix} Open Shifts Filters Closed`,
  OPEN_SHIFTS_FILTERS_CLEARED: `${appV2EventPrefix} Open Shifts Filters Cleared`,
  OPEN_SHIFTS_CALLOUT_VIEWED: `${appV2EventPrefix} Open Shifts Callout Viewed`,
  OPEN_SHIFTS_CARD_DISABLED: `${appV2EventPrefix} Open Shifts Card Disabled`,
  SHIFT_DETAILS_OPENED: `${appV2EventPrefix} Shift Details Opened`,
  SHIFT_DETAILS_VIEWED: `${appV2EventPrefix} Shift Details Viewed`,
  SHIFT_DETAILS_CLOSED: `${appV2EventPrefix} Shift Details Closed`,
  SHIFT_DETAILS_FAILED_TO_LOAD: `${appV2EventPrefix} Shift Details Failed To Load`,
  SHIFT_DETAILS_UNAVAILABLE_CLOSED: `${appV2EventPrefix} Shift Details Unavailable Closed`,
  SHIFT_DETAILS_COPY_WORKPLACE_ADDRESS: `${appV2EventPrefix} Shift Details Copy Workplace Address`,
  SHIFT_DETAILS_OPEN_WORKPLACE_MAP: `${appV2EventPrefix} Shift Details Open Workplace Map`,
  SHIFT_DETAILS_CTA_BOOK_SHIFT: `${appV2EventPrefix} Shift Details CTA Book Shift`,
  SHIFT_DETAILS_DOC_RESOLUTION_VIEWED: `${appV2EventPrefix} Shift Details Doc Resolution Viewed`,
  SHIFT_DETAILS_CTA_VIEW_REQUIREMENTS: `${appV2EventPrefix} Shift Details CTA View Requirements`,
  SHIFT_DETAILS_CARD_CTA_BLOCKING_DOCUMENT: `${appV2EventPrefix} Shift Details Card CTA Blocking Document`,
  SHIFT_DETAILS_CTA_START_QUIZ: `${appV2EventPrefix} Shift Details CTA Start Quiz`,
  SHIFT_DETAILS_CTA_SIGN_AGREEMENT: `${appV2EventPrefix} Shift Details CTA Sign Agreement`,
  SHIFT_DETAILS_CTA_SETUP_PAYMENTS: `${appV2EventPrefix} Shift Details CTA Setup Payments`,
  SHIFT_DETAILS_CTA_MARK_INTEREST: `${appV2EventPrefix} Shift Details CTA Mark Interest`,
  SHIFT_DETAILS_CTA_CREATE_BOOKING_REQUEST: `${appV2EventPrefix} Shift Details CTA Create Booking Request`,
  SHIFT_DETAILS_NOT_INSTANT_BOOKABLE: `${appV2EventPrefix} Shift Details Not Instant Bookable`,
  SHIFT_DETAILS_SHIFT_IN_WEEK_MODAL_OPENED: `${appV2EventPrefix} Shift Details Shift in Week Modal Opened`,
  SHIFT_DETAILS_SHIFT_IN_WEEK_MODAL_DAY_SELECTED: `${appV2EventPrefix} Shift Details Shift in Week Modal Day Selected`,
  WORKPLACE_CHECK_IN_INSTRUCTIONS_OPENED: `${appV2EventPrefix} Workplace Check In Instructions Opened`,
  WORKPLACE_CLOCK_IN_GUIDE_OPENED: `${appV2EventPrefix} Workplace Clock In Guide Opened`,
  WORKPLACE_OPEN_SHIFTS_OPENED: `${appV2EventPrefix} Workplace Open Shifts Opened`,
  WORKPLACE_PROFILE_OPENED: `${appV2EventPrefix} Workplace Profile Opened`,
  SHIFTS_INVALIDATED_ON_DEEPLINK: `${appV2EventPrefix} Shifts Invalidated On Deeplink`,
  SHIFTS_INVALIDATED_ON_APP_RESUMED: `${appV2EventPrefix} Shifts Invalidated On App Resumed`,
  SHIFT_LIST_TIME_SLOT_CLICKED: `${appV2EventPrefix} Shift List Time Slot Clicked`,
  BROWSE_WORKPLACES_OPENED: `${appV2EventPrefix} Browse Workplaces Opened`,
  BROWSE_WORKPLACES_CLOSED: `${appV2EventPrefix} Browse Workplaces Closed`,
  URGENT_SHIFTS_DEEPLINK_OPENED: `${appV2EventPrefix} Urgent Shifts Deeplink Opened`,
  URGENT_SHIFTS_DEEPLINK_SHIFT_OPENED: `${appV2EventPrefix} Urgent Shifts Deeplink Shift Opened`,
  URGENT_SHIFTS_DEEPLINK_MISSING_SHIFT: `${appV2EventPrefix} Urgent Shifts Deeplink Missing Shift`,
  OFFER_CREATED: `${appV2EventPrefix} Offer Created`,
  CHAT_WITH_WORKPLACE: `${appV2EventPrefix} Chat with Workplace`,
  CALL_WORKPLACE: `${appV2EventPrefix} Call Workplace`,

  // Shift Details
  SHIFT_DETAILS_CLOCK_IN_NOW_TAPPED: `${appV2EventPrefix} Shift Details Clock In Now Tapped`,
  SHIFT_DETAILS_LATE_FOR_SHIFT_TAPPED: `${appV2EventPrefix} Shift Details Late For Shift Tapped`,
  SHIFT_DETAILS_SENT_HOME_TAPPED: `${appV2EventPrefix} Shift Details Sent Home Tapped`,
  SHIFT_DETAILS_CANCEL_SHIFT_TAPPED: `${appV2EventPrefix} Shift Details Cancel Shift Tapped`,
  SHIFT_DETAILS_TRANSFER_SHIFT_TAPPED: `${appV2EventPrefix} Shift Details Transfer Shift Tapped`,
  SHIFT_DETAILS_ASSUMED_JOURNEY_STATE_INSIDE_GEOFENCE: `${appV2EventPrefix} Shift Details Assumed Journey State Inside Geofence`,
  SHIFT_DETAILS_ASSUMED_JOURNEY_STATE_UNKNOWN: `${appV2EventPrefix} Shift Details Assumed Journey State Unknown`,
  SHIFT_DETAILS_PAGE_VIEWED: `${appV2EventPrefix} Shift Details Page Viewed`,
  SHIFT_DETAILS_WORKPLACE_CARD_TAPPED: `${appV2EventPrefix} Shift Details Workplace Card Tapped`,
  SHIFT_DETAILS_BACK_BUTTON_TAPPED: `${appV2EventPrefix} Shift Details Back Button Tapped`,
  SHIFT_DETAILS_OPTIONS_BUTTON_TAPPED: `${appV2EventPrefix} Shift Details Options Button Tapped`,
  SHIFT_DETAILS_GET_DIRECTIONS_TAPPED: `${appV2EventPrefix} Shift Details Get Directions Tapped`,
  SHIFT_DETAILS_SCORING_WINDOW_DONT_SHOW_THRESHOLD: `${appV2EventPrefix} Shift Details Scoring window, don't show threshold`,
  SHIFT_DETAILS_LOCATION_TRACKING_FAILED_PAGE_VIEWED: `${appV2EventPrefix} Shift Details Location Tracking Failed Page Viewed`,
  SHIFT_DETAILS_LOCATION_VERIFICATION_CONNECTED: `${appV2EventPrefix} Shift Details Location Verification Connected`,
  SHIFT_DETAILS_LOCATION_VERIFICATION_FAILED: `${appV2EventPrefix} Shift Details Location Verification Failed`,
  SHIFT_DETAILS_ALREADY_STARTED_WORKING_TAPPED: `${appV2EventPrefix} Shift Details Already Started Working Tapped`,
  ALREADY_STARTED_WORKING_TIME_PICKER_OPENED: `${appV2EventPrefix} Already Started Working Time Picker Opened`,
  ALREADY_STARTED_WORKING_TIME_SELECTED: `${appV2EventPrefix} Already Started Working Time Selected`,
  ALREADY_STARTED_WORKING_REASON_SUBMITTED: `${appV2EventPrefix} Already Started Working Reason Submitted`,
  ALREADY_STARTED_WORKING_CANCELLED: `${appV2EventPrefix} Already Started Working Cancelled`,
  ALREADY_STARTED_WORKING_VALIDATION_ERROR: `${appV2EventPrefix} Already Started Working Validation Error`,
  ALREADY_STARTED_WORKING_BUTTON_TAPPED: `${appV2EventPrefix} Already Started Working Button Tapped`,

  // My Bookings
  MY_BOOKINGS_CANCELLATION_PENALTY_FOOTER_VIEWED: `${appV2EventPrefix} My Bookings Cancellation Penalty Footer Viewed`,

  // Timekeeping
  TIMEKEEPING_CLOCK_OUT_TAPPED: `${appV2EventPrefix} Timekeeping Clock Out Tapped`,
  TIMEKEEPING_START_BREAK_TAPPED: `${appV2EventPrefix} Timekeeping Start Break Tapped`,
  TIMEKEEPING_END_BREAK_TAPPED: `${appV2EventPrefix} Timekeeping End Break Tapped`,
  TIMEKEEPING_SKIP_BREAK_TAPPED: `${appV2EventPrefix} Timekeeping Skip Break Tapped`,
  TIMEKEEPING_PAGE_VIEWED: `${appV2EventPrefix} Timekeeping Page Viewed`,
  TIMEKEEPING_FOCUS_SUBPAGE_VIEWED: `${appV2EventPrefix} Timekeeping Focus Subpage Viewed`,
  TIMEKEEPING_DETAILS_SUBPAGE_VIEWED: `${appV2EventPrefix} Timekeeping Details Subpage Viewed`,
  TIMEKEEPING_OPTIONS_OPENED: `${appV2EventPrefix} Timekeeping Options Opened`,
  TIMEKEEPING_OPTIONS_CLOCK_OUT_TAPPED: `${appV2EventPrefix} Timekeeping Options Clock Out Tapped`,
  TIMEKEEPING_OPTIONS_SENT_HOME_TAPPED: `${appV2EventPrefix} Timekeeping Options Sent Home Tapped`,
  TIMEKEEPING_OPTIONS_CHAT_WITH_SUPPORT_TAPPED: `${appV2EventPrefix} Timekeeping Options Chat With Support Tapped`,
  TIMEKEEPING_OPTIONS_CHAT_WITH_WORKPLACE_TAPPED: `${appV2EventPrefix} Timekeeping Options Chat With Workplace Tapped`,
  TIMEKEEPING_AUTO_CLOCK_OUT_WARNING_SHOWN: `${appV2EventPrefix} Timekeeping Auto Clock Out Warning Shown`,
  TIMEKEEPING_AUTO_CLOCK_OUT_WARNING_CLOCK_OUT_TAPPED: `${appV2EventPrefix} Timekeeping Auto Clock Out Warning Clock Out Tapped`,
  TIMEKEEPING_WORKPLACE_CARD_TAPPED: `${appV2EventPrefix} Timekeeping Workplace Card Tapped`,
  TIMEKEEPING_BACK_BUTTON_TAPPED: `${appV2EventPrefix} Timekeeping Back Button Tapped`,
  TIMEKEEPING_ACTION_COMPLETED: `${appV2EventPrefix} Timekeeping Action Completed`,
  TIMEKEEPING_ACTION_FAILED: `${appV2EventPrefix} Timekeeping Action Failed`,
  TIMEKEEPING_EDIT_CLOCK_IN_TAPPED: `${appV2EventPrefix} Timekeeping Edit Clock In Tapped`,

  // Timekeeping Integration Retry
  TIMEKEEPING_INTEGRATION_RETRY_ATTEMPT: `${appV2EventPrefix} Timekeeping Integration Retry Attempt`,
  TIMEKEEPING_INTEGRATION_RETRY_EXHAUSTED: `${appV2EventPrefix} Timekeeping Integration Retry Exhausted`,
  TIMEKEEPING_INTEGRATION_RETRY_TIMEOUT: `${appV2EventPrefix} Timekeeping Integration Retry Timeout`,
  TIMEKEEPING_INTEGRATION_RETRY_CANCELLED: `${appV2EventPrefix} Timekeeping Integration Retry Cancelled`,

  // Timekeeping Network Retry
  TIMEKEEPING_NETWORK_RETRY_ATTEMPT: `${appV2EventPrefix} Timekeeping Network Retry Attempt`,
  TIMEKEEPING_NETWORK_RETRY_EXHAUSTED: `${appV2EventPrefix} Timekeeping Network Retry Exhausted`,

  // Create Sent Home Request
  SENT_HOME_REQUEST_OPTIONS_OPENED: `${appV2EventPrefix} Sent Home Request Options Opened`,
  SENT_HOME_REQUEST_OPTIONS_CHAT_WITH_SUPPORT_TAPPED: `${appV2EventPrefix} Sent Home Request Options Chat With Support Tapped`,

  // Shift History
  SHIFT_HISTORY_PAGE_VIEWED: `${appV2EventPrefix} Shift History Page Viewed`,
  SHIFT_HISTORY_CHAT_WITH_SUPPORT_TAPPED: `${appV2EventPrefix} Shift History Chat With Support Tapped`,
  SHIFT_HISTORY_UPLOAD_TIMESHEET_TAPPED: `${appV2EventPrefix} Shift History Upload Timesheet Tapped`,
  SHIFT_HISTORY_UPLOAD_TIMESHEET_STARTED: `${appV2EventPrefix} Shift History Upload Timesheet Started`,
  SHIFT_HISTORY_UPLOAD_TIMESHEET_UPLOADED: `${appV2EventPrefix} Shift History Upload Timesheet Finished`,
  SHIFT_HISTORY_UPLOAD_TIMESHEET_UPLOAD_ERROR: `${appV2EventPrefix} Shift History Upload Timesheet Error`,
  SHIFT_HISTORY_VIEW_EARNINGS_TAPPED: `${appV2EventPrefix} Shift History View Earnings Tapped`,

  // Past Shift Details
  PAST_SHIFT_DETAILS_PAGE_VIEWED: `${appV2EventPrefix} Past Shift Details Page Viewed`,
  PAST_SHIFT_DETAILS_CHAT_WITH_SUPPORT_TAPPED: `${appV2EventPrefix} Past Shift Details Chat With Support Tapped`,
  PAST_SHIFT_DETAILS_ACTION_TAPPED: `${appV2EventPrefix} Past Shift Details Action Tapped`,
  PAST_SHIFT_DETAILS_UPLOAD_TIMESHEET_STARTED: `${appV2EventPrefix} Past Shift Details Upload Timesheet Started`,
  PAST_SHIFT_DETAILS_UPLOAD_TIMESHEET_UPLOADED: `${appV2EventPrefix} Past Shift Details Upload Timesheet Uploaded`,
  PAST_SHIFT_DETAILS_UPLOAD_TIMESHEET_UPLOAD_ERROR: `${appV2EventPrefix} Past Shift Details Upload Timesheet Upload Error`,
  PAST_SHIFT_DETAILS_WORKPLACE_CARD_TAPPED: `${appV2EventPrefix} Past Shift Details Workplace Card Tapped`,

  // Guided Support
  GUIDED_SUPPORT_PAGE_VIEWED: `${appV2EventPrefix} Guided Support Page Viewed`,
  GUIDED_SUPPORT_SHIFT_SELECTED: `${appV2EventPrefix} Guided Support Shift Selected`,
  GUIDED_SUPPORT_TAB_CHANGED: `${appV2EventPrefix} Guided Support Tab Changed`,
  GUIDED_SUPPORT_SHIFT_DETAILS_VIEWED: `${appV2EventPrefix} Guided Support Shift Details Viewed`,
  GUIDED_SUPPORT_REPORT_ISSUE_TAPPED: `${appV2EventPrefix} Guided Support Report Issue Tapped`,
  GUIDED_SUPPORT_SOMETHING_ELSE_TAPPED: `${appV2EventPrefix} Guided Support Something Else Tapped`,
  GUIDED_SUPPORT_ERROR: `${appV2EventPrefix} Guided Support Error`,
  GUIDED_SUPPORT_PAYMENT_STATUS_UNKNOWN: `${appV2EventPrefix} Guided Support Payment Status Unknown`,
  GUIDED_SUPPORT_ATTENDANCE_CONFIRMATION_VIEWED: `${appV2EventPrefix} Guided Support Attendance Confirmation Viewed`,
  GUIDED_SUPPORT_ATTENDANCE_CONFIRMED: `${appV2EventPrefix} Guided Support Attendance Confirmed`,
  GUIDED_SUPPORT_ATTENDANCE_DECLINED: `${appV2EventPrefix} Guided Support Attendance Declined`,
  GUIDED_SUPPORT_CANCELLATION_POLICY_VIEWED: `${appV2EventPrefix} Guided Support Cancellation Policy Viewed`,
  GUIDED_SUPPORT_CONTINUE_TO_CANCEL_TAPPED: `${appV2EventPrefix} Guided Support Continue To Cancel Tapped`,

  // Shift Verification Request
  SHIFT_VERIFICATION_REQUEST_PAGE_VIEWED: `${appV2EventPrefix} Shift Verification Request Page Viewed`,

  // Clock In Flow
  CLOCK_IN_MODAL_OPENED: `${appV2EventPrefix} Clock In Modal Opened`,
  CLOCK_IN_MODAL_CLOSED: `${appV2EventPrefix} Clock In Modal Closed`,
  CLOCK_IN_BREAK_POLICY_ACKNOWLEDGED: `${appV2EventPrefix} Clock In Break Policy Acknowledged`,
  CLOCK_IN_WORKPLACE_RULES_ACKNOWLEDGED: `${appV2EventPrefix} Clock In Workplace Rules Acknowledged`,
  CLOCK_IN_CHARTING_REMINDER_ACKNOWLEDGED: `${appV2EventPrefix} Clock In Charting Reminder Acknowledged`,
  CLOCK_IN_SUCCESS: `${appV2EventPrefix} Clock In Success`,
  CLOCK_IN_TOO_EARLY: `${appV2EventPrefix} Clock In Too Early`,
  CLOCK_IN_OUTSIDE_GEOFENCE: `${appV2EventPrefix} Clock In Outside Geofence`,
  CLOCK_OUT_OUTSIDE_GEOFENCE: `${appV2EventPrefix} Clock Out Outside Geofence`,

  // Clock Out Flow
  CLOCK_OUT_MODAL_OPENED: `${appV2EventPrefix} Clock Out Modal Opened`,
  CLOCK_OUT_MODAL_CLOSED: `${appV2EventPrefix} Clock Out Modal Closed`,
  CLOCK_OUT_SUCCESS: `${appV2EventPrefix} Clock Out Success`,
  CLOCK_OUT_CONFIRM_CONTINUE_TAPPED: `${appV2EventPrefix} Clock Out Confirm Continue Tapped`,

  // Timesheet Submission
  TIMESHEET_SUBMISSION_PAGE_VIEWED: `${appV2EventPrefix} Timesheet Submission Page Viewed`,
  TIMESHEET_EDIT_CLOCK_IN_TAPPED: `${appV2EventPrefix} Timesheet Edit Clock In Tapped`,
  TIMESHEET_EDIT_CLOCK_OUT_TAPPED: `${appV2EventPrefix} Timesheet Edit Clock Out Tapped`,
  TIMESHEET_EDIT_BREAK_TAPPED: `${appV2EventPrefix} Timesheet Edit Break Tapped`,
  TIMESHEET_SUBMITTED: `${appV2EventPrefix} Timesheet Submitted`,
  TIMESHEET_SUBMISSION_FAILED: `${appV2EventPrefix} Timesheet Submission Failed`,
  TIMESHEET_FORM_VALIDATION_ERROR: `${appV2EventPrefix} Timesheet Form Validation Error`,
  TIMESHEET_SUBMISSION_ATTENDANCE_SCORE_MODAL_OPENED: `${appV2EventPrefix} Timesheet Submission Attendance Score Modal Opened`,
  TIMESHEET_SUBMISSION_POST_SHIFT_REVIEW_MODAL_OPENED: `${appV2EventPrefix} Timesheet Submission Post Shift Review Modal Opened`,
  TIMESHEET_SUBMISSION_INSTANT_PAY_EARNINGS_NOT_AVAILABLE: `${appV2EventPrefix} Timesheet Submission Instant Pay Earnings Not Available`,

  // Paper Timesheet Submission
  PAPER_TIMESHEET_UPLOAD_STARTED: `${appV2EventPrefix} Paper Timesheet Upload Started`,
  PAPER_TIMESHEET_UPLOADED: `${appV2EventPrefix} Paper Timesheet Uploaded`,
  PAPER_TIMESHEET_UPLOAD_ERROR: `${appV2EventPrefix} Paper Timesheet Upload Error`,

  // Shift Actions
  INSTANT_BOOKED_SHIFT: `${appV2EventPrefix} Instant Booked Shift`,
  MARKED_INTEREST_SHIFT: `${appV2EventPrefix} Marked Interest Shift`,
  UNDO_BOOKING: `${appV2EventPrefix} Undo Booking`,
  SHIFT_CONFIRM_BOOKING_SHEET_VIEWED: `${appV2EventPrefix} Shift Confirm Booking Sheet Viewed`,

  // Shift booking document submission flows
  SHIFT_BOOKING_FLOW_DOCUMENT_SUBMISSION_REVIEW_CTA_CLICKED: `${appV2EventPrefix} Shift documents flow document submission review cta clicked`,
  SHIFT_BOOKING_FLOW_DOCUMENT_SUBMISSION_SUCCESSFUL: `${appV2EventPrefix} Shift documents flow document submission successful`,
  SHIFT_BOOKING_FLOW_DOCUMENT_SUBMISSION_FAILED: `${appV2EventPrefix} Shift documents flow document submission failed`,

  // Worker Availability
  AVAILABILITY_CALENDAR_VIEWED: `${appV2EventPrefix} Availability Calendar Viewed`,

  // Reviews
  WORKPLACE_REVIEWS_RATING_SUBMITTED: `${appV2EventPrefix} Workplace Reviews Rating Submitted`,
  WORKPLACE_REVIEWS_RATING_UPDATED: `${appV2EventPrefix} Workplace Reviews Rating Updated`,
  WORKPLACE_REVIEWS_REVIEW_SUBMITTED: `${appV2EventPrefix} Workplace Reviews Review Submitted`,
  WORKPLACE_REVIEWS_REVIEW_REJECTED_OFFENSIVE_WORDS: `${appV2EventPrefix} Workplace Reviews Review Rejected Offensive Words`,
  WORKPLACE_REVIEWS_SCREEN_OPENED: `${appV2EventPrefix} Workplace Reviews Screen Opened`,
  WORKPLACE_REVIEWS_SCREEN_CLOSED: `${appV2EventPrefix} Workplace Reviews Screen Closed`,
  WORKPLACE_REVIEWS_OPENED_FROM_FEEDBACK_MODAL: `${appV2EventPrefix} Workplace Reviews Screen Opened From Feedback Modal`,
  WORKPLACE_REVIEWS_INLINE_REPLIES_TOGGLED: `${appV2EventPrefix} Workplace Reviews Inline Replies Toggled`,
  WORKPLACE_REVIEWS_VIDEO_PLAYED: `${appV2EventPrefix} Workplace Reviews Video Played`,
  WORKPLACE_REVIEWS_VIDEO_COMPLETED: `${appV2EventPrefix} Workplace Reviews Video Completed`,
  WORKPLACE_REVIEWS_REPLY_SUBMITTED: `${appV2EventPrefix} Workplace Reviews Reply Submitted`,
  DELAYED_WORKPLACE_REVIEW_MODAL_OPENED: `${appV2EventPrefix} Delayed Workplace Review Modal Opened`,
  DELAYED_WORKPLACE_REVIEW_SKIPPED: `${appV2EventPrefix} Delayed Workplace Review Skipped`,
  WORKPLACE_REVIEWS_SEARCHED: `${appV2EventPrefix} Workplace Reviews Searched`,

  // Refer and earn intermediate screen
  REFER_AND_EARN: `${appV2EventPrefix} Refer and Earn`,

  // Workplace referral events
  WORKPLACE_REFERRAL: `${appV2EventPrefix} Workplace Referral`,
  WORKPLACE_REFERRAL_STATS: `${appV2EventPrefix} Workplace Referral Stats`,

  // Support
  OPENED_SUPPORT_ARTICLE: `${appV2EventPrefix} Opened Support Article`,
  ENTERED_SUPPORT_FLOW_VIA_CHAT: `${appV2EventPrefix} Entered Support Flow Via Chat`,

  // Worker to Worker Referrals events
  VIEWED_WORKER_TO_WORKER_REFERRAL_SCREEN: `${appV2EventPrefix} Viewed worker to worker referral screen`,
  SHARED_CODE_FROM_WORKER_TO_WORKER_REFERRAL_SCREEN: `${appV2EventPrefix} Shared code from worker to worker referral screen`,
  VISITED_ENTER_REFERRAL_CODE_FROM_WORKER_TO_WORKER_REFERRAL_SCREEN: `${appV2EventPrefix} Visited enter referral code screen from worker to worker referral screen`,
  CLICKED_ON_WORKER_TO_WORKER_REFERRAL_BANNER: `${appV2EventPrefix} Clicked on worker to worker referral banner`,
  VIEWED_REFERRAL_REDEEM_PAGE: `${appV2EventPrefix} Viewed referral redeem page`,
  REFERRAL_REDEEM_BROWSE_SHIFTS_CLICKED: `${appV2EventPrefix} Referral redeem browse shifts clicked`,
  REFERRAL_REDEEM_FAQ_CLICKED: `${appV2EventPrefix} Referral redeem FAQ clicked`,
  REFERRAL_SUCCESS_MODAL_CONTINUE_CLICKED: `${appV2EventPrefix} Referral success modal continue clicked`,
  REFERRAL_SUCCESS_BROWSE_SHIFTS_CLICKED: `${appV2EventPrefix} Referral success browse shifts clicked`,
  REFERRAL_SUCCESS_FAQ_CLICKED: `${appV2EventPrefix} Referral success FAQ clicked`,
  REFERRAL_SHARE_LINK_CLICKED: `${appV2EventPrefix} Referral share link clicked`,
  REFERRAL_SHARE_LINK_PAGE_VIEWED: `${appV2EventPrefix} Referral share link page viewed`,
  REFERRAL_LINK_REDEEMED: `${appV2EventPrefix} Referral link redeemed`,
  PLACEMENT_PAGE_REFER_FRIEND_CLICKED: `${appV2EventPrefix} Placement page refer friend clicked`,
  VIEWED_MY_REFERRALS_TAB: `${appV2EventPrefix} Viewed my referrals tab`,
  ACTIVE_REFERRAL_BANNER_CLICKED: `${appV2EventPrefix} Active referral banner clicked`,
  VIEWED_MY_REFERRALS_TAB_UNKNOWN_STATUS: `${appV2EventPrefix} Viewed my referrals tab unknown status`,
  OPENED_MY_REFERRALS_FAQ: `${appV2EventPrefix} Opened my referrals FAQ`,

  UPDATE_ETA_BOTTOM_SHEET_NUDGE_VIEWED: `${appV2EventPrefix} Update ETA Bottom Sheet Nudge Viewed`,

  // My Shifts
  SUBMITTED_ETA_MODAL: `${appV2EventPrefix} Submitted ETA modal`,
  VIEWED_FACILITY_PROFILE: `${appV2EventPrefix} Facility Profile Viewed`,
  SHIFT_CARD_FACILITY_PROFILE_CLICKED: `${appV2EventPrefix} Shift card facility profile clicked`,
  SHIFT_CARD_CLICKED: `${appV2EventPrefix} MyShifts shift card clicked`,
  UNVERIFIED_SHIFTS_CARD_CLICKED: `${appV2EventPrefix} MyShifts unverified shifts card clicked`,
  SHIFT_CARD_CHAT_BUTTON_CLICKED: `${appV2EventPrefix} Shift card facility chat button clicked`,
  MESSAGES_ICON_CLICKED: `${appV2EventPrefix} Messages icon clicked`,
  PENDING_SENT_HOME_REQUESTS_CARD_CLICKED: `${appV2EventPrefix} MyShifts pending sent home requests card clicked`,
  NEW_SIGNING_FLOW_WITH_FEEDBACK_MODAL_OPENED: `${appV2EventPrefix} New signing flow with feedback modal opened`,

  // Booking Requests
  BOOKING_REQUEST_CANCELED: `${appV2EventPrefix} Booking request canceled`,

  // News Feed
  NEWS_FEED_CARD_CLICKED: `${appV2EventPrefix} News Feed content card clicked`,
  NEWS_FEED_CARD_LINK_CLICKED: `${appV2EventPrefix} News Feed content card link clicked`,
  NEWS_FEED_PAGE_VIEWED: `${appV2EventPrefix} News Feed page viewed`,
  NEWS_FEED_ITEM_OPENED: `${appV2EventPrefix} News Feed item opened`,
  NEWS_FEED_REACTION_ADDED: `${appV2EventPrefix} News Feed reaction added`,
  NEWS_FEED_COMMENT_ADDED: `${appV2EventPrefix} News Feed comment added`,
  NEWS_FEED_BOTTOM_REACHED: `${appV2EventPrefix} News Feed reached bottom of feed`,

  // Documents
  UPLOAD_DOCUMENT_SUCCESS: `${appV2EventPrefix} Successfully uploaded document`,
  UPLOAD_DOCUMENT_FAILURE: `${appV2EventPrefix} Failed to upload document`,
  DOCUMENT_DETAILS_SCREEN_VIEWED: `${appV2EventPrefix} Document Details Screen Viewed`,
  VIEWED_DOCUMENTS: `${appV2EventPrefix} Documents Viewed`,
  VIEWED_WORKPLACE_DOCUMENTS: `${appV2EventPrefix} Workplace Documents Viewed`,
  MISSING_DOCUMENTS_ALERT_UPLOAD_BUTTON_CLICKED: `${appV2EventPrefix} Missing documents alert upload button clicked`,
  MISSING_DOCUMENTS_NOTIFY_SUPPORT_BUTTON_CLICKED: `${appV2EventPrefix} Missing documents alert notify support button clicked`,
  DOCUMENTS_PAGE_MORE_INFO_ICON_CLICKED: `${appV2EventPrefix} Documents page more info icon clicked`,

  // Document Search
  DOCUMENT_SEARCH_VIEWED: `${appV2EventPrefix} Document Search Viewed`,
  DOCUMENT_SEARCH_ERROR_VIEWED: `${appV2EventPrefix} Document Search Error Viewed`,
  DOCUMENT_SEARCH_RESULT_CLICKED: `${appV2EventPrefix} Document Search Result Clicked`,
  DOCUMENT_SEARCH_NOT_FOUND_VIEWED: `${appV2EventPrefix} Document Search Not Found Viewed`,
  DOCUMENT_SEARCH_NOT_FOUND_ADD_DOCUMENT_CLICKED: `${appV2EventPrefix} Document Search Not Found Add Document Clicked`,
  DOCUMENT_SEARCH_RESULTS_DISPLAYED: `${appV2EventPrefix} Document Search Results Displayed`,

  // BLS/CPR and TB Test Improvements
  VIEWED_IMPROVED_BLS_CPR_PAGE: `${appV2EventPrefix} Viewed improved BLS/CPR page`,
  VIEWED_IMPROVED_TB_TEST_PAGE: `${appV2EventPrefix} Viewed improved TB test page`,
  CLICKED_CTA_ON_IMPROVED_BLS_CPR_BUTTON: `${appV2EventPrefix} Clicked CTA on improved BLS/CPR button`,
  CLICKED_CTA_ON_IMPROVED_TB_TEST_BUTTON: `${appV2EventPrefix} Clicked CTA on improved TB test button`,

  // Documents upload flow
  DOCUMENTS_UPLOAD_FLOW_VIEWED_MISSING_DOCUMENTS_ALERT: `${appV2EventPrefix} Documents upload flow viewed missing docs alert`,
  DOCUMENTS_UPLOAD_FLOW_MISSING_DOCUMENTS_ALERT_CLICKED_VIEW_DOCUMENTS: `${appV2EventPrefix} Documents upload flow missing docs alert clicked view documents`,
  DOCUMENTS_UPLOAD_FLOW_DOCUMENTS_PAGE_VIEWED: `${appV2EventPrefix} Documents upload flow documents page viewed`,
  DOCUMENTS_UPLOAD_FLOW_DOCUMENTS_PAGE_REQUIREMENT_CLICKED: `${appV2EventPrefix} Documents upload flow documents page requirement clicked`,
  DOCUMENTS_UPLOAD_FLOW_DOCUMENTS_DETAILS_PAGE_VIEWED: `${appV2EventPrefix} Documents upload flow documents details page viewed`,
  DOCUMENTS_UPLOAD_FLOW_DOCUMENT_DETAILS_CTA_CLICKED: `${appV2EventPrefix} Documents upload flow document details cta clicked`,
  DOCUMENTS_UPLOAD_FLOW_DOCUMENT_DETAILS_SUBMISSION_FINISHED: `${appV2EventPrefix} Documents upload flow document details upload finished`,

  // Notifications
  NOTIFICATION_CENTER_ICON_VIEWED: `${appV2EventPrefix} Notification center icon viewed`,
  NOTIFICATION_CENTER_VIEWED: `${appV2EventPrefix} Notification center viewed`,

  // Urgent Shifts
  TAPPED_URGENT_SHIFTS_BANNER: `${appV2EventPrefix} Tapped Urgent Shifts Banner`,

  // Hot shifts
  HOT_SHIFT_ICON_TAPPED: `${appV2EventPrefix} Hot Shift Icon Tapped`,

  // Shift bookability
  TAPPED_CONTACT_SUPPORT_FOR_UNDETERMINED_BOOKABILITY_STATUS: `${appV2EventPrefix} Tapped Contact Support For Undetermined Bookability Status`,
  TAPPED_SHIFT_UNAVAILABLE_FOR_BLOCKED_BOOKABILITY_STATUS: `${appV2EventPrefix} Tapped Shift Unavailable For Blocked Bookability Status`,
  TAPPED_BUTTON_FOR_BLOCKED_BOOKABILITY_STATUS: `${appV2EventPrefix} Tapped Button For Blocked Bookability Status`,
  TAPPED_BUTTON_FOR_ALLOWED_BOOKABILITY_STATUS: `${appV2EventPrefix} Tapped Button For Allowed Bookability Status`,
  VIEWED_MISSING_DOCUMENTS_ALERT: `${appV2EventPrefix} Viewed missing documents alert`,
  VIEWED_UNDETERMINED_SHIFT_BUTTON: `${appV2EventPrefix} Viewed undetermined shift button`,
  VIEWED_CANT_BOOK_SHIFT_CTA: `${appV2EventPrefix} Viewed can't book shift button`,
  UNMET_CRITERIA_WITHOUT_A_CARD: `${appV2EventPrefix} Unmet criteria without a card`,
  TAPPED_VIEW_BOOKINGS_FROM_BOOKABILITY_CARD: `${appV2EventPrefix} Tapped view bookings from bookability card`,

  // Onboarding
  ONBOARDING_ERROR: `${appV2EventPrefix} Self-Onboarding Error Occurred`,
  STARTED_STRIPE_SETUP: `${appV2EventPrefix} Started Stripe Setup`,
  VIEWED_STRIPE_SETUP: `${appV2EventPrefix} Viewed Stripe Setup`,
  ENTERED_APP: `${appV2EventPrefix} App Entered`,
  ONBOARDING_RESUMED_FROM_LAST_STEP: `${appV2EventPrefix} Onboarding resumed from last step`,
  ONBOARDING_ADD_ROLES_PAGE_VIEWED: `${appV2EventPrefix} Onboarding add roles page viewed`,
  ONBOARDING_PERSONAL_ID_ABANDONED_SUBTYPE_SELECT: `${appV2EventPrefix} Onboarding Personal ID Abandoned Subtype Select`,
  ONBOARDING_PERSONAL_ID_ABANDONED_VERIFICATION: `${appV2EventPrefix} Onboarding Personal ID Abandoned Verification`,
  ONBOARDING_PERSONAL_ID_NOT_REQUIRED_CONTINUE_CLICKED: `${appV2EventPrefix} Onboarding Personal ID Not Required Continue Clicked`,
  ONBOARDING_HOME_ADDRESS_BUTTON_TAPPED: `${appV2EventPrefix} Onboarding home address button tapped`,
  ONBOARDING_MIDDLE_NAME_ENTERED: `${appV2EventPrefix} Onboarding middle name entered`,
  ONBOARDING_NO_MIDDLE_NAME_CONFIRMATION_CHECKED: `${appV2EventPrefix} Onboarding no middle name confirmation checked`,
  ONBOARDING_INTERESTED_WORK_TYPE_PAGE_VIEWED: `${appV2EventPrefix} Onboarding interested work type page viewed`,
  ASK_INTERESTED_WORK_TYPE_ERROR: `${appV2EventPrefix} Error asking interested work type`,
  ONBOARDING_INTERESTED_WORK_TYPE_SELECTED: `${appV2EventPrefix} Onboarding interested work type selected`,
  ONBOARDING_AGREEMENT_EXPLANATION_PAGE_VIEWED: `${appV2EventPrefix} Onboarding agreement explanation page viewed`,
  ONBOARDING_JOB_SEARCH_AGREEMENT_STEP_VIEWED: `${appV2EventPrefix} Onboarding job search agreement step viewed`,
  ONBOARDING_JOB_SEARCH_AGREEMENT_SIGNED: `${appV2EventPrefix} Onboarding job search agreement signed`,
  ONBOARDING_IC_AGREEMENT_STEP_VIEWED: `${appV2EventPrefix} Onboarding ic agreement step viewed`,
  ONBOARDING_IC_AGREEMENT_SIGNED: `${appV2EventPrefix} Onboarding ic agreement signed`,
  ONBOARDING_STEP_STARTED: `${appV2EventPrefix} Onboarding step started`,
  ONBOARDING_STEP_COMPLETED: `${appV2EventPrefix} Onboarding step completed`,
  ONBOARDING_HOME_ADDRESS_LOCATION_PERMISSION_RESULT: `${appV2EventPrefix} Onboarding home address location permission result`,
  ONBOARDING_HOME_ADDRESS_LOCATION_PERMISSION_RESULT_ERROR: `${appV2EventPrefix} Onboarding home address location permission result error`,
  WELCOME_PAGE_VIEWED: `${appV2EventPrefix} Welcome page viewed`,
  ONBOARDING_HOME_ADDRESS_CHECK_LOCATION_PERMISSION: `${appV2EventPrefix} Onboarding home address check location permission`,
  ONBOARDING_HOME_ADDRESS_ASK_LOCATION_PERMISSION: `${appV2EventPrefix} Onboarding home address ask location permission`,
  ONBOARDING_IDP_SELECTED: `${appV2EventPrefix} Onboarding IDP selected`,
  ONBOARDING_SHIFTS_EDUCATION_PAGE_VIEWED: `${appV2EventPrefix} Onboarding shifts education page viewed`,
  ONBOARDING_JOBS_EDUCATION_PAGE_VIEWED: `${appV2EventPrefix} Onboarding jobs education page viewed`,
  UNFAMILIAR_SHIFTS_EDUCATION_VIEWED: `${appV2EventPrefix} Unfamiliar shifts education viewed`,
  UNFAMILIAR_JOBS_EDUCATION_VIEWED: `${appV2EventPrefix} Unfamiliar jobs education viewed`,

  // Mandatory break policy
  MANDATORY_BREAK_POLICY_VIEWED: `${appV2EventPrefix} Mandatory break policy dialog viewed`,
  MANDATORY_BREAK_POLICY_CANCELLED: `${appV2EventPrefix} Mandatory break policy dialog cancelled`,
  MANDATORY_BREAK_POLICY_ACCEPTED: `${appV2EventPrefix} Mandatory break policy dialog accepted`,

  // WorkplaceQuiz
  VIEWED_QUIZ_PASSED_DIALOG: `${appV2EventPrefix} Viewed quiz passed dialog`,
  VIEWED_QUIZ_FAILED_DIALOG: `${appV2EventPrefix} Viewed quiz failed dialog`,
  TAPPED_BUTTON_FOR_BOOK_SHIFT_ON_QUIZ_PASSED_WITH_SHIFT_DIALOG: `${appV2EventPrefix} Tapped button for book shift on quiz passed with shift dialog`,
  TAPPED_BUTTON_FOR_CANCEL_ON_QUIZ_PASSED_WITH_SHIFT_DIALOG: `${appV2EventPrefix} Tapped button for cancel on quiz passed with shift dialog`,
  TAPPED_BUTTON_FOR_RETAKE_QUIZ_ON_QUIZ_FAILED_DIALOG: `${appV2EventPrefix} Tapped button for retake quiz on quiz failed dialog`,
  TAPPED_BUTTON_FOR_CANCEL_ON_QUIZ_FAILED_DIALOG: `${appV2EventPrefix} Tapped button for cancel on quiz failed dialog`,
  VIEWED_QUIZ_REQUIREMENT_DIALOG: `${appV2EventPrefix} Viewed quiz requirement dialog`,
  TAPPED_BUTTON_FOR_CONTINUE_ON_QUIZ_REQUIREMENT_DIALOG: `${appV2EventPrefix} Tapped button for continue on quiz requirement dialog`,
  VIEWED_WORKPLACE_RULES_PAGE: `${appV2EventPrefix} Viewed workplace rules page`,
  CLOSED_WORKPLACE_RULES_PAGE: `${appV2EventPrefix} Closed workplace rules page`,
  VIEWED_WORKPLACE_QUIZ_PAGE: `${appV2EventPrefix} Viewed workplace quiz page`,
  CLOSED_WORKPLACE_QUIZ_PAGE: `${appV2EventPrefix} Closed workplace quiz page`,

  // Skills Assessment
  SKILLS_ASSESSMENT_MY_ACCOUNT_BANNER_CLICKED: `${appV2EventPrefix} Skills assessment my account banner clicked`,
  SKILLS_ASSESSMENT_MY_ACCOUNT_PAGE_VIEWED: `${appV2EventPrefix} Skills assessment page viewed in my account`,
  SKILLS_ASSESSMENT_ONBOARDING_PAGE_VIEWED: `${appV2EventPrefix} Skills assessment page viewed during onboarding`,
  SKILLS_ASSESSMENT_SCHEDULED_ONBOARDING_INSTRUCTIONS_PAGE_VIEWED: `${appV2EventPrefix} Skills assessment instructions page viewed during onboarding for scheduled assessment`,
  SKILLS_ASSESSMENT_SCHEDULED_ONBOARDING_PAGE_VIEWED: `${appV2EventPrefix} Skills assessment page viewed during onboarding for scheduled assessment`,
  SKILLS_ASSESSMENT_SCHEDULED_ONBOARDING_SCHEDULE_BUTTON_CLICKED: `${appV2EventPrefix} Skills assessment schedule button clicked during onboarding for scheduled assessment`,
  SKILLS_ASSESSMENT_SCHEDULED_ONBOARDING_INSTRUCTIONS_BUTTON_CLICKED: `${appV2EventPrefix} Skills assessment instructions button clicked during onboarding for scheduled assessment`,
  SKILLS_ASSESSMENT_SCHEDULED_ONBOARDING_CONFIRMATION_PAGE_VIEWED: `${appV2EventPrefix} Skills assessment confirmation page viewed during onboarding for scheduled assessment`,
  SKILLS_ASSESSMENT_SCHEDULED_ONBOARDING_CONFIRMATION_BUTTON_CLICKED: `${appV2EventPrefix} Skills assessment confirmation button clicked during onboarding for scheduled assessment`,
  SKILLS_ASSESSMENT_ONBOARDING_SKIPPED: `${appV2EventPrefix} Skills assessment onboarding skipped`,
  SKILLS_ASSESSMENT_VIDEO_FLOW_VIEWED: `${appV2EventPrefix} Skills assessment video flow viewed`,
  SKILLS_ASSESSMENT_CLICKED_HAVING_ISSUES: `${appV2EventPrefix} Skills assessment clicked having issues`,
  SKILLS_ASSESSMENT_CLICKED_HAVING_ISSUES_CALL_BUTTON: `${appV2EventPrefix} Skills assessment having issues call button`,
  SKILLS_ASSESSMENT_VIDEO_ASK_STARTED: `${appV2EventPrefix} Skills assessment video ask started`,
  SKILLS_ASSESSMENT_VIDEO_ASK_QUESTION_PRESENTED: `${appV2EventPrefix} Skills assessment video ask question presented`,
  SKILLS_ASSESSMENT_VIDEO_ASK_QUESTION_SUBMITTED: `${appV2EventPrefix} Skills assessment video ask question submitted`,
  SKILLS_ASSESSMENT_VIDEO_ASK_SUBMITTED: `${appV2EventPrefix} Skills assessment video ask submitted`,
  SKILLS_ASSESSMENT_STARTED_EVENT: `${appV2EventPrefix} Skills assessment started event`,
  SKILLS_ASSESSMENT_SCHEDULED_EVENT: `${appV2EventPrefix} Skills assessment scheduled event`,
  SKILLS_ASSESSMENT_RESCHEDULED: `${appV2EventPrefix} Skills assessment rescheduled`,
  SKILLS_ASSESSMENT_SUBMITTED_EVENT: `${appV2EventPrefix} Skills assessment submitted event`,
  SKILLS_ASSESSMENT_VIDEO_ASK_EXITED: `${appV2EventPrefix} Skills assessment video ask exited`,
  SKILLS_ASSESSMENT_EVENT_STATUS_VIEWED: `${appV2EventPrefix} Skills assessment event status viewed`,
  SKILLS_ASSESSMENT_REQUIREMENT_DIALOG_VIEWED: `${appV2EventPrefix} Skills assessment requirement dialog viewed during booking`,
  SKILLS_ASSESSMENT_REQUIREMENT_DIALOG_CONTINUE_BUTTON_CLICKED: `${appV2EventPrefix} Skills assessment continue button clicked on requirement dialog during booking`,
  SKILLS_ASSESSMENT_UNDER_REVIEW_DIALOG_VIEWED: `${appV2EventPrefix} Skills assessment under review dialog viewed during booking`,
  SKILLS_ASSESSMENT_FAILED_DIALOG_VIEWED: `${appV2EventPrefix} Skills assessment failed dialog viewed during booking`,
  SKILLS_ASSESSMENT_UNEXPECTED_ERROR_DIALOG_VIEWED: `${appV2EventPrefix} Skills assessment unexpected error dialog viewed during booking`,
  SKILLS_ASSESSMENT_DIALOG_DETAILS_BUTTON_CLICKED: `${appV2EventPrefix} Skills assessment details button clicked during  booking`,
  SKILLS_ASSESSMENT_RECORDING_PERMISSIONS_CHECKED: `${appV2EventPrefix} Skills assessment recording permissions checked`,
  SKILLS_ASSESSMENT_START_TIME_PASSED_DIALOG_CLOSED: `${appV2EventPrefix} Skills assessment start time passed dialog closed`,
  SKILLS_ASSESSMENT_START_TIME_PASSED_DIALOG_START_NOW_CLICKED: `${appV2EventPrefix} Skills assessment start time passed dialog start now clicked`,
  SKILLS_ASSESSMENTS_RESEND_TEXT_CLICKED: `${appV2EventPrefix} Skills assessments resend text clicked`,
  SKILLS_ASSESSMENT_SKIP_ASSESSMENT_ALERT_CONFIRMED: `${appV2EventPrefix} Skills assessment skip assessment alert confirmed`,

  // Clipboard Orientation
  CLIPBOARD_ORIENTATION_MY_ACCOUNT_BANNER_CLICKED: `${appV2EventPrefix} Clipboard orientation my account banner clicked`,
  CLIPBOARD_ORIENTATION_START_TIME_PASSED_ALERT_CTA_CLICKED: `${appV2EventPrefix} Clipboard orientation start time passed alert cta clicked`,
  CLIPBOARD_ORIENTATION_START_TIME_PASSED_ALERT_DISMISSED: `${appV2EventPrefix} Clipboard orientation start time passed alert dismissed`,
  CLIPBOARD_ORIENTATION_FAILURE_ALERT_DISMISSED: `${appV2EventPrefix} Clipboard orientation failure alert dismissed`,

  // Open shifts
  OPEN_SHIFTS_TAB_LAYOUT: `${appV2EventPrefix} Open shifts tab layout`,
  OPENED_SHARED_SHIFT: `${appV2EventPrefix} Opened shared shift`,

  // Shift blocks
  SHIFT_BLOCKS: `${appV2EventPrefix} Shift Blocks`,
  NEGOTIATE_BLOCK_PROPOSAL_SUBMITTED: `${appV2EventPrefix} Negotiate block proposal submitted`,

  // Negotiation
  VIEWED_NEXT_NEGOTIATION_SHIFT_PAGE: `${appV2EventPrefix} Viewed Next Negotiation Shifts Page`,
  RATE_NEGOTIATION_ENABLED_LOGIC_MISMATCH: `${appV2EventPrefix} Rate negotiation enabled logic mismatch`,
  RATE_NEGOTIATION_ENABLED_LOGIC_MATCH: `${appV2EventPrefix} Rate negotiation enabled logic match`,

  // Shift Auction
  SHIFT_AUCTION_PLACE_BID_VIEWED: `${appV2EventPrefix} Shift auction place bid viewed`,
  SHIFT_AUCTION_PLACE_BID_BUTTON_CLICKED: `${appV2EventPrefix} Shift auction place bid button clicked`,
  SHIFT_AUCTION_PLACE_BID_ERROR: `${appV2EventPrefix} Shift auction place bid error`,
  SHIFT_AUCTION_REVIEW_BID_ERROR: `${appV2EventPrefix} Shift auction review bid error`,
  SHIFT_AUCTION_PLACE_BID_NO_AUCTION: `${appV2EventPrefix} Shift auction place bid no auction`,
  SHIFT_AUCTION_REVIEW_BID_NO_AUCTION: `${appV2EventPrefix} Shift auction review bid no auction`,
  SHIFT_AUCTION_INSTANT_BOOK_BUTTON_CLICKED: `${appV2EventPrefix} Shift auction instant book button clicked`,
  SHIFT_AUCTION_INSTANT_BOOK_VIEWED: `${appV2EventPrefix} Shift auction instant book viewed`,
  SHIFT_AUCTION_CONFIRM_INSTANT_BOOK_NO_AUCTION: `${appV2EventPrefix} Shift auction confirm instant book no auction`,

  // Account deletion
  REQUEST_ACCOUNT_DELETION_LOGOUT: `${appV2EventPrefix} Log Out After Request Account Deletion`,
  REQUEST_ACCOUNT_DELETION_CONFIRM: `${appV2EventPrefix} Confirm Request Account Deletion`,
  REQUEST_ACCOUNT_DELETION_SEND_OTP: `${appV2EventPrefix} Request OTP For Account Deletion`,
  REQUEST_ACCOUNT_DELETION_CANCEL_AT_OTP: `${appV2EventPrefix} Cancel Request Account Deletion At OTP`,
  REQUEST_ACCOUNT_DELETION_CANCEL_AT_CONFIRM: `${appV2EventPrefix} Cancel Request Account Deletion At Confirmation`,

  // Agreement
  SIGN_AGREEMENT_VIEWED: `${appV2EventPrefix} Viewed sign agreement page`,
  OPEN_AGREEMENT_SUPPORT_ARTICLE_ERROR: `${appV2EventPrefix} Error opening agreement support article`,
  SEND_AGREEMENT_EMAIL_SUCCESS: `${appV2EventPrefix} Successfully sent agreement email`,
  SEND_JOB_SEARCH_AGREEMENT_EMAIL_SUCCESS: `${appV2EventPrefix} Successfully sent job search agreement email`,

  // Sign new agreement
  SIGN_NEW_AGREEMENT_SEND_OTP: `${appV2EventPrefix} Request OTP for sign new agreement`,
  SIGN_NEW_AGREEMENT_STARTED: `${appV2EventPrefix} Sign new agreement`,
  SIGN_NEW_AGREEMENT_MODAL_DISMISS: `${appV2EventPrefix} Dismissed sign new agreement modal`,
  SIGN_NEW_AGREEMENT_MODAL_CONTINUE: `${appV2EventPrefix} Clicked continue on sign new agreement modal`,

  // Attendance Score
  ATTENDANCE_SCORE_PAGE_OPENED_FROM_FEEDBACK_MODAL: `${appV2EventPrefix} Attendance Score Page Opened From Feedback Modal`,
  SWITCH_ATTENDANCE_SCORE_TABS: `${appV2EventPrefix} Switch Attendance Score Tabs`,

  // Debit Card Expiration Banner
  TAPPED_DEBIT_CARD_ABOUT_TO_EXPIRE_BANNER: `${appV2EventPrefix} Tapped Debit Card About To Expire Banner`,
  TAPPED_DEBIT_CARD_EXPIRED_BANNER: `${appV2EventPrefix} Tapped Debit Card Expired Banner`,

  // Career Agent
  CAREER_AGENT_PAGE_VIEWED: `${appV2EventPrefix} Career Agent Page Viewed`,

  FEEDBACK_ON_HCP_WORK_QUALITY: `${appV2EventPrefix} Work quality feedback`,
  SIGNING_FLOW_V2_SIGNER_NAME_SUBMITTED: `${appV2EventPrefix} Signing flow V2 signer name submitted`,

  // Facility Timeclock Compliance
  FACILITY_TIMECLOCK_COMPLIANCE_EXPERIMENT_EVENT: `${appV2EventPrefix} Facility Timeclock Compliance Experiment Event`,
  FACILITY_TIMECLOCK_COMPLIANCE_EVENT: `${appV2EventPrefix} Facility Timeclock Compliance Event`,

  TOO_FAR_AWAY_PANEL: `${appV2EventPrefix} Too Far Away Shown`,

  // Late Cancel Protection
  VIEWED_LATE_CANCEL_PROTECTION_CARD: `${appV2EventPrefix} Viewed late cancel protection card`,

  // Clipboard Orientation
  CLIPBOARD_ORIENTATION_SCHEDULED_ONBOARDING_PAGE_VIEWED: `${appV2EventPrefix} Clipboard Orientation Scheduled Onboarding Page Viewed`,
  CLIPBOARD_ORIENTATION_SCHEDULED_EVENT: `${appV2EventPrefix} Clipboard Orientation Scheduled Event`,
  CLIPBOARD_ORIENTATION_SKIP_ASSESSMENT_ALERT_CONFIRMED: `${appV2EventPrefix} Clipboard Orientation Skip Assessment Alert Confirmed`,
  CLIPBOARD_ORIENTATION_SCHEDULED_ONBOARDING_SCHEDULE_BUTTON_CLICKED: `${appV2EventPrefix} Clipboard Orientation Scheduled Onboarding Schedule Button Clicked`,
  CLIPBOARD_ORIENTATION_SCHEDULED_ONBOARDING_CONFIRMATION_BUTTON_CLICKED: `${appV2EventPrefix} Clipboard Orientation Scheduled Onboarding Confirmation Button Clicked`,
  CLIPBOARD_ORIENTATION_SCHEDULED_ONBOARDING_CONFIRMATION_PAGE_VIEWED: `${appV2EventPrefix} Clipboard Orientation Scheduled Onboarding Confirmation Page Viewed`,
  CLIPBOARD_ORIENTATION_RESEND_TEXT_CLICKED: `${appV2EventPrefix} Clipboard Orientation Resend Text Clicked`,
  CLIPBOARD_ORIENTATION_REQUIRED_DIALOG_VIEWED: `${appV2EventPrefix} Clipboard orientation required dialog viewed`,
  CLIPBOARD_ORIENTATION_REQUIRED_DIALOG_CONTINUE_BUTTON_CLICKED: `${appV2EventPrefix} Clipboard orientation required dialog continue button clicked`,
  CLIPBOARD_ORIENTATION_LANDING_PAGE_VIEWED: `${appV2EventPrefix} Clipboard orientation landing page viewed`,
  CLIPBOARD_ORIENTATION_RESCHEDULED: `${appV2EventPrefix} Clipboard orientation rescheduled`,
  CLIPBOARD_ORIENTATION_RESCHEDULED_PAGE_VIEWED: `${appV2EventPrefix} Clipboard orientation rescheduled page viewed`,
  CLIPBOARD_ORIENTATION_RESCHEDULED_CONFIRMATION_BUTTON_CLICKED: `${appV2EventPrefix} Clipboard orientation rescheduled confirmation button clicked`,
  CLIPBOARD_ORIENTATION_BEGIN_ASSESSMENT_BUTTON_CLICKED: `${appV2EventPrefix} Clipboard orientation begin assessment button clicked`,
  CLIPBOARD_ORIENTATION_VIDEO_STEP_VIEWED: `${appV2EventPrefix} Clipboard orientation video step viewed`,
  CLIPBOARD_ORIENTATION_VIDEO_PLAY_BUTTON_CLICKED: `${appV2EventPrefix} Clipboard orientation video play button clicked`,
  CLIPBOARD_ORIENTATION_VIDEO_PAUSE_BUTTON_CLICKED: `${appV2EventPrefix} Clipboard orientation video pause button clicked`,
  CLIPBOARD_ORIENTATION_VIDEO_REWIND_BUTTON_CLICKED: `${appV2EventPrefix} Clipboard orientation video rewind button clicked`,
  CLIPBOARD_ORIENTATION_VIDEO_STEP_CONTINUE_BUTTON_CLICKED_BEFORE_VIDEO_COMPLETION: `${appV2EventPrefix} Clipboard orientation video step continue button clicked before video completion`,
  CLIPBOARD_ORIENTATION_VIDEO_STEP_COMPLETED: `${appV2EventPrefix} Clipboard orientation video step completed`,
  CLIPBOARD_ORIENTATION_RECAP_STEP_VIEWED: `${appV2EventPrefix} Clipboard orientation recap step viewed`,
  CLIPBOARD_ORIENTATION_RECAP_STEP_COMPLETED: `${appV2EventPrefix} Clipboard orientation recap step completed`,
  CLIPBOARD_ORIENTATION_QUIZ_STEP_VIEWED: `${appV2EventPrefix} Clipboard orientation quiz step viewed`,
  CLIPBOARD_ORIENTATION_QUIZ_STEP_COMPLETED: `${appV2EventPrefix} Clipboard orientation quiz step completed`,
  CLIPBOARD_ORIENTATION_COMPLETED: `${appV2EventPrefix} Clipboard orientation completed`,

  // In Home
  IN_HOME_BAA_SIGNATURE_SUBMITTED: `${appV2EventPrefix} In Home BAA signature submitted`,
  IN_HOME_BAA_SIGNATURE_FAILURE: `${appV2EventPrefix} In Home BAA signature failed to submit`,
  VISIT_DETAILS_CTA_BOOK_VISIT: `${appV2EventPrefix} Visit Details CTA Book Visit`,
  VISIT_LOCK_BANNER_FIND_OUT_WHY_TAPPED: `${appV2EventPrefix} Visit Lock Banner Find Out Why Tapped`,
  VISIT_LOCK_ACCESS_LOCKED_TAPPED: `${appV2EventPrefix} Visit Lock Access Locked Tapped`,
  VISIT_LOCK_IVE_DONE_THIS_TAPPED: `${appV2EventPrefix} Visit Lock I've Done This Tapped`,
  BOOKED_VISIT: `${appV2EventPrefix} Booked Visit`,

  // License
  ADD_LICENSE_ALERT_BOTTOM_SHEET_ADD_LICENSE_BUTTON_CLICKED: `${appV2EventPrefix} Add license alert bottom sheet add license button clicked`,
  ADD_LICENSE_ALERT_BOTTOM_SHEET_NOT_NOW_BUTTON_CLICKED: `${appV2EventPrefix} Add license alert bottom sheet not now button clicked`,
  PENDING_LICENSE_ALERT_BOTTOM_SHEET_SHOW_LICENSES_BUTTON_CLICKED: `${appV2EventPrefix} Pending license alert bottom sheet show licenses button clicked`,
  PENDING_LICENSE_ALERT_BOTTOM_SHEET_DISMISS_BUTTON_CLICKED: `${appV2EventPrefix} Pending license alert bottom sheet dismiss button clicked`,
  CLICKED_LICENSE_RENEWAL_BUTTON: `${appV2EventPrefix} Clicked license renewal button`,
  EMAIL_LICENSE_RENEWAL_DOCS: `${appV2EventPrefix} Email license renewal related documents`,
  VIEW_LICENSE_RENEWAL_GUIDE_LINK: `${appV2EventPrefix} View license renewal guide link`,

  GEOLOCATION_MISSING_ALERT_VIEWED: `${appV2EventPrefix} Geolocation missing alert opened`,
  GEOLOCATION_MISSING_ALERT_CANCELLED: `${appV2EventPrefix} Geolocation missing alert cancelled`,
  GEOLOCATION_MISSING_ALERT_UPDATE_ADDRESS_BUTTON_CLICKED: `${appV2EventPrefix} Geolocation missing alert update address button clicked`,

  // Touchpoint
  TOUCHPOINT_CLOCK_IN_STARTED: `${appV2EventPrefix} Touchpoint Clock In Started`,
  TOUCHPOINT_CLOCK_OUT_STARTED: `${appV2EventPrefix} Touchpoint Clock Out Started`,
  TOUCHPOINT_SCAN_SUCCESS: `${appV2EventPrefix} Touchpoint Scan Success`,
  TOUCHPOINT_SCAN_FAILURE: `${appV2EventPrefix} Touchpoint Scan Failure`,
  TOUCHPOINT_LOCATION_VALIDATION_FAILED: `${appV2EventPrefix} Touchpoint Location Validation Failed`,
  TOUCHPOINT_CONVERSION_TO_NON_INSTANT_FAILED: `${appV2EventPrefix} Touchpoint Conversion To Non Instant Failed`,
  TOUCHPOINT_TUTORIAL_OPENED: `${appV2EventPrefix} Touchpoint Tutorial Opened`,

  // Independent Contractor Badge
  INDEPENDENT_CONTRACTOR_BADGE_REQUIRED_BUTTON_CLICKED: `${appV2EventPrefix} Independent contractor badge required button clicked`,
  NO_ROLE_OR_ACTIVE_LICENSES_FOR_BADGE_ERROR: `${appV2EventPrefix} No role or active licenses for badge error`,

  // Clipboard Score
  CLIPBOARD_SCORE_PAGE_VIEWED: `${appV2EventPrefix} Clipboard Score Page Viewed`,
  CLIPBOARD_SCORE_ADJUSTMENTS_VIEWED: `${appV2EventPrefix} Clipboard Score Adjustments Viewed`,
  CLIPBOARD_SCORE_HISTORY_VIEWED: `${appV2EventPrefix} Clipboard Score History Viewed`,
  CLIPBOARD_SCORE_LOG_TOGGLED: `${appV2EventPrefix} Clipboard Score Log Toggled`,

  CLIPBOARD_SCORE_RESTRICTED_BOTTOM_SHEET_VIEWED: `${appV2EventPrefix} Clipboard Score Restricted Bottom Sheet Viewed`,
  CLIPBOARD_SCORE_RESTRICTED_BOTTOM_SHEET_CONTINUE_CLICKED: `${appV2EventPrefix} Clipboard Score Restricted Bottom Sheet Continue Clicked`,

  SHIFT_CANCEL_RESTRICTION_WARNING_VIEWED: `${appV2EventPrefix} Shift Cancel Restriction Warning Viewed`,
  SHIFT_CANCEL_RESTRICTION_WARNING_CONFIRMED: `${appV2EventPrefix} Shift Cancel Restriction Warning Confirmed`,
  SHIFT_CANCEL_RESTRICTION_WARNING_KEPT_SHIFT: `${appV2EventPrefix} Shift Cancel Restriction Warning Kept Shift`,

  CLIPBOARD_SCORE_NO_SHOW_BOTTOM_SHEET_VIEWED: `${appV2EventPrefix} Clipboard Score No Show Bottom Sheet Viewed`,
  CLIPBOARD_SCORE_WORKER_LEFT_EARLY_BOTTOM_SHEET_VIEWED: `${appV2EventPrefix} Clipboard Score Worker Left Early Bottom Sheet Viewed`,

  CLIPBOARD_SCORE_NEVER_NO_SHOW_PAGE_VIEWED: `${appV2EventPrefix} Clipboard Score Never No Show Page Viewed`,

  // Attendance Score Bottom Sheet
  CLIPBOARD_SCORE_BOTTOM_SHEET_VIEWED: `${appV2EventPrefix} Clipboard Score Bottom Sheet Viewed`,
  CLIPBOARD_SCORE_DETAILS_LINK_CLICKED: `${appV2EventPrefix} Clipboard Score Details Link Clicked`,
  CLIPBOARD_SCORE_CONTINUE_CLICKED: `${appV2EventPrefix} Clipboard Score Continue Clicked`,

  // Earnings Bottom Sheet
  EARNINGS_BOTTOM_SHEET_VIEWED: `${appV2EventPrefix} Earnings Bottom Sheet Viewed`,
  EARNINGS_BOTTOM_SHEET_CONTINUE_CLICKED: `${appV2EventPrefix} Earnings Bottom Sheet Continue Clicked`,
  EARNINGS_BOTTOM_SHEET_INSTANT_PAYOUT_SETTINGS_CLICKED: `${appV2EventPrefix} Earnings Bottom Sheet Instant Payout Settings Clicked`,

  // Post Shift Review Flow
  POST_SHIFT_REVIEW_STEP_VIEWED: `${appV2EventPrefix} Post Shift Review Step Viewed`,
  POST_SHIFT_REVIEW_CONTINUE_CLICKED: `${appV2EventPrefix} Post Shift Review Continue Clicked`,
  POST_SHIFT_REVIEW_SKIPPED: `${appV2EventPrefix} Post Shift Review Skipped`,
  POST_SHIFT_REVIEW_QUESTION_SKIPPED: `${appV2EventPrefix} Post Shift Review Question Skipped`,
  POST_SHIFT_REVIEW_VIDEO_PREVIEW_PLAYED: `${appV2EventPrefix} Post Shift Review Video Preview Played`,
  POST_SHIFT_REVIEW_VIDEO_PREVIEW_COMPLETED: `${appV2EventPrefix} Post Shift Review Video Preview Completed`,
  POST_SHIFT_REVIEW_VIDEO_RECORDING_STARTED: `${appV2EventPrefix} Post Shift Review Video Recording Started`,
  POST_SHIFT_REVIEW_VIDEO_RE_RECORDED: `${appV2EventPrefix} Post Shift Review Video Re-Recorded`,
  POST_SHIFT_REVIEW_VIDEO_UPLOAD_FAILED: `${appV2EventPrefix} Post Shift Review Video Upload Failed`,
  POST_SHIFT_REVIEW_BACK_CLICKED: `${appV2EventPrefix} Post Shift Review Back Clicked`,
  EMPLOYMENT_VERIFICATION_DOCUMENT_SELECTED: `${appV2EventPrefix} Employment Verification Document Selected`,
  EMPLOYMENT_VERIFICATION_SUBMITTED: `${appV2EventPrefix} Employment Verification Submitted`,
  EMPLOYMENT_VERIFICATION_SKIPPED: `${appV2EventPrefix} Employment Verification Skipped`,
  PEER_REVIEW_INTERACTION: `${appV2EventPrefix} Peer Review Interaction`,
  WORKPLACE_COMPARISON_INTERACTION: `${appV2EventPrefix} Workplace Comparison Interaction`,

  // Clipboard Score Education
  CLIPBOARD_SCORE_EDUCATION_INTRO: `${appV2EventPrefix} Clipboard Score Education Intro`,
  CLIPBOARD_SCORE_EDUCATION_YOUR_SCORE: `${appV2EventPrefix} Clipboard Score Education Your Score`,
  CLIPBOARD_SCORE_EDUCATION_HIGHER_SCORE_IS_BETTER: `${appV2EventPrefix} Clipboard Score Education Higher Score Is Better`,
  CLIPBOARD_SCORE_EDUCATION_EARN_POINTS: `${appV2EventPrefix} Clipboard Score Education Earn Points`,
  CLIPBOARD_SCORE_EDUCATION_LIFE_HAPPENS: `${appV2EventPrefix} Clipboard Score Education Life Happens`,
  CLIPBOARD_SCORE_EDUCATION_ARRIVE_ON_TIME: `${appV2EventPrefix} Clipboard Score Education Arrive On Time`,
  CLIPBOARD_SCORE_EDUCATION_START_RECAP: `${appV2EventPrefix} Clipboard Score Education Start Recap`,
  CLIPBOARD_SCORE_EDUCATION_RECAP_FIRST: `${appV2EventPrefix} Clipboard Score Education Recap First`,
  CLIPBOARD_SCORE_EDUCATION_RECAP_SECOND: `${appV2EventPrefix} Clipboard Score Education Recap Second`,
  CLIPBOARD_SCORE_EDUCATION_RECAP_THIRD: `${appV2EventPrefix} Clipboard Score Education Recap Third`,
  CLIPBOARD_SCORE_EDUCATION_FINAL_CONFIRM: `${appV2EventPrefix} Clipboard Score Education Final Confirm`,

  // Emergency Credits Education
  EMERGENCY_CREDITS_EDUCATION_STARTED: `${appV2EventPrefix} Emergency Credits Education Started`,
  EMERGENCY_CREDITS_EDUCATION_STEP_VIEWED: `${appV2EventPrefix} Emergency Credits Education Step Viewed`,
  EMERGENCY_CREDITS_EDUCATION_COMPLETED: `${appV2EventPrefix} Emergency Credits Education Completed`,
  EMERGENCY_CREDITS_EDUCATION_EXITED: `${appV2EventPrefix} Emergency Credits Education Exited`,
  EMERGENCY_CREDITS_INFO_LEARN_MORE_CLICKED: `${appV2EventPrefix} Emergency Credits Info Learn More Clicked`,

  // Your Clipboard Score Page (Emergency Credits Clock-Out Flow)
  YOUR_CLIPBOARD_SCORE_PAGE_VIEWED: `${appV2EventPrefix} Your Clipboard Score Page Viewed`,
  YOUR_CLIPBOARD_SCORE_APPLY_CREDIT_CLICKED: `${appV2EventPrefix} Your Clipboard Score Apply Credit Clicked`,
  YOUR_CLIPBOARD_SCORE_CONTINUE_CLICKED: `${appV2EventPrefix} Your Clipboard Score Continue Clicked`,

  // Attendance Confirmation
  ATTENDANCE_CONFIRMATION_NUDGE_VIEWED: `${appV2EventPrefix} Attendance Confirmation Nudge Viewed`,
  ATTENDANCE_CONFIRMATION_NUDGE_CONFIRMED: `${appV2EventPrefix} Attendance Confirmation Nudge Confirmed`,
  ATTENDANCE_CONFIRMATION_NUDGE_CANCELLED: `${appV2EventPrefix} Attendance Confirmation Nudge Cancelled`,

  // Roles
  ROLE_ADDED: `${appV2EventPrefix} Role Added`,
  ROLE_REMOVED: `${appV2EventPrefix} Role Removed`,

  // Geofence
  GEOFENCE_POLLING_STARTED: `${appV2EventPrefix} Geofence Polling Started`,
  GEOFENCE_POLLING_COMPLETED: `${appV2EventPrefix} Geofence Polling Completed`,
  GEOFENCE_STATUS_CHANGED: `${appV2EventPrefix} Geofence Status Changed`,
  GEOFENCE_STATUS_CHANGED_IGNORED: `${appV2EventPrefix} Geofence Status Changed Ignored`,
  HYPERTRACK_SUBSCRIPTION_SETUP_STARTED: `${appV2EventPrefix} HyperTrack Subscription Setup Started`,
  HYPERTRACK_SUBSCRIPTION_SETUP_COMPLETED: `${appV2EventPrefix} HyperTrack Subscription Setup Completed`,
  HYPERTRACK_ORDER_RECEIVED: `${appV2EventPrefix} HyperTrack Order Received`,
  HYPERTRACK_GEOFENCE_CHECK_FAILED: `${appV2EventPrefix} HyperTrack Geofence Check Failed`,

  // Missed Punch Request Geofence
  MPR_GEOFENCE_CHECK_COMPLETED: `${appV2EventPrefix} MPR Geofence Check Completed`,
  MPR_GEOFENCE_CHECK_FAILED: `${appV2EventPrefix} MPR Geofence Check Failed`,
  MPR_RETURN_FOR_SIGNATURE_SHOWN: `${appV2EventPrefix} MPR Return For Signature Shown`,
  MPR_RECHECK_LOCATION_CLICKED: `${appV2EventPrefix} MPR Recheck Location Clicked`,
  MPR_CONFIRM_WITHOUT_SIGNATURE_CLICKED: `${appV2EventPrefix} MPR Confirm Without Signature Clicked`,

  // Arrival Time
  SHIFT_ARRIVAL_TIME_CONFIRMED: `${appV2EventPrefix} Shift Arrival Time Confirmed`,
  SHIFT_ARRIVAL_TIME_CONFIRMATION_MODAL_VIEWED: `${appV2EventPrefix} Shift Arrival Time Confirmation Modal Viewed`,
  SHIFT_INVITE_ACCEPTED: `${appV2EventPrefix} Shift Invite Accepted`,

  // Favorite Workplaces
  FAVORITE_WORKPLACES_SHIFT_PAGE_VIEWED: `${appV2EventPrefix} Favorite Workplaces Shift Page Viewed`,
  FAVORITE_WORKPLACES_PICKER_PAGE_VIEWED: `${appV2EventPrefix} Favorite Workplaces Picker Page Viewed`,
  CHOOSE_FAVORITE_WORKPLACES_BUTTON_CLICKED: `${appV2EventPrefix} Choose Favorite Workplaces Button Clicked`,
  UPDATE_FAVORITE_WORKPLACES_BUTTON_CLICKED: `${appV2EventPrefix} Update Favorite Workplaces Button Clicked`,
  UPDATE_FAVORITE_WORKPLACES: `${appV2EventPrefix} Update Favorite Workplaces`,
  FAVORITE_WORKPLACES_ERROR: `${appV2EventPrefix} Favorite Workplaces Error`,

  // Address
  UPDATED_ADDRESS: `${appV2EventPrefix} Address Updated`,

  // SSN
  ADD_SSN_BOTTOM_SHEET_OPENED: `${appV2EventPrefix} Add SSN Bottom Sheet Opened`,
  SSN_UPDATED: `${appV2EventPrefix} SSN Updated`,
  SSN_MISMATCH_ERROR: `${appV2EventPrefix} SSN Mismatch Error`,
  SSN_VALIDATION_ERROR: `${appV2EventPrefix} SSN Validation Error`,
  SSN_PREREQUISITE_DETECTED: `${appV2EventPrefix} SSN Prerequisite Detected`,
  SSN_PREREQUISITE_ACTION_STARTED: `${appV2EventPrefix} SSN Prerequisite Action Started`,
  SSN_PREREQUISITE_ACTION_COMPLETED: `${appV2EventPrefix} SSN Prerequisite Action Completed`,
  UPDATE_WORKER_SSN_FAILURE: `${appV2EventPrefix} Failed to update worker SSN`,

  // Ten99 Policy Coverage
  VIEWED_TEN99_POLICY_COVERAGE_CARD: `${appV2EventPrefix} Viewed Ten99 Policy Coverage Card`,
  TEN99_POLICY_APPLICATION_SESSION_CREATED: `${appV2EventPrefix} 1099 Policy Application Session Created`,
  VIEWED_TEN99_POLICY_DOCUMENT_PAGE: `${appV2EventPrefix} Viewed Ten99 Policy Document Page`,
  TEN99_POLICY_APPLICATION_SUBMITTED_OR_ABANDONED: `${appV2EventPrefix} 1099 Policy Application Submitted or Abandoned`,
  CLICKED_VIEW_TEN99_POLICY_FAQ: `${appV2EventPrefix} Clicked View 1099 Policy FAQ`,

  // Payments Onboarding
  PAYMENTS_ONBOARDING_SET_UP_BANNER_SHOWN: `${appV2EventPrefix} Payments onboarding set up banner shown`,
  PAYMENTS_ONBOARDING_ENTRYPOINT_CLICKED: `${appV2EventPrefix} Payments onboarding entrypoint clicked`,
  PAYMENTS_ONBOARDING_INITIAL_VIEWED: `${appV2EventPrefix} Payments onboarding initial viewed`,
  PAYMENTS_ONBOARDING_TIPS_VIEWED: `${appV2EventPrefix} Payments onboarding tips viewed`,
  PAYMENTS_ONBOARDING_GO_TO_STRIPE_CLICKED: `${appV2EventPrefix} Payments onboarding go to Stripe clicked`,
  PAYMENTS_ONBOARDING_WAITING_VIEWED: `${appV2EventPrefix} Payments onboarding waiting viewed`,
  PAYMENTS_ONBOARDING_WAITING_RETURN_TO_STRIPE_CLICKED: `${appV2EventPrefix} Payments onboarding waiting return to Stripe clicked`,
  PAYMENTS_ONBOARDING_VERIFICATION_FAILED_VIEWED: `${appV2EventPrefix} Payments onboarding verification failed viewed`,
  PAYMENTS_ONBOARDING_VERIFICATION_FAILED_RETURN_TO_STRIPE_CLICKED: `${appV2EventPrefix} Payments onboarding verification failed return to Stripe clicked`,
  PAYMENTS_ONBOARDING_EXITED: `${appV2EventPrefix} Payments onboarding exited`,
  PAYMENTS_ONBOARDING_VERIFICATION_SUCCEEDED_VIEWED: `${appV2EventPrefix} Payments onboarding verification succeeded viewed`,
  PAYMENTS_ONBOARDING_PAYOUT_SETTINGS_VIEWED: `${appV2EventPrefix} Payments onboarding payout settings viewed`,
  PAYMENTS_ONBOARDING_PAYOUT_SETTINGS_SET: `${appV2EventPrefix} Payments onboarding payout settings set`,
  PAYMENTS_ONBOARDING_COMPLETED: `${appV2EventPrefix} Payments onboarding completed`,

  // Stripe Restriction
  STRIPE_RESTRICTION_BANNER_SHOWN: `${appV2EventPrefix} Stripe restriction banner shown`,
  STRIPE_RESTRICTION_BANNER_CTA_CLICKED: `${appV2EventPrefix} Stripe restriction banner CTA clicked`,

  // Failed Payout
  FAILED_PAYOUT_BANNER_SHOWN: `${appV2EventPrefix} Failed payout banner shown`,
  FAILED_PAYOUT_PAGE_OPENED: `${appV2EventPrefix} Failed payout page opened`,
  FAILED_PAYOUT_ACTION_TALK_TO_SUPPORT: `${appV2EventPrefix} Failed payout action - Talk to support`,
  FAILED_PAYOUT_ACTION_UPDATE_PAYOUT_SETTINGS: `${appV2EventPrefix} Failed payout action - Update payout settings`,
  FAILED_PAYOUT_ACTION_RETRY_PAYOUT: `${appV2EventPrefix} Failed payout action - Retry payout`,

  // Earnings page
  EARNINGS_PAGE_SHOWN: `${appV2EventPrefix} Earnings Page - Shown`,
  EARNINGS_PAGE_SETTINGS_SHOWN: `${appV2EventPrefix} Earnings Page - Settings - Shown`,
  EARNINGS_PAGE_SETTINGS_EXPORT_EARNINGS_CLICKED: `${appV2EventPrefix} Earnings Page - Settings - Export Earnings Clicked`,
  EARNINGS_PAGE_SETTINGS_TAX_INFO_CLICKED: `${appV2EventPrefix} Earnings Page - Settings - Tax Info Clicked`,
  EARNINGS_PAGE_SETTINGS_PAYOUT_SETTINGS_CLICKED: `${appV2EventPrefix} Earnings Page - Settings - Payout Settings Clicked`,
  EARNINGS_PAGE_SETTINGS_STRIPE_CLICKED: `${appV2EventPrefix} Earnings Page - Settings - Stripe Clicked`,

  EARNINGS_PAGE_VIEW_SHIFT_HISTORY_TAPPED: `${appV2EventPrefix} Earnings Page - View Shift History Tapped`,

  EARNINGS_PAGE_OUTSTANDING_BALANCE_BANNER_SHOWN: `${appV2EventPrefix} Earnings Page - Outstanding balance banner - Shown`,
  EARNINGS_PAGE_OUTSTANDING_BALANCE_BANNER_SEND_PAYMENT_CLICKED: `${appV2EventPrefix} Earnings Page - Outstanding balance banner - Send payment clicked`,

  // Orientation Shifts
  VIEWED_ORIENTATION_REQUIRED_CARD: `${appV2EventPrefix} Viewed Orientation Required Card`,
  ORIENTATION_FACILITY_CHAT_TAPPED: `${appV2EventPrefix} Tapped Orientation Card Facility Chat`,
  ORIENTATION_BOOK_SHIFTS_TAPPED: `${appV2EventPrefix} Tapped Orientation Card Book Shifts`,

  // 1099 Form UI
  TAX_SEASON_BANNER_SHOWN: `${appV2EventPrefix} Tax season banner shown`,
  TAX_SEASON_BANNER_CTA_CLICKED: `${appV2EventPrefix} Tax season banner cta clicked`,
  TAX_SEASON_BANNER_DISMISSED: `${appV2EventPrefix} Tax season banner dismissed`,

  // Holiday Gift
  HOLIDAY_GIFT_BANNER_SHOWN: `${appV2EventPrefix} Holiday Gift Banner Shown`,
  HOLIDAY_GIFT_BANNER_CTA_CLICKED: `${appV2EventPrefix} Holiday Gift Banner CTA Clicked`,
  HOLIDAY_GIFT_SHARE_CTA_CLICKED: `${appV2EventPrefix} Holiday Gift Share CTA Clicked`,
  HOLIDAY_GIFT_INSTRUCTIONS_CTA_CLICKED: `${appV2EventPrefix} Holiday Gift Instructions CTA Clicked`,

  // Get Help During Shift
  GET_HELP_DURING_SHIFT_SHOWN: `${appV2EventPrefix} Get help during shift shown`,
  GET_HELP_DURING_SHIFT_ACCEPTED_HELP: `${appV2EventPrefix} Get help during shift accepted help`,
  GET_HELP_DURING_SHIFT_CONTACTED_SUPPORT: `${appV2EventPrefix} Get help during shift contacted support`,

  // Professional References
  PROFESSIONAL_REFERENCE_CREATED: `${appV2EventPrefix} Professional reference created`,
  PROFESSIONAL_REFERENCE_SHARED: `${appV2EventPrefix} Professional reference shared`,
  PROFESSIONAL_REFERENCES_PAGE_VIEWED: `${appV2EventPrefix} Professional references page viewed`,

  // Missed Punch Requests
  MISSED_PUNCH_REQUEST_TIMESHEET_BOUNDARY_VIOLATION_ATTEMPTED: `${appV2EventPrefix} Missed Punch Request Timesheet Boundary Violation Attempted`,

  // Work Badges
  WORK_BADGE_PREVIEW_LOAD_FAILURE: `${appV2EventPrefix} Work Badge Preview Load Failure`,
  WORK_BADGE_PHOTO_SELECTION_FAILURE: `${appV2EventPrefix} Work Badge Photo Selection Failure`,
  WORK_BADGE_EMAIL_SENT_SUCCESS: `${appV2EventPrefix} Work Badge Email Sent Success`,
  WORK_BADGE_REVIEW_POLICY_CLICKED: `${appV2EventPrefix} Work Badge Review Policy Clicked`,
  WORK_BADGE_REVIEW_POLICY_COMPLETED: `${appV2EventPrefix} Work Badge Review Policy Completed`,
  WORK_BADGE_NEED_NEW_BADGE_CLICKED: `${appV2EventPrefix} Work Badge Need New Badge Clicked`,
  WORK_BADGE_REVIEW_POLICY_QUALIFICATION_NAME_NOT_DEFINED: `${appV2EventPrefix} Work Badge Review Policy Qualification Name Not Defined`,
  WORK_BADGE_POLICY_REDESIGN_VIEWED: `${appV2EventPrefix} Work Badge Policy Redesign Viewed`,
  WORK_BADGE_POLICY_REDESIGN_GET_BADGE_CLICKED: `${appV2EventPrefix} Work Badge Policy Redesign Get Badge Clicked`,

  // Job Search Agreement - Page
  JOB_SEARCH_AGREEMENT_SIGNED: `${appV2EventPrefix} Job Search Agreement Signed`,

  // Job Search Agreement - Form
  JOB_SEARCH_AGREEMENT_SCROLLED: `${appV2EventPrefix} Job Search Agreement Scrolled`,
  JOB_SEARCH_AGREEMENT_CHECKBOX_CHECKED: `${appV2EventPrefix} Job Search Agreement Checkbox Checked`,

  // Job Search Agreement - Support
  OPEN_JOB_SEARCH_AGREEMENT_SUPPORT_ARTICLE_ERROR: `${appV2EventPrefix} Open Job Search Agreement Support Article Error`,

  // Job Search Agreement - Modal
  JOB_SEARCH_AGREEMENT_MODAL_VIEWED: `${appV2EventPrefix} Job Search Agreement Modal Viewed`,

  // Chat - Cancellation Detection
  CANCELLATION_ALERT_TRIGGERED: `${appV2EventPrefix} Cancellation Alert Triggered`,
  CANCELLATION_ALERT_ACTION: `${appV2EventPrefix} Cancellation Alert Action`,

  // Reactivation Bonus
  REACTIVATION_BONUS_BANNER_VIEWED: `${appV2EventPrefix} Reactivation Bonus Banner Viewed`,
  REACTIVATION_BONUS_BANNER_CLICKED: `${appV2EventPrefix} Reactivation Bonus Banner Clicked`,
  REACTIVATION_BONUS_BANNER_DISMISSED: `${appV2EventPrefix} Reactivation Bonus Banner Dismissed`,
  REACTIVATION_BONUS_BOTTOM_SHEET_VIEWED: `${appV2EventPrefix} Reactivation Bonus Bottom Sheet Viewed`,

  // Concorde Scholarship V2
  CONCORDE_SCHOLARSHIP_V2_BANNER_VIEWED: `${appV2EventPrefix} Concorde Scholarship V2 Banner Viewed`,
  CONCORDE_SCHOLARSHIP_V2_BANNER_OPENED: `${appV2EventPrefix} Concorde Scholarship V2 Banner Opened`,
  CONCORDE_SCHOLARSHIP_V2_BANNER_DISMISSED: `${appV2EventPrefix} Concorde Scholarship V2 Banner Dismissed`,
  CONCORDE_SCHOLARSHIP_V2_INTEREST_SUBMITTED: `${appV2EventPrefix} Concorde Scholarship V2 Interest Submitted`,
  CONCORDE_SCHOLARSHIP_V2_SEE_ALL_PROGRAMS_CLICKED: `${appV2EventPrefix} Concorde Scholarship V2 See All Programs Clicked`,
  CONCORDE_SCHOLARSHIP_V2_STATUS_VIEWED: `${appV2EventPrefix} Concorde Scholarship V2 Status Viewed`,
  CONCORDE_SCHOLARSHIP_V2_STATUS_CONTINUE_CLICKED: `${appV2EventPrefix} Concorde Scholarship V2 Status Continue Clicked`,

  // Location Change Prompt
  LOCATION_CHANGE_PROMPT_VIEWED: `${appV2EventPrefix} Location Change Prompt Viewed`,
  LOCATION_CHANGE_PROMPT_ACCEPTED: `${appV2EventPrefix} Location Change Prompt Accepted`,
  LOCATION_CHANGE_PROMPT_DISMISSED: `${appV2EventPrefix} Location Change Prompt Dismissed`,

  // Travel Shifts
  TRAVEL_SHIFTS_BANNER_VIEWED: `${appV2EventPrefix} Travel Shifts Banner Viewed`,
  TRAVEL_SHIFTS_BANNER_CTA_CLICKED: `${appV2EventPrefix} Travel Shifts Banner CTA Clicked`,
  TRAVEL_SHIFTS_BOTTOM_SHEET_VIEWED: `${appV2EventPrefix} Travel Shifts Bottom Sheet Viewed`,
  TRAVEL_SHIFTS_BOTTOM_SHEET_DISMISSED: `${appV2EventPrefix} Travel Shifts Bottom Sheet Dismissed`,
  TRAVEL_SHIFTS_INTEREST_SUBMITTED: `${appV2EventPrefix} Travel Shifts Interest Submitted`,

  // Worker Pay Survey
  WORKER_PAY_SURVEY_PAGE_VIEWED: `${appV2EventPrefix} Worker Pay Survey Page Viewed`,
  WORKER_PAY_SURVEY_CARD_VIEWED: `${appV2EventPrefix} Worker Pay Survey Card Viewed`,
  WORKER_PAY_SURVEY_CARD_CLICKED: `${appV2EventPrefix} Worker Pay Survey Card Clicked`,
  WORKER_PAY_SURVEY_SUBMITTED: `${appV2EventPrefix} Worker Pay Survey Submitted`,

  // Badge Verification (Clock-In)
  BADGE_VERIFICATION_DIALOG_VIEWED: `${appV2EventPrefix} Badge Verification Dialog Viewed`,
  BADGE_VERIFICATION_TAKE_PHOTO_TAPPED: `${appV2EventPrefix} Badge Verification Take Photo Tapped`,
  BADGE_VERIFICATION_NO_BADGE_TAPPED: `${appV2EventPrefix} Badge Verification No Badge Tapped`,
  BADGE_VERIFICATION_RETAKE_PHOTO_TAPPED: `${appV2EventPrefix} Badge Verification Retake Photo Tapped`,
  BADGE_VERIFICATION_HAS_BADGE_TAPPED: `${appV2EventPrefix} Badge Verification Has Badge Tapped`,
  BADGE_VERIFICATION_PHOTO_SUBMITTED: `${appV2EventPrefix} Badge Verification Photo Submitted`,
  BADGE_VERIFICATION_SKIPPED: `${appV2EventPrefix} Badge Verification Skipped`,
  BADGE_VERIFICATION_WHY_BADGE_REQUIRED_TAPPED: `${appV2EventPrefix} Badge Verification Why Badge Required Tapped`,
  BADGE_VERIFICATION_ALREADY_COMPLETED: `${appV2EventPrefix} Badge Verification Already Completed`,

  // Badge Verification - Temp Badge (Redesign)
  BADGE_VERIFICATION_TEMP_BADGE_PICKED_UP: `${appV2EventPrefix} Badge Verification Temp Badge Picked Up`,
  BADGE_VERIFICATION_TEMP_BADGE_SKIPPED: `${appV2EventPrefix} Badge Verification Temp Badge Skipped`,

  // Badge Verification Result (Post-Grading)
  BADGE_VERIFICATION_RESULT_VIEWED: `${appV2EventPrefix} Badge Verification Result Viewed`,
  BADGE_VERIFICATION_RESULT_GET_NEW_BADGE_CLICKED: `${appV2EventPrefix} Badge Verification Result Get New Badge Clicked`,
  BADGE_VERIFICATION_RESULT_DISMISSED: `${appV2EventPrefix} Badge Verification Result Dismissed`,

  // Early Access Facilities
  EARLY_ACCESS_FACILITIES_INTEREST_FORM_SUBMITTED: `${appV2EventPrefix} Early access facilities interest form submitted`,
  EARLY_ACCESS_FACILITIES_MAP_PIN_CLICKED: `${appV2EventPrefix} Early access facilities map pin clicked`,
  EARLY_ACCESS_FACILITIES_INTEREST_FLOW_STEP_CHANGED: `${appV2EventPrefix} Early access facilities interest flow step changed`,
  EARLY_ACCESS_BANNER_SHOWN: `${appV2EventPrefix} Early Access Banner Shown`,
  EARLY_ACCESS_BANNER_CTA_CLICKED: `${appV2EventPrefix} Early Access Banner CTA Clicked`,
  EARLY_ACCESS_CALLOUT_PILL_CLICKED: `${appV2EventPrefix} Early Access Callout pill clicked`,
  EARLY_ACCESS_FACILITY_SELECTED: `${appV2EventPrefix} Early Access Facility Selected`,
  EARLY_ACCESS_FACILITIES_NEAR_ME_CLICKED: `${appV2EventPrefix} Early Access Facilities Near Me Clicked`,
  EARLY_ACCESS_FACILITIES_LIST_VIEW_CLICKED: `${appV2EventPrefix} Early Access Facilities List View Clicked`,

  // Share Clipboard Score
  SHARE_CLIPBOARD_SCORE_PAGE_VIEWED: `${appV2EventPrefix} Share Clipboard Score Page Viewed`,
  SHARE_CLIPBOARD_SCORE_SOCIAL_SHARE_TAPPED: `${appV2EventPrefix} Share Clipboard Score Social Share Tapped`,
  SHARE_CLIPBOARD_SCORE_SOCIAL_SHARE_SUCCESS: `${appV2EventPrefix} Share Clipboard Score Social Share Success`,

  // Shift Bundles
  SHIFT_BUNDLE_VIEWED: `${appV2EventPrefix} Shift Bundle Viewed`,
  SHIFT_BUNDLE_CLICKED: `${appV2EventPrefix} Shift Bundle Clicked`,
  SHIFT_BUNDLE_SELECT_SHIFTS: `${appV2EventPrefix} Shift Bundle Select Shifts`,
  SHIFT_BUNDLE_BOOKED: `${appV2EventPrefix} Shift Bundle Booked`,

  // Shift Doubles
  SHIFT_DOUBLE_BOOKED: `${appV2EventPrefix} Shift Double Booked`,
  SHIFT_DOUBLE_QUIZ_CTA_TAPPED: `${appV2EventPrefix} Shift Double Quiz CTA Tapped`,

  // TB Test Guided Upload
  VIEWED_TB_TEST_GUIDED_UPLOAD_PAGE: `${appV2EventPrefix} Viewed TB test guided upload page`,
  VIEWED_TB_TEST_GUIDED_UPLOAD_DIALOG: `${appV2EventPrefix} Viewed TB test guided upload dialog`,
  TB_TEST_GUIDED_UPLOAD_STARTED: `${appV2EventPrefix} TB test guided upload started`,
  TB_TEST_GUIDED_UPLOAD_TEST_TYPE_SELECTED: `${appV2EventPrefix} TB test guided upload test type selected`,
  TB_TEST_GUIDED_UPLOAD_DOCUMENT_UPLOADED: `${appV2EventPrefix} TB test guided upload document uploaded`,
  TB_TEST_GUIDED_UPLOAD_COMPLETED: `${appV2EventPrefix} TB test guided upload completed`,
  TB_TEST_GUIDED_UPLOAD_INVALID_TEST_DATE: `${appV2EventPrefix} TB test guided upload invalid test date`,
  VIEWED_TB_TEST_GUIDED_UPLOAD_SUCCESS_STEP: `${appV2EventPrefix} Viewed TB test guided upload success step`,
  VIEWED_TB_TEST_GUIDED_UPLOAD_INVALID_TEST_ERROR_STEP: `${appV2EventPrefix} Viewed TB test guided upload invalid test error step`,
  TB_TEST_GUIDED_UPLOAD_ABANDONED: `${appV2EventPrefix} TB test guided upload abandoned`,
  TB_TEST_GUIDED_UPLOAD_NOT_COMPLETED_RECENTLY_SELECTED: `${appV2EventPrefix} TB test guided upload not completed recently selected`,
  TB_TEST_GUIDED_UPLOAD_UPLOADED_FILE_PREVIEWED: `${appV2EventPrefix} TB test guided upload uploaded file previewed`,
  TB_TEST_GUIDED_UPLOAD_PREVIEWED_FILE_REPLACED: `${appV2EventPrefix} TB test guided upload previewed file replaced`,
  TB_TEST_GUIDED_UPLOAD_PREVIEWED_FILE_REMOVED: `${appV2EventPrefix} TB test guided upload previewed file removed`,
  VIEWED_SCHEDULE_TB_TEST_PAGE: `${appV2EventPrefix} Viewed schedule TB test page`,
  TB_TEST_GUIDED_UPLOAD_SCHEDULE_PROVIDER_CLICKED: `${appV2EventPrefix} TB test guided upload schedule provider clicked`,

  // File Preview
  FILE_PREVIEW_NOT_AVAILABLE: `${appV2EventPrefix} File preview not available`,

  // PandaDoc events
  PANDADOC_SIGN_CTA_CLICKED: `${appV2EventPrefix} PandaDoc sign cta clicked`,
  PANDADOC_SDK_DOCUMENT_LOADED: `${appV2EventPrefix} PandaDoc SDK document loaded`,
  PANDADOC_SDK_DOCUMENT_SIGNED: `${appV2EventPrefix} PandaDoc SDK document signed`,
  PANDADOC_SIGNING_CLOSED: `${appV2EventPrefix} PandaDoc signing closed`,
  PANDADOC_QUIZ_NOT_PASSED_VIEWED: `${appV2EventPrefix} PandaDoc quiz not passed viewed`,
  PANDADOC_QUIZ_NOT_PASSED_REVIEW_QUESTIONS_TAPPED: `${appV2EventPrefix} PandaDoc quiz not passed review questions tapped`,
  PANDADOC_QUIZ_NOT_PASSED_RETAKE_QUIZ_TAPPED: `${appV2EventPrefix} PandaDoc quiz not passed retake quiz tapped`,
  PANDADOC_QUIZ_NOT_PASSED_NOT_NOW_TAPPED: `${appV2EventPrefix} PandaDoc quiz not passed not now tapped`,

  // Clock-In Visibility Tracking
  CLOCK_IN_VISIBILITY_STATE_CHANGED: `${appV2EventPrefix} Clock In Visibility State Changed`,

  // Shift Blast
  SHIFT_BLAST_DEEP_LINK_VISITED: `${appV2EventPrefix} Shift Blast Deep Link Visited`,

  // Suggest InstantPay
  SUGGEST_INSTANT_PAY_BOTTOM_SHEET_VIEWED: `${appV2EventPrefix} Suggest InstantPay Bottom Sheet Viewed`,
  SUGGEST_INSTANT_PAY_SWITCH_CLICKED: `${appV2EventPrefix} Suggest InstantPay Switch Clicked`,
  SUGGEST_INSTANT_PAY_SWITCH_SUCCESS: `${appV2EventPrefix} Suggest InstantPay Switch Success`,
  SUGGEST_INSTANT_PAY_DISMISSED: `${appV2EventPrefix} Suggest InstantPay Dismissed`,

  // Nearest Open Shifts
  NEAREST_OPEN_SHIFTS_SEARCH_COMPLETED: `${appV2EventPrefix} Nearest Open Shifts Search Completed`,

  // Empty State
  EMPTY_STATE_BOOKING_STATS_VIEWED: `${appV2EventPrefix} Empty State Booking Stats Viewed`,
  EMPTY_STATE_NEAREST_SHIFT_CLICKED: `${appV2EventPrefix} Empty State Nearest Shift Clicked`,

  // For You
  FOR_YOU_SHIFTS_LIST_VIEWED: `${appV2EventPrefix} For You Shifts Viewed`,
  FOR_YOU_SHIFTS_SHIFT_CLICKED: `${appV2EventPrefix} For You Shifts Shift Clicked`,
  FOR_YOU_SHIFTS_SHIFT_BOOKED: `${appV2EventPrefix} For You Shifts Shift Booked`,
  TOP_THREE_SHIFT_BOOKED: `${appV2EventPrefix} Top Three Shift Booked`,

  // Cancellation Protection Banner
  CANCELLATION_PROTECTION_BANNER_VIEWED: `${appV2EventPrefix} Cancellation Protection Banner Viewed`,
  CANCELLATION_PROTECTION_BANNER_VIEW_TERMS_CLICKED: `${appV2EventPrefix} Cancellation Protection Banner View Terms Clicked`,
  CANCELLATION_PROTECTION_BANNER_DISMISSED: `${appV2EventPrefix} Cancellation Protection Banner Dismissed`,
} as const;

export const APP_V2_APP_EVENTS = {
  APP_LOADING_PAGE_DISPLAYED: `${appV2EventPrefix} App Loading Page Displayed`,
  APP_LOADING_PAGE_EFFECT_RUNNING: `${appV2EventPrefix} App Loading Page Effect Running`,

  CANNOT_GENERATE_LICENSE_RENEWAL_DOCS: `${appV2EventPrefix} Cannot generate license renewal docs`,

  ACCOUNT_LOG_CREATE_FAILED: `${appV2EventPrefix} Account log create failed`,

  OPEN_IN_BROWSER_FAILED: `${appV2EventPrefix} Open in browser failed`,

  // Onboarding
  STRIPE_ONBOARDING_ERROR: `${appV2EventPrefix} Stripe Onboarding Error`,
  AGREEMENT_SIGNING_ERROR: `${appV2EventPrefix} Agreement Signing Error`,
  AGREEMENT_TO_SIGN_NOT_DEFINED: `${appV2EventPrefix} Agreement to sign not defined`,
  GET_WORKER_ONBOARDING_FAILURE: `${appV2EventPrefix} Failed to get worker onboarding`,
  PATCH_WORKER_ONBOARDING_FAILURE: `${appV2EventPrefix} Failed to update worker onboarding`,
  ONBOARDING_PERSONAL_ID_NOT_REQUIRED_ERROR: `${appV2EventPrefix} Onboarding Personal ID Not Required Error`,
  ONBOARDING_PERSONAL_ID_FETCH_ERROR: `${appV2EventPrefix} Onboarding Personal ID Fetch Error`,
  ONBOARDING_PERSONAL_ID_IN_REVIEW_PAGE_VIEWED: `${appV2EventPrefix} Onboarding Personal ID In Review Page Viewed`,
  ONBOARDING_PERSONAL_ID_VERIFICATION_PAGE_VIEWED: `${appV2EventPrefix} Onboarding Personal ID Verification Page Viewed`,
  ONBOARDING_PERSONAL_ID_APPROVED_BOTTOM_SHEET_VIEWED: `${appV2EventPrefix} Onboarding Personal ID Approved Bottom Sheet Viewed`,
  ONBOARDING_PERSONAL_ID_APPROVED_WITH_NAME_UPDATE_BOTTOM_SHEET_VIEWED: `${appV2EventPrefix} Onboarding Personal ID Approved With Name Update Bottom Sheet Viewed`,
  ONBOARDING_PERSONAL_ID_APPROVED_WITH_FLAGGED_NAME_BOTTOM_SHEET_VIEWED: `${appV2EventPrefix} Onboarding Personal ID Approved With Flagged Name Bottom Sheet Viewed`,
  ONBOARDING_PERSONAL_ID_ACKNOWLEDGE_NAME_UPDATE_BUTTON_TAPPED: `${appV2EventPrefix} Onboarding Personal ID Acknowledge Name Update Button Tapped`,
  ONBOARDING_UPDATE_ADDRESS_ERROR: `${appV2EventPrefix} Onboarding Update Address Error`,
  UPDATE_ADDRESS_ERROR: `${appV2EventPrefix} Update Address Error`,
  ONBOARDING_UPDATE_PERSONAL_INFORMATION_ERROR: `${appV2EventPrefix} Onboarding Update Personal Information Error`,
  ONBOARDING_UPDATE_EMAIL_ERROR: `${appV2EventPrefix} Onboarding Update Email Error`,
  ONBOARDING_SESSION_EXPIRED_ERROR: `${appV2EventPrefix} Onboarding Session Expired Error`,
  ONBOARDING_ACCOUNT_CONFLICT_ERROR: `${appV2EventPrefix} Onboarding Account Conflict Error`,
  SIGN_AGREEMENT_FAILURE: `${appV2EventPrefix} Failed to sign agreement`,
  UPDATE_AUTOMATED_NAME_UPDATE_FAILURE: `${appV2EventPrefix} Failed to update automated name update`,
  CREATE_PAYMENT_SERVICE_ACCOUNT_FAILURE: `${appV2EventPrefix} Failed to create payment service account`,
  GET_PAYMENT_SERVICE_ACCOUNT_FAILURE: `${appV2EventPrefix} Failed to get payment service account`,
  UPDATE_PAYMENT_SERVICE_ACCOUNT_FAILURE: `${appV2EventPrefix} Failed to update payment service account`,

  // Job Search Agreement Errors
  GET_JOB_SEARCH_AGREEMENTS_FAILURE: `${appV2EventPrefix} Get Job Search Agreements Failure`,
  SIGN_JOB_SEARCH_AGREEMENT_FAILURE: `${appV2EventPrefix} Sign Job Search Agreement Failure`,
  PDF_PLATFORM_UNSUPPORTED_JOB_SEARCH_AGREEMENT: `${appV2EventPrefix} PDF Platform Unsupported Job Search Agreement`,

  // App
  APPLICATION_CRASHED: `${appV2EventPrefix} Application Crashed`,
  FIREBASE_OTP_SIGN_IN_ERROR: `${appV2EventPrefix} Firebase signInWithCustomToken error`,
  AGENT_PROFILE_LOGGED_IN_ERROR: `${appV2EventPrefix} API request to /agentProfile/loggedIn failed`,
  APP_INFO_ERROR: `${appV2EventPrefix} Failed to load Capacitor App info`,
  DEVICE_INFO_ERROR: `${appV2EventPrefix} Failed to load Capacitor Device info`,
  API_SCHEMA_VALIDATION_ERROR: `${appV2EventPrefix} API Zod Schema validation error`,
  API_INPUT_SCHEMA_VALIDATION_ERROR: `${appV2EventPrefix} API Input Zod Schema validation error`,
  RECORD_TIMEKEEPING_ACTION_FAILED: `${appV2EventPrefix} Record Timekeeping Action Failed`,
  RECORD_TIMEKEEPING_ACTION_API_ERROR: `${appV2EventPrefix} Record Timekeeping Action API Error`,
  FEATURE_FLAG_SCHEMA_VALIDATION_ERROR: `${appV2EventPrefix} Feature Flag Zod schema validation error`,
  INVALID_SET_OF_COORDINATES_ERROR: `${appV2EventPrefix} Invalid set of coordinates error`,
  FAILED_TO_SET_UP_APP_STATE_LISTENER: `${appV2EventPrefix} Failed to set up app state listener`,
  APP_RESTORED: `${appV2EventPrefix} App Restored`,
  NON_EXISTING_ICON_REQUESTED: `${appV2EventPrefix} Non existing icon requested`,
  NON_EXISTING_ILLUSTRATION_REQUESTED: `${appV2EventPrefix} Non existing illustration requested`,
  FAILED_TO_OPEN_OS_STORE: `${appV2EventPrefix} Failed to open OS store`,
  SHOWING_FORCE_UPDATE_OR_NUDGE_DIALOG: `${appV2EventPrefix} Showing force update/update nudge dialog`,
  APP_LOADING_TIMEOUT: `${appV2EventPrefix} App loading timeout`,
  APP_SHORTCUT_SYNC_FAILURE: `${appV2EventPrefix} App shortcut sync failure`,
  APP_SHORTCUT_LISTENER_FAILURE: `${appV2EventPrefix} App shortcut listener failure`,
  APP_SHORTCUT_ACTION_FAILURE: `${appV2EventPrefix} App shortcut action failure`,

  // Touchpoint QR brightness handling
  TOUCHPOINT_QR_SET_MAX_BRIGHTNESS_FAILURE: `${appV2EventPrefix} Touchpoint QR set max brightness failure`,
  TOUCHPOINT_QR_RESTORE_BRIGHTNESS_FAILURE: `${appV2EventPrefix} Touchpoint QR restore brightness failure`,

  // Auth
  REQUEST_OTP_FAILURE: `${appV2EventPrefix} Failed to request OTP`,
  VALIDATE_OTP_FAILURE: `${appV2EventPrefix} Failed to validate OTP`,
  AUTH_ON_SUBMIT_FAILURE: `${appV2EventPrefix} Failed to initiate authentication during onSubmit`,
  AUTO_LOGIN_FROM_URL_FAILURE: `${appV2EventPrefix} Failed to auto login from URL`,
  AUTO_LOGIN_CLEARING_EXISTING_AUTH: `${appV2EventPrefix} Clearing existing auth before auto login`,
  AUTO_LOGIN_CLEAR_AUTH_FAILURE: `${appV2EventPrefix} Failed to clear existing auth before auto login`,
  REQUEST_LOGIN_LINK_FAILURE: `${appV2EventPrefix} Failed to request login link`,
  COGNITO_FIREBASE_SYNC_ERROR: `${appV2EventPrefix} Cognito Firebase sync error`,
  COGNITO_FIREBASE_SYNC_SUCCESS: `${appV2EventPrefix} Cognito Firebase sync success`,
  COGNITO_ONBOARDING_SESSION_RESTORED: `${appV2EventPrefix} Cognito onboarding session restored`,
  COGNITO_SESSION_RESTORED: `${appV2EventPrefix} Cognito session restored`,
  COGNITO_SESSION_RESTORE_ERROR: `${appV2EventPrefix} Cognito session restore error`,
  FIREBASE_LOGOUT_SKIPPED_FOR_COGNITO_ONBOARDING: `${appV2EventPrefix} Firebase logout skipped for Cognito onboarding`,
  COGNITO_SIGN_OUT_ERROR: `${appV2EventPrefix} Cognito sign out error`,
  COGNITO_SIGN_OUT_SUCCESS: `${appV2EventPrefix} Cognito sign out success`,
  COGNITO_TOKEN_FALLBACK_TO_FIREBASE: `${appV2EventPrefix} Cognito token fallback to Firebase`,
  COGNITO_SIGNUP_INITIATED: `${appV2EventPrefix} Cognito signup initiated`,
  COGNITO_SIGNUP_CONFIRMED: `${appV2EventPrefix} Cognito signup confirmed`,
  COGNITO_SIGNUP_FAILED: `${appV2EventPrefix} Cognito signup failed`,
  COGNITO_EMAIL_SIGNUP_INITIATED: `${appV2EventPrefix} Cognito email signup initiated`,
  COGNITO_EMAIL_SIGNUP_FAILED: `${appV2EventPrefix} Cognito email signup failed`,
  COGNITO_OTP_REQUESTED: `${appV2EventPrefix} Cognito OTP requested`,
  COGNITO_OTP_CONFIRMED: `${appV2EventPrefix} Cognito OTP confirmed`,
  COGNITO_MAGIC_LINK_REQUESTED: `${appV2EventPrefix} Cognito magic link requested`,
  COGNITO_MAGIC_LINK_CONFIRMED: `${appV2EventPrefix} Cognito magic link confirmed`,
  COGNITO_MAGIC_LINK_REQUEST_FAILED: `${appV2EventPrefix} Cognito magic link request failed`,
  COGNITO_MAGIC_LINK_FRESH_PAGE_AUTH: `${appV2EventPrefix} Cognito magic link fresh page auth`,
  COGNITO_MAGIC_LINK_FALLBACK_TO_FIREBASE: `${appV2EventPrefix} Cognito magic link fallback to Firebase`,
  FAILED_TO_GET_COGNITO_TOKEN: `${appV2EventPrefix} Failed to get Cognito token`,
  FAILED_TO_REFRESH_COGNITO_TOKEN: `${appV2EventPrefix} Failed to refresh Cognito token`,
  COGNITO_TOKEN_REFRESH_FAILURE_DETAIL: `${appV2EventPrefix} Cognito token refresh failure detail`,
  COGNITO_SIGN_OUT_BEFORE_RETRY: `${appV2EventPrefix} Cognito sign out before retry`,
  COGNITO_SIGN_OUT_INVOKED: `${appV2EventPrefix} Cognito sign out invoked`,
  COGNITO_SYNC_FLOW_STARTED: `${appV2EventPrefix} Cognito sync flow started`,
  COGNITO_SYNC_SIGN_OUT_TRIGGERED: `${appV2EventPrefix} Cognito sync sign out triggered`,
  COGNITO_STARTUP_LOCALSTORAGE_STATE: `${appV2EventPrefix} Cognito startup localStorage state`,
  COGNITO_APP_RESUME_LOCALSTORAGE_STATE: `${appV2EventPrefix} Cognito app resume localStorage state`,
  AUTH_TOKEN_PROACTIVE_REFRESH: `${appV2EventPrefix} Auth token proactive refresh`,
  AUTH_401_RETRY_STARTED: `${appV2EventPrefix} Auth 401 retry started`,
  AUTH_401_RETRY_SUCCESS: `${appV2EventPrefix} Auth 401 retry success`,
  AUTH_401_RETRY_FAILED: `${appV2EventPrefix} Auth 401 retry failed`,
  FAILED_TO_REFRESH_FIREBASE_TOKEN: `${appV2EventPrefix} Failed to refresh Firebase token`,
  FIREBASE_ID_TOKEN_CHANGED_ERROR: `${appV2EventPrefix} Firebase ID token changed listener error`,
  SIGNED_OUT_FROM_FIREBASE: `${appV2EventPrefix} Signed out from Firebase`,
  SIGNED_IN_TO_FIREBASE: `${appV2EventPrefix} Signed in to Firebase`,
  AUTHORIZED_WORKER: `${appV2EventPrefix} Authorized worker`,
  FIREBASE_TOKEN_LISTENER_ATTACHED_AFTER_USER_WAS_AUTHENTICATED: `${appV2EventPrefix} Firebase token listener attached after user was authenticated`,
  FIREBASE_ID_TOKEN_CHANGED: `${appV2EventPrefix} Firebase ID token changed`,
  SPLASH_SCREEN_HIDING_SKIPPED_DUE_TO_AUTH_STATE: `${appV2EventPrefix} Hiding of splash screen skipped because auth state has not loaded`,
  STUCK_AT_SPLASH_SCREEN_DUE_TO_AUTH_STATE: `${appV2EventPrefix} Stuck at splash screen due to auth state`,
  WORKER_INITIALIZATION_SKIPPED: `${appV2EventPrefix} Worker initialization skipped`,
  SPLASH_SCREEN_HIDE_TIMEOUT_SET: `${appV2EventPrefix} Set a timeout to hide splash screen because auth state has loaded`,
  SPLASH_SCREEN_HIDDEN_DUE_TO_AUTH_STATE: `${appV2EventPrefix} Hiding splash screen because auth state has loaded`,
  SESSION_POPULATED_AFTER_LOGIN: `${appV2EventPrefix} Session populated after login`,
  SESSION_POPULATE_AFTER_LOGIN_SKIPPED: `${appV2EventPrefix} Session populate after login, due to user not being authorized`,
  SESSION_POPULATED_AFTER_LOGIN_START_USE_FETCH_AND_INITIALIZE_WORKER: `${appV2EventPrefix} Session populate after login started [fired by useFetchAndInitializeWorker]`, // TODO: remove this event after investigation is complete (Ron Karroll)
  SESSION_POPULATED_AFTER_LOGIN_END_USE_FETCH_AND_INITIALIZE_WORKER: `${appV2EventPrefix} Session populate after login completed [fired by to useFetchAndInitializeWorker]`, // TODO: remove this event after investigation is complete (Ron Karroll)
  ON_LOGGEDOUT_FUNCTION_STARTED: `${appV2EventPrefix} OnLoggedOut function started`, // TODO: remove this event after investigation is complete (Ron_Karroll)
  ON_LOGGEDOUT_FUNCTION_ENDED: `${appV2EventPrefix} OnLoggedOut function ended`, // TODO: remove this event after investigation is complete (Ron Karroll)
  ON_LOGGEDOUT_FUNCTION_ERROR: `${appV2EventPrefix} OnLoggedOut function error`, // TODO: remove this event after investigation is complete (Ron Karroll)
  LEGACY_LOGOUT_FUNCTION_STARTED: `${appV2EventPrefix} OnLoggedOut function started`, // TODO: remove this event after investigation is complete (Ron Karroll)
  LEGACY_LOGOUT_FUNCTION_ENDED: `${appV2EventPrefix} OnLoggedOut function ended`, // TODO: remove this event after investigation is complete (Ron Karroll)
  LEGACY_LOGOUT_FUNCTION_ERROR: `${appV2EventPrefix} OnLoggedOut function error`, // TODO: remove this event after investigation is complete (Ron Karroll)
  POPULATE_SESSION_AFTER_LOGIN_ERROR: `${appV2EventPrefix} populateSessionAfterLogin function error`, // TODO: remove this event after investigation is complete (Ron Karroll)
  FIREBASE_LISTENER_ON_HANDLE_TOKEN_CHANGE_ERROR: `${appV2EventPrefix} Firebase listener on handle token change error`, // TODO: remove this event after investigation is complete (Ron Karroll)
  FIREBASE_LISTENER_HANDLER_ATTACHMENT_ERROR: `${appV2EventPrefix} Firebase listener handler attachment error`, // TODO: remove this event after investigation is complete (Ron Karroll)
  WORKER_INITIALIZATION_START: `${appV2EventPrefix} Worker initialization start`, // TODO: remove this event after investigation is complete (Ron Karroll)
  FIREBASE_CLASS_AUTH_TOKEN_REFRESH_STARTED: `${appV2EventPrefix} Auth Token Refresh Started`, // TODO: remove this event after investigation is complete (Ron Karroll)
  FIREBASE_CLASS_AUTH_TOKEN_REFRESH_SUCCESS: `${appV2EventPrefix} Auth Token Refresh Success`, // TODO: remove this event after investigation is complete (Ron Karroll)
  FIREBASE_CLASS_AUTH_TOKEN_REFRESH_FAILED: `${appV2EventPrefix} Auth Token Refresh Failed`, // TODO: remove this event after investigation is complete (Ron Karroll)
  IS_AUTHENTICATED_IN_FIREBASE_PRIOR_TO_FETCH_AND_INITIALIZE_WORKER: `${appV2EventPrefix} Is authenticated in Firebase prior to fetch and initialize worker`, // TODO: remove this event after investigation is complete (Ron Karroll)
  IS_AUTHORIZED_PRIOR_TO_FETCH_AND_INITIALIZE_WORKER: `${appV2EventPrefix} Is authorized prior to fetch and initialize worker`, // TODO: remove this event after investigation is complete (Ron Karroll)
  AUTH_INVESTIGATION_APP_STATE_CHANGE: `${appV2EventPrefix} Auth investigation app state change`, // TODO: remove this event after investigation is complete (Ron Karroll)
  SET_PREFERRED_PERSISTENCE_FOR_AUTH: `${appV2EventPrefix} Set preferred persistence for auth`,

  // Embedded Token Relay
  EMBEDDED_TOKEN_RESTORATION_STARTED: `${appV2EventPrefix} Embedded Token Restoration Started`,
  EMBEDDED_TOKEN_RESTORATION_SKIPPED_TOKENS_EXIST: `${appV2EventPrefix} Embedded Token Restoration Skipped - Tokens Exist`,
  EMBEDDED_TOKEN_RESTORATION_SUCCESS: `${appV2EventPrefix} Embedded Token Restoration Success`,
  EMBEDDED_TOKEN_RESTORATION_TIMEOUT: `${appV2EventPrefix} Embedded Token Restoration Timeout`,
  EMBEDDED_TOKEN_STORE_SENT: `${appV2EventPrefix} Embedded Token Store Sent`,
  EMBEDDED_TOKEN_CLEAR_SENT: `${appV2EventPrefix} Embedded Token Clear Sent`,

  // Agent
  GET_WORKER_FAILURE: `${appV2EventPrefix} Failed to load agent profile`,
  GET_WORKER_STAGE_FAILURE: `${appV2EventPrefix} Failed to load agent stage`,
  UPDATE_AGENT_PROFILE_FAILURE: `${appV2EventPrefix} Failed to update agent profile`,
  SAVE_AGENT_PREFERENCES_SUCCESS: `${appV2EventPrefix} Saved agent preferences`,
  SAVE_AGENT_PREFERENCES_FAILURE: `${appV2EventPrefix} Failed to load agent preferences`,
  GET_AGENT_PROFILE_PICTURE_FAILURE: `${appV2EventPrefix} Failed to get agent profile picture`,
  UPDATE_AGENT_PROFILE_PICTURE_FAILURE: `${appV2EventPrefix} Failed to update agent profile picture`,
  GET_VERIFICATION_SELFIE_FAILURE: `${appV2EventPrefix} Failed to get verification selfie`,
  GET_AGENT_BY_PHONE_FAILURE: `${appV2EventPrefix} Failed to load agent by phone`,
  POST_AGENT_LOGGED_IN_FAILURE: `${appV2EventPrefix} Failed to save agent logged in`,
  GET_WORKER_SUCCESS: `${appV2EventPrefix} Successfully fetched worker`,
  WORKER_INITIALIZATION_FAILURE: `${appV2EventPrefix} Failed to initialize worker`,
  GET_AGENT_SENT_HOME_CANCELLATION_PAY_PARAMS_FAILURE: `${appV2EventPrefix} Failed to load agent sent home cancellation pay params`,
  GET_AGENT_FRIENDS_FAILURE: `${appV2EventPrefix} Failed to load agent friends`,
  GET_AGENT_FRIEND_REQUESTS_FAILURE: `${appV2EventPrefix} Failed to load agent friend requests`,
  GET_RECENT_COLLEAGUES_FAILURE: `${appV2EventPrefix} Failed to load agent friend requests`,
  GET_SENT_HOME_REQUESTS_FAILURE: `${appV2EventPrefix} Failed to load sent home requests`,
  CREATE_SENT_HOME_REQUESTS_FAILURE: `${appV2EventPrefix} Failed to create sent home requests`,
  GET_OPEN_NEGOTIATIONS_COUNT_FAILURE: `${appV2EventPrefix} Failed to load open negotiations count`,
  GET_RATE_NEGOTIATIONS_LIST_FAILURE: `${appV2EventPrefix} Failed to load rate negotiations list`,
  GET_NEGOTIATION_SHIFT_DETAILS_FAILURE: `${appV2EventPrefix} Failed to load negotiation shift details`,
  RATE_NEGOTIATION_SHIFT_NOT_FOUND: `${appV2EventPrefix} Rate negotiation shift not found`,
  CREATE_NEGOTIATION_FAILURE: `${appV2EventPrefix} Failed to create negotiation`,
  END_NEGOTIATION_FAILURE: `${appV2EventPrefix} Failed to end negotiation`,
  GET_INSTANT_PAY_STATUS_FAILURE: `${appV2EventPrefix} Failed to load instant pay status`,
  GET_SHIFT_SLOTS_V2_FAILURE: `${appV2EventPrefix} Failed to get worker shift slots`,

  // Booking Requests
  GET_BOOKING_REQUESTS_FAILURE: `${appV2EventPrefix} Failed to load booking requests`,
  DELETE_BOOKING_REQUEST_FAILURE: `${appV2EventPrefix} Failed to delete booking request`,
  POST_BOOKING_REQUEST_FAILURE: `${appV2EventPrefix} Failed to create booking request`,

  // News Feed
  GET_NEWS_FEED_ITEMS_FAILURE: `${appV2EventPrefix} Failed to load news feed items`,
  POST_NEWS_FEED_ITEM_FAILURE: `${appV2EventPrefix} Failed to create news feed item`,
  POST_NEWS_FEED_ITEM_COMMENT_FAILURE: `${appV2EventPrefix} Failed to create news feed item comment`,
  POST_NEWS_FEED_ITEM_REACTION_FAILURE: `${appV2EventPrefix} Failed to create news feed item reaction`,
  UNSUPPORTED_NEWS_FEED_EVENT: `${appV2EventPrefix} Attempting to use an unsupported news feed event`,

  // Deep Links
  DEEP_LINK_GENERATION_FAILED: `${appV2EventPrefix} Deep link generation failed`,

  // Payroll
  GET_WORKER_PAYROLL_FAILURE: `${appV2EventPrefix} Failed to load worker payroll`,

  UPDATE_NON_EXISTENT_WORKER: `${appV2EventPrefix} Failed to update worker as it was not fetched yet`,

  // Facility
  GET_FACILITY_PROFILE_FAILURE: `${appV2EventPrefix} Failed to load facility profile`,
  GET_WORKPLACE_FAILURE: `${appV2EventPrefix} Failed to load workplace`,
  GET_FACILITY_PHOTOS_FAILURE: `${appV2EventPrefix} Failed to load facility photos`,
  GET_FACILITY_RATINGS_FAILURE: `${appV2EventPrefix} Failed to load facility ratings`,
  GET_FACILITY_STREET_IMAGE_URL_FAILURE: `${appV2EventPrefix} Failed to load facility Google Maps street image URL`,
  GET_FACILITY_VERIFICATION_PREFERENCES_FAILURE: `${appV2EventPrefix} Failed to load facility verification preferences`,
  GET_SHIFT_SLOTS_FAILURE: `${appV2EventPrefix} Failed to get shift slots`,
  GET_FACILITY_EXCLUSION_FAILURE: `${appV2EventPrefix} Failed to load facility exclusion`,
  GET_WORKPLACES_FAILURE: `${appV2EventPrefix} Failed to load workplaces`,
  GET_FAVORITE_WORKPLACES_FAILURE: `${appV2EventPrefix} Failed to load favorite workplaces`,
  GET_QUALIFIED_WORKPLACES_FAILURE: `${appV2EventPrefix} Failed to load qualified workplaces`,
  ADD_FAVORITE_WORKPLACE_FAILURE: `${appV2EventPrefix} Failed to add favorite workplace`,
  REMOVE_FAVORITE_WORKPLACE_FAILURE: `${appV2EventPrefix} Failed to remove favorite workplace`,
  GET_WORKPLACE_PROFILE_FAILURE: `${appV2EventPrefix} Failed to load workplace profile`,
  GET_WORKPLACE_STATS_FAILURE: `${appV2EventPrefix} Failed to load workplace statistics`,

  // WorkplaceQuiz
  GET_WORKPLACE_QUIZ_FAILURE: `${appV2EventPrefix} Failed to load workplace quiz`,
  GET_WORKPLACE_QUIZ_RESULT_LOGS_FAILURE: `${appV2EventPrefix} Failed to load workplace quiz result logs`,
  SUBMIT_WORKPLACE_QUIZ_FAILURE: `${appV2EventPrefix} Failed to submit workplace quiz`,
  // This is temporary added event for debugging operationally if the quiz feature flag evaluation fails
  UNDEFINED_FACILITY_WHILE_EVALUATING_IS_QUIZ_ENABLED: `${appV2EventPrefix} Undefined facility while evaluating is quiz enabled`,

  // Skills Assessment
  GET_SKILLS_ASSESSMENTS_FAILURE: `${appV2EventPrefix} Failed to load skills assessments`,
  SKILLS_ASSESSMENTS_EVENT_FAILURE: `${appV2EventPrefix} Failed to create skills assessment event`,
  SKILLS_ASSESSMENTS_SCHEDULED_EVENT_FAILURE: `${appV2EventPrefix} Failed to create skills assessment SCHEDULED event`,
  SKILLS_ASSESSMENTS_STARTED_EVENT_FAILURE: `${appV2EventPrefix} Failed to create skills assessment STARTED event`,
  SKILLS_ASSESSMENTS_SUBMITTED_EVENT_FAILURE: `${appV2EventPrefix} Failed to create skills assessment SUBMITTED event`,
  SKILLS_ASSESSMENTS_IFRAME_ERROR: `${appV2EventPrefix} Error in Skills Assessment VideoAsk iframe`,
  SKILLS_ASSESSMENTS_NOTIFICATION_REQUEST_FAILURE: `${appV2EventPrefix} Failed to request skills assessment notification`,
  SKILLS_ASSESSMENTS_CONFIRMED_NOTIFICATION_ISSUE_FAILURE: `${appV2EventPrefix} Failed to confirm skills assessment notification issue`,

  // Missed Punch Requests
  VALIDATE_TIMECARD_FAILURE: `${appV2EventPrefix} Failed to validate timecard`,

  // Facility specs
  // TODO(clipboardhealth.atlassian.net/browse/TX-761): Remove const usage after the complete rollout and flag removal
  GET_FACILITY_SOLVE_UNPAID_WORKED_BREAKS_STAGE: `${appV2EventPrefix} Failed to load facility SolveWorkedUnpaidBreaks stage`,

  // Facility notes
  GET_MANDATORY_BREAK_POLICY_ACKNOWLEDGEMENT_FAILURE: `${appV2EventPrefix} Failed to load mandatory break policy acknowledgement`,
  POST_MANDATORY_BREAK_POLICY_ACKNOWLEDGEMENT_FAILURE: `${appV2EventPrefix} Failed to post mandatory break policy acknowledgement`,
  GET_FACILITY_NOTES_FAILURE: `${appV2EventPrefix} Failed to load facility notes`,

  // Documents
  GET_DISTRIBUTION_URL_FAILURE: `${appV2EventPrefix} Failed to get document url`,
  CONSTRUCT_PDF_FROM_IMAGES_FAILURE: `${appV2EventPrefix} Failed to get create pdf from images`,
  PRESIGNED_URL_UPLOAD_FAILURE: `${appV2EventPrefix} Failed to get presigned url`,
  DOCUMENT_UPLOAD_CAMERA_TAKE_PHOTO_FAILURE: `${appV2EventPrefix} Failed to take photo with camera`,
  DOCUMENT_UPLOAD_CAMERA_TAKE_PHOTO_PERMISSION_DENIED: `${appV2EventPrefix} Permission denied for camera in document upload`,
  DOCUMENT_UPLOAD_MOBILE_FILE_PICKER_FAILURE: `${appV2EventPrefix} Failed to choose file on mobile`,
  DOCUMENT_UPLOAD_BROWSER_FILE_PICKER_FAILURE: `${appV2EventPrefix} Failed to choose file on browser`,
  GET_REJECTED_DOCUMENT_NOTIFICATION_FAILURE: `${appV2EventPrefix} Failed to get rejected document notification`,
  GET_DOCUMENT_ID_FAILURE: `${appV2EventPrefix} Failed to get document id`,
  GET_REQUIREMENT_EXPIRY_FAILURE: `${appV2EventPrefix} Failed to get requirement expiry`,
  CREATE_STRIPE_VERIFICATION_SESSION_FAILURE: `${appV2EventPrefix} Failed to create stripe identity verification session`,
  STRIPE_IDENTITY_VERIFICATION_SESSION_FAILURE: `${appV2EventPrefix} Error during stripe identity session`,
  STRIPE_IDENTITY_WEB_FLOW_ERROR: `${appV2EventPrefix} Error during stripe identity web flow`,
  STRIPE_IDENTITY_FLOW_BEGUN: `${appV2EventPrefix} Stripe Identity Flow Begun`,
  STRIPE_IDENTITY_FLOW_COMPLETED: `${appV2EventPrefix} Stripe Identity Flow Completed`,
  DELETE_DOCUMENT_FAILURE: `${appV2EventPrefix} Error while trying to delete document`,
  CREATE_DOCUMENT_FAILURE: `${appV2EventPrefix} Error while trying to create document`,
  CREATE_SHIFT_SIGNING_OUT_FEEDBACK_FAILURE: `${appV2EventPrefix} Error while trying to create shift signing out feedback`,
  DELETE_DOCUMENT_AFTER_STRIPE_IDENTITY_FAILURE: `${appV2EventPrefix} Error while trying to delete document after stripe failure`,
  STRIPE_IDENTITY_SDK_SESSION_EVENT: `${appV2EventPrefix} Stripe Identity Native SDK Event`,
  STRIPE_IDENTITY_SDK_SESSION_RESULT: `${appV2EventPrefix} Stripe Identity Native SDK Result`,
  MISSING_DOCUMENTS_ALERT_NOTIFY_SUPPORT_FAILURE: `${appV2EventPrefix} Failed to notify support from missing documents alerts`,
  REQUIREMENT_TYPE_DOCUMENTS_COUNT_EVENT: `${appV2EventPrefix} Requirement type documents count event`,
  REQUIREMENT_UNLOCKED_SHIFTS_TRACK_EVENT: `${appV2EventPrefix} Requirement unlocked shifts track event`,
  CREATE_HELLO_SIGN_SESSION_FAILURE: `${appV2EventPrefix} Failed to create hello sign session`,
  UPDATE_HELLO_SIGN_SESSION_FAILURE: `${appV2EventPrefix} Failed to update hello sign session`,
  GET_HELLO_SIGN_SESSION_FAILURE: `${appV2EventPrefix} Failed to get hello sign session`,
  INVALID_COMPOSITE_CONFIGURATION: `${appV2EventPrefix} Invalid composite configuration`,
  DOCUMENT_UPLOAD_MODAL_OPEN_TIME: `${appV2EventPrefix} Document uploading time`,
  HELLO_SIGN_SESSION_STARTED: `${appV2EventPrefix} Hello Sign Session Started`,
  HELLO_SIGN_SIGN_EVENT: `${appV2EventPrefix} Hello Sign Sign Event`,
  HELLO_SIGN_ERROR_EVENT: `${appV2EventPrefix} Hello Sign Error Event`,
  HELLO_SIGN_CANCEL_EVENT: `${appV2EventPrefix} Hello Sign Cancel Event`,
  HELLO_SIGN_READY_EVENT: `${appV2EventPrefix} Hello Sign Ready Event`,
  HELLO_SIGN_SESSION_FALLBACK_TO_POLLING: `${appV2EventPrefix} Hello Sign Session Fallback to Polling`,
  CREATE_ESIGN_WORKFLOW_SESSION_FAILURE: `${appV2EventPrefix} Failed to create esign workflow session`,
  UPDATE_ESIGN_WORKFLOW_SESSION_FAILURE: `${appV2EventPrefix} Failed to update esign workflow session`,
  DOCUMENT_DETAILS_PAGE_NOT_FOUND: `${appV2EventPrefix} Document Details Page Not Found`,
  DOCUMENT_DETAILS_PAGE_WORKER_REQUIREMENT_NOT_FOUND: `${appV2EventPrefix} Document Details Page Worker Requirement Not Found`,
  DOCUMENTS_PAGE_QUALIFICATION_DROPDOWN_CHANGE: `${appV2EventPrefix} Documents Page Qualification Dropdown Change`,
  DOCUMENTS_PAGE_QUALIFICATION_DROPDOWN_SOURCE: `${appV2EventPrefix} Documents Page Qualification Dropdown Source`,
  GET_WORKER_REQUIREMENTS_FAILURE: `${appV2EventPrefix} Failed to load worker requirements`,
  ARCHIVE_DOCUMENT_FAILURE: `${appV2EventPrefix} Failed to archive document`,
  GET_REQUIREMENT_FAILURE: `${appV2EventPrefix} Failed to load requirement`,
  CREATE_TEN99_POLICY_APPLICATION_SESSION_FAILURE: `${appV2EventPrefix} Failed to create 1099 policy application session`,
  GET_TEN99_POLICY_JOBS_FAILURE: `${appV2EventPrefix} Failed to get 1099 policy jobs`,

  // Open Shifts
  GET_OPEN_SHIFT_COUNT_FAILURE: `${appV2EventPrefix} Failed to load open shift count`,
  GET_OPEN_SHIFT_BY_DATE_FAILURE: `${appV2EventPrefix} Failed to load open shift by date`,
  GET_OPEN_SHIFT_MODAL_FAILURE: `${appV2EventPrefix} Failed to load open shift modal`,
  GET_USER_TIMEZONE_FAILURE: `${appV2EventPrefix} Failed to load user timezone`,
  GET_USER_BY_EMAIL_FAILURE: `${appV2EventPrefix} Failed to load user by email`,
  GET_AGENT_SHIFTS_FAILURE: `${appV2EventPrefix} Failed to load agent shifts`,
  WORKER_CALENDAR_STATS: `${appV2EventPrefix} Worker Calendar Stats`,
  GET_MAP_VIEW_FACILITY_OPEN_SHIFT_COUNT_FAILURE: `${appV2EventPrefix} Failed to load map view facility open shift count`,
  GET_FACILITY_VIEW_OPEN_SHIFTS_FAILURE: `${appV2EventPrefix} Failed to load facility view open shifts`,
  GET_LIST_VIEW_OPEN_SHIFTS_FAILURE: `${appV2EventPrefix} Failed to load open shifts for list view`,
  GET_SEARCH_SHIFTS_FAILURE: `${appV2EventPrefix} Failed to load search shifts`,

  // Shift Actions
  POST_CLAIM_SHIFT_FAILURE: `${appV2EventPrefix} Failed to claim shift`,
  POST_MARK_INTEREST_SHIFT_FAILURE: `${appV2EventPrefix} Failed to mark interest for shift`,
  POST_ACCEPT_NEGOTIATION_FAILURE: `${appV2EventPrefix} Failed to accept negotiation`,

  // Shift Auction
  POST_SHIFT_AUCTION_BID_FAILURE: `${appV2EventPrefix} Failed to place shift auction bid`,
  POST_SHIFT_AUCTION_INSTANT_BOOK_FAILURE: `${appV2EventPrefix} Failed to instant book shift auction`,

  // Shift Blast
  SHIFT_BLAST_VISIT_RECORD_FAILURE: `${appV2EventPrefix} Failed to record shift blast visit`,

  // Shift
  GET_SHIFT_STATE_FAILURE: `${appV2EventPrefix} Failed to load shift state`,
  GET_WORKER_SHIFT_FAILURE: `${appV2EventPrefix} Failed to get worker shift`,
  GET_APP_CONFIGURATION_FAILURE: `${appV2EventPrefix} Failed to load shift configuration`,
  UPLOAD_SHIFT_TIMECARD_TO_S3_FAILURE: `${appV2EventPrefix} Failed to upload timecard to AWS S3`,
  UPDATE_SHIFT_TIMECARD_FAILURE: `${appV2EventPrefix} Failed to update shift timecard`,
  CANCEL_SHIFT_FAILURE: `${appV2EventPrefix} Failed to cancel shift`,
  CANCEL_SHIFT_SUCCESS: `${appV2EventPrefix} Shift cancelled successfully`,
  GET_SHIFT_FAILURE: `${appV2EventPrefix} Failed to get shift`,
  GET_SHIFT_FEEDBACK_FAILURE: `${appV2EventPrefix} Failed to get shift feedback`,
  GET_UPCOMING_SHIFTS_FAILURE: `${appV2EventPrefix} Failed to get upcoming shifts for agent`,

  // MyShifts
  GET_NEXT_TWO_DAYS_SHIFTS_FAILURE: `${appV2EventPrefix} Failed to load next two days shifts`,
  GET_FUTURE_SHIFTS_FAILURE: `${appV2EventPrefix} Failed to load future shifts`,

  // Unverified shifts
  GET_UNVERIFIED_SHIFTS_FAILURE: `${appV2EventPrefix} Failed to load unverified shifts`,
  TIMESHEET_PHOTO_UPLOADED: `${appV2EventPrefix} Timesheet Photo Uploaded`,
  CANCEL_TIMESHEET_PHOTO_FORGOTTEN: `${appV2EventPrefix} Timesheet Photo Forgotten`,
  CANCEL_TIMECARD_SENT_ANOTHER_WAY: `${appV2EventPrefix} Timecard Sent Another Way`,
  CANCEL_SHIFT_NOT_ATTENDED: `${appV2EventPrefix} Shift Not Attended`,
  SET_TIMESHEET_AVAILABILITY_FAILURE: `${appV2EventPrefix} Failed to set timesheet availability`,
  UNVERIFIED_SHIFT_ACTION: `${appV2EventPrefix} Unverified Shift Action`,

  // Shift invites
  GET_PENDING_SHIFT_INVITES: `${appV2EventPrefix} Failed to load pending shift invites`,
  GET_PENDING_VISIT_INVITES_FAILURE: `${appV2EventPrefix} Failed to load pending visit invites`,
  GET_WORKER_VISIT_LOCK_STATUS_FAILURE: `${appV2EventPrefix} Failed to load worker visit lock status`,
  GET_SHIFT_INVITE_FAILURE: `${appV2EventPrefix} Failed to load shift invite`,
  ACCEPT_OR_DECLINE_SHIFT_INVITE: `${appV2EventPrefix} Failed to accept/decline shift invite`,
  ACCEPT_OVERWORKING_SHIFT_INVITE: `${appV2EventPrefix} Accepting overworking shift invite`,
  SHIFT_INVITE_SCHEMA_VALIDATION_ERROR: `${appV2EventPrefix} API Zod Schema validation error`,
  SHIFT_INVITE_BANNER_CLICK: `${appV2EventPrefix} Shift Invite banner click`,
  SHIFT_INVITE_PENDING_COUNT_CLICK: `${appV2EventPrefix} Shift Invite pending count click`,
  SHIFT_INVITE_ERROR: `${appV2EventPrefix} Shift Invite error`,
  SHIFT_INVITE_CONFLICTING_SHIFT_FOUND: `${appV2EventPrefix} Shift Invite conflicting shift found`,
  FAILURE_TO_ACCEPT_SHIFT_INVITE_STARTING_SOON_BECAUSE_OF_BACKGROUND_CHECK: `${appV2EventPrefix} Failure to accept shift invite starting soon without a valid background check`,
  SHIFT_INVITE_NOT_FOUND: `${appV2EventPrefix} Shift invite not found or deleted`,

  // GCP
  POST_SIGN_URL_FAILURE: `${appV2EventPrefix} Failed to sign url for GCP`,

  // Google Places Autocomplete
  GET_ADDRESS_INCOMPLETE_DATA_FAILURE: `${appV2EventPrefix} Failed to get complete address from Places Autocomplete`,

  // Reviews
  GET_REVIEW_QUESTIONNAIRE_FAILURE: `${appV2EventPrefix} Failed to load review questions`,
  POST_REVIEW_FAILURE: `${appV2EventPrefix} Failed to post the review`,
  POST_COMMENT_FAILURE: `${appV2EventPrefix} Failed to post the comment`,
  PATCH_COMMENT_FAILURE: `${appV2EventPrefix} Failed to patch the comment`,
  DELETE_COMMENT_FAILURE: `${appV2EventPrefix} Failed to delete the comment`,
  POST_RATING_FAILURE: `${appV2EventPrefix} Failed to post the rating`,
  GET_RATING_AGGREGATES_FAILURE: `${appV2EventPrefix} Failed to get rating aggregates`,
  GET_MULTIPLE_CHOICE_AGGREGATES_FAILURE: `${appV2EventPrefix} Failed to get multiple choice aggregates`,
  GET_THREAD_AGGREGATES_FAILURE: `${appV2EventPrefix} Failed to get thread aggregates`,
  GET_REVIEW_COMMENTS_FAILURE: `${appV2EventPrefix} Failed to get review comments`,
  POST_COMMENT_REACTION: `${appV2EventPrefix} Failed to post comment reaction`,
  GET_COMPARISON_PAIR_FAILURE: `${appV2EventPrefix} Failed to get comparison pair`,
  POST_WORKPLACE_COMPARISON_FAILURE: `${appV2EventPrefix} Failed to post workplace comparison`,
  DELETE_COMMENT_REACTION: `${appV2EventPrefix} Failed to delete comment reaction`,
  GET_WORKPLACE_WORKERS_SHIFTS_FAILURE: `${appV2EventPrefix} Failed to get workplace worker shifts`,
  REVIEWS_TAG_SCREEN_ERROR: `${appV2EventPrefix} Failed to tag reviews screen`,
  GET_REVIEW_COMMENT_FAILURE: `${appV2EventPrefix} Failed to get review comments`,
  // Worker
  UPDATE_AGENT_DATA_FAILURE: `${appV2EventPrefix} Failed to update agent data`,

  // Worker Availability
  GET_AVAILABILITIES_API_FAILURE: `${appV2EventPrefix} Failed to load availabilities`,
  PUT_AVAILABILITIES_API_FAILURE: `${appV2EventPrefix} Failed to save availabilities`,

  // Requirement Status
  GET_REQUIREMENT_STATUS_FAILURE: `${appV2EventPrefix} Failed to load requirement status`,

  // Checkr Application
  GET_CHECKR_APPLICATION_STATUS_FAILURE: `${appV2EventPrefix} Failed to load checkr application status`,
  RESEND_CHECKR_INVITATION_FAILURE: `${appV2EventPrefix} Failed to resend checkr invitation`,
  SEND_ONBOARDING_CHECKR_INVITATION_FAILURE: `${appV2EventPrefix} Failed to send onboarding checkr invite`,

  // Documents
  GET_FILTERED_DOCUMENTS_FAILURE: `${appV2EventPrefix} Failed to load filtered documents`,
  GET_MISSING_REQUIREMENTS_BY_DATE_FAILURE: `${appV2EventPrefix} Failed to load missing requirements by date`,

  // Professional References
  GET_PROFESSIONAL_REFERENCES_FAILURE: `${appV2EventPrefix} Failed to load professional references`,
  GET_PROFESSIONAL_REFERENCE_FAILURE: `${appV2EventPrefix} Failed to load professional reference`,
  CREATE_PROFESSIONAL_REFERENCE_FAILURE: `${appV2EventPrefix} Failed to create professional reference`,
  SHARE_PROFESSIONAL_REFERENCE_FAILURE: `${appV2EventPrefix} Failed to share professional reference`,
  CREATE_PROFESSIONAL_REFERENCE_ERROR: `${appV2EventPrefix} Create professional reference error`,

  // Workplace Referrals
  GET_WORKPLACE_REFERRAL_STATS_FAILURE: `${appV2EventPrefix} Failed to load workplace referral stats`,
  GET_WORKPLACE_REFERRALS_FAILURE: `${appV2EventPrefix} Failed to load workplace referrals`,

  // Worker to Worker Referrals
  GET_WORKER_REFERRAL_BONUSES_FAILURE: `${appV2EventPrefix} Failed to load worker to worker referral bonuses`,
  GET_WORKER_REFERRAL_PROFILE_FAILURE: `${appV2EventPrefix} Failed to load worker referral profile`,
  SHARE_REFERRAL_CODE_ERROR: `${appV2EventPrefix} Failed to complete sharing worker to worker referral code`,

  // WorkerReferrals
  POST_SHARE_YOUR_PROFILE_FAILURE: `${appV2EventPrefix} Failed to share your profile`,
  GET_WORKER_REFERRAL_CODE_FAILURE: `${appV2EventPrefix} Failed to get worker referral code`,
  POST_WORKER_REFERRAL_CODE_FAILURE: `${appV2EventPrefix} Failed to create worker referral code`,

  GET_AGENT_STATS_FAILURE: `${appV2EventPrefix} Failed to get agent stats`,

  // Work With Friends
  GET_WORKER_FRIEND_LINK_FAILURE: `${appV2EventPrefix} Failed to load worker friend link`,
  GET_WORKER_FRIEND_SETTINGS_FAILURE: `${appV2EventPrefix} Failed to load worker friend settings`,
  GET_INVITE_FRIEND_LINK_FAILURE: `${appV2EventPrefix} Failed to load invite friend link`,
  // Urgent Shifts
  GET_URGENT_SHIFTS_FAILURE: `${appV2EventPrefix} Failed to load urgent shifts`,
  GET_CHECK_ATTENDANCE_V1_FAILURE: `${appV2EventPrefix} Failed to check attendance v1`,
  POST_CONFIRM_ATTENDANCE_FAILURE: `${appV2EventPrefix} Failed to confirm attendance`,
  UPDATE_YOUR_ETA_FAILURE: `${appV2EventPrefix} Failed to update the ETA for shift`,

  UPDATE_ETA_BOTTOM_SHEET_ERROR: `${appV2EventPrefix} Update ETA Bottom Sheet Error`,

  // Referrals
  GET_REFERRALS_ELIGIBILITY_FAILURE: `${appV2EventPrefix} Failed to get referrals eligibility`,
  GET_REFERRALS_ELIGIBILITY_V2_FAILURE: `${appV2EventPrefix} Failed to get referrals eligibility v2`,
  REFERRAL_CODE_REDEEM_FAILURE: `${appV2EventPrefix} Failed to redeem referral code`,
  GET_REFERRALS_FAILURE: `${appV2EventPrefix} Failed to get referrals`,

  // Location
  GET_DISTANCE_BETWEEN_TWO_GEOLOCATIONS_FAILURE: `${appV2EventPrefix} Failed to get distance between two geolocations`,
  LOCATION_VERIFICATION_CHECK_FAILURE: `${appV2EventPrefix} Location Verification Check failed`,
  GET_DEVICE_GEOLOCATION_IF_ALLOWED_FAILURE: `${appV2EventPrefix} Get Device GeoLocation Failed`,
  IS_DEVICE_LOCATION_PERMISSION_GRANTED_FAILURE: `${appV2EventPrefix} Get Is Device Location Permission Granted Failed`,
  SKIP_ALWAYS_ALLOW_DEVICE_SETTING_CHECK: `${appV2EventPrefix} Get Is Device Location Permission Granted Failed`,
  HANDLE_COMMUTE_TOPIC_SUBSCRIPTION_FAILURE: `${appV2EventPrefix} Handle Commute Topic Subscription Failed`,
  TRIP_TRACKING_STOPPED: `${appV2EventPrefix} Trip Tracking Stopped`,
  TRIP_TRACKING_STARTED: `${appV2EventPrefix} Trip Tracking Started`,
  TRIP_TRACKING_ERROR: `${appV2EventPrefix} Trip Tracking Error`,
  TRIP_TRACKING_NOT_CALLED: `${appV2EventPrefix} Trip Tracking Not Called`,
  GET_ROUTE_ESTIMATES_FAILURE: `${appV2EventPrefix} Get Route Estimates Failure`,
  ARRIVAL_TIME_UNAVAILABLE: `${appV2EventPrefix} Arrival Time Unavailable`,
  SHIFT_DETAILS_ROUTE_ESTIMATE_UNAVAILABLE: `${appV2EventPrefix} Shift Details Route Estimate Unavailable`,

  GET_WORKER_TRIPS_FAILURE: `${appV2EventPrefix} Failed to load worker trips`,

  WORKER_LEFT_EARLY: `${appV2EventPrefix} Worker Left Early`,
  WORKER_DEPARTURE_UPDATE_FAILURE: `${appV2EventPrefix} Worker Departure Update Failure`,
  WORKER_UPDATED_LOCATION_SETTINGS: `${appV2EventPrefix} Worker Updated Location Settings`,
  LOCATION_ACCURACY_ERROR: `${appV2EventPrefix} Error while getting the location accuracy status`,
  HYPER_TRACK_TRIAL_ENABLED: `${appV2EventPrefix} HyperTrack Trial Enabled`,
  HYPER_TRACK_INIT_SUCCESS: `${appV2EventPrefix} HyperTrack Init Success`,
  HYPER_TRACK_INIT_FAILURE: `${appV2EventPrefix} HyperTrack Init Failure`,
  HYPER_TRACK_RESET_SUCCESS: `${appV2EventPrefix} HyperTrack Reset Success`,
  HYPER_TRACK_RESET_FAILURE: `${appV2EventPrefix} HyperTrack Reset Failure`,
  HYPER_TRACK_TRIP_TRACKING_STARTED: `${appV2EventPrefix} HyperTrack Trip Tracking Started`,
  HYPER_TRACK_TRIP_TRACKING_FAILED: `${appV2EventPrefix} HyperTrack Trip Tracking Failed`,
  HYPER_TRACK_GEOFENCE_CHECK: `${appV2EventPrefix} HyperTrack Geofence Check`,
  HYPER_TRACK_GEOFENCE_CHECK_SUCCEEDED: `${appV2EventPrefix} HyperTrack Geofence Check Succeeded`,
  HYPER_TRACK_GEOFENCE_CHECK_FAILED: `${appV2EventPrefix} HyperTrack Geofence Check Failed`,
  FALLBACK_GEOFENCE_CHECK: `${appV2EventPrefix} Fallback Geofence Check Succeeded`,
  FALLBACK_GEOFENCE_CHECK_SUCCEEDED: `${appV2EventPrefix} Fallback Geofence Check Succeeded`,
  FALLBACK_GEOFENCE_CHECK_FAILED: `${appV2EventPrefix} Fallback Geofence Check Failed`,
  ERROR_FETCHING_PREVIOUS_LOCATION_PERMISSION: `${appV2EventPrefix} Error fetching previous location permission`,
  ERROR_SUBMITTING_SHIFT_TIME_SHEET: `${appV2EventPrefix} Error submitting shift time sheet`,
  URGENT_SHIFTS_UPDATE_LOCATION_ERROR: `${appV2EventPrefix} Location Permission Update Error`,
  SHIFT_ARRIVAL_TIME_BOTTOM_SHEET_ERROR_VIEWED: `${appV2EventPrefix} Shift Arrival Time Bottom Sheet Error Viewed`,

  // Chat
  ZENDESK_CHAT_OPENED: `${appV2EventPrefix} Opened Zendesk Chat`,
  GET_CHAT_CHANNELS_FAILURE: `${appV2EventPrefix} Failed to get chat channels`,
  BACKFILL_FRIEND_CHAT_FAILURE: `${appV2EventPrefix} Failed to backfill friend chat`,
  CHILDCARE_SUPPORT_CHAT_CREATED: `${appV2EventPrefix} Childcare support chat created`,
  CHILDCARE_SUPPORT_CHAT_EXITED: `${appV2EventPrefix} Childcare support chat exited`,
  CHILDCARE_SUPPORT_CHAT_CREATION_FAILED: `${appV2EventPrefix} Childcare support chat creation failed`,
  CHILDCARE_SUPPORT_CHAT_MODAL_VIEWED: `${appV2EventPrefix} Childcare support chat modal viewed`,
  CHILDCARE_SUPPORT_CHAT_MODAL_OPEN_TAPPED: `${appV2EventPrefix} Childcare support chat zendesk conversation opened`,
  SMOOCH_CHAT_READY: `${appV2EventPrefix} Smooch chat ready`,
  SMOOCH_CONVERSATION_ADDED: `${appV2EventPrefix} Smooch conversation added`,
  SMOOCH_CHAT_CONNECTED: `${appV2EventPrefix} Smooch chat connected`,
  SEND_MESSAGE_TO_WORKPLACE_FAILURE: `${appV2EventPrefix} Failed to send message to workplace`,
  SHIFT_INVITE_REQUEST_MESSAGE_RENDER_FAILURE: `${appV2EventPrefix} Failed to render shift invite request message`,
  GROUP_SHIFT_INVITE_REQUEST_MESSAGE_RENDER_FAILURE: `${appV2EventPrefix} Failed to render group shift invite request message`,
  SHIFT_TIME_PROPOSAL_MESSAGE_RENDER_FAILURE: `${appV2EventPrefix} Failed to render shift time proposal message`,
  SHARED_CREDENTIALS_MESSAGE_RENDER_FAILURE: `${appV2EventPrefix} Failed to render shared credentials message`,
  VISIT_INVITE_REQUEST_MESSAGE_RENDER_FAILURE: `${appV2EventPrefix} Failed to render visit invite request message`,
  INPUT_ETA_MESSAGE_RENDER_FAILURE: `${appV2EventPrefix} Failed to render input eta message`,

  // Shift bookability
  GET_BOOKABILITY_STATUS_FAILURE: `${appV2EventPrefix} Failed to load bookability status`,
  SHIFT_BLOCKED_CRITERIA_FAILURE: `${appV2EventPrefix} Shift Bookability Unmet Criteria Failure`,
  GET_PAGINATED_BOOKABILITY_STATUS_FAILURE: `${appV2EventPrefix} Failed to load paginated bookability status`,
  SHIFT_BLOCKED_DUE_TO_EMPTY_MISSING_DOCUMENTS: `${appV2EventPrefix} Shift blocked due to empty missing documents`,
  PRE_BOOKING_STATE_CHECKED: `${appV2EventPrefix} Pre Booking State Checked`,
  HOUR_RESTRICTION_CONFLICT_CHECK_DATE_RANGE_ERROR: `${appV2EventPrefix} UseHourRestrictionConflictData Invalid Date Range`,

  // Mandatory breaks
  GET_EXTRA_WORKED_TIME_REQUESTS_FAILURE: `${appV2EventPrefix} Failed to get extra worked time request`,
  PATCH_EXTRA_WORKED_TIME_REQUEST_METADATA_FAILURE: `${appV2EventPrefix} Failed to patch extra worked time request metadata`,
  CREATE_FULL_SHIFT_EXTRA_WORKED_TIME_REQUEST_FAILURE: `${appV2EventPrefix} Failed to create full shift extra worked time request`,
  GET_PROVISIONAL_FULL_SHIFT_EXTRA_WORKED_TIME_REQUEST_FAILURE: `${appV2EventPrefix} Failed to get provisional full shift extra worked time request`,
  PATCH_FULL_SHIFT_EXTRA_WORKED_TIME_REQUEST_FAILURE: `${appV2EventPrefix} Failed to patch full shift extra worked time request`,

  // Zendesk
  ZENDESK_LOGIN_ERROR: `${appV2EventPrefix} Zendesk login error`,

  // Shift Invite
  SHIFT_INVITE_IN_CHAT: `${appV2EventPrefix} Shift Invite In Chat`,

  // Licenses
  GET_LICENSES_FAILURE: `${appV2EventPrefix} Failed to load licenses`,
  GET_LICENSES_COUNT_FAILURE: `${appV2EventPrefix} Failed to load licenses count`,
  GET_LICENSE_DETAILS_FAILURE: `${appV2EventPrefix} Failed to load license details`,
  ARCHIVE_LICENSE_FAILURE: `${appV2EventPrefix} Failed to archive license`,
  ADD_LICENSE_FAILURE: `${appV2EventPrefix} Failed to add license`,

  // Shift Blocks
  GET_SHIFT_BLOCK_FAILURE: `${appV2EventPrefix} Failed to load shift block`,
  UPDATE_SHIFT_BLOCK_FAILURE: `${appV2EventPrefix} Failed to update shift block`,
  GET_WORKER_PREFERRED_STATUS_FAILURE: `${appV2EventPrefix} Failed to get worker's preferred status`,
  REQUEST_TO_BOOK_SHIFT_BLOCK_FAILURE: `${appV2EventPrefix} Failed to request to book shift block`,
  POST_CREATE_CHAT_CHANNEL_FAILURE: `${appV2EventPrefix} Failed to create chat channel`,

  // Qualifications
  GET_QUALIFICATIONS_FAILURE: `${appV2EventPrefix} Failed to get qualifications`,
  QUALIFICATION_CATEGORY_ENTRY_NOT_FOUND: `${appV2EventPrefix} Qualification category entry not found`,

  // Cancelled shift details
  GET_CANCELLED_SHIFT_DETAILS_FAILURE: `${appV2EventPrefix} Failed to load cancelled shift details`,

  // Attendance score
  GET_ATTENDANCE_SCORE_HISTORY: `${appV2EventPrefix} Failed to load agent recent attendance score history`,
  GET_ATTENDANCE_SCORE_PROFILE: `${appV2EventPrefix} Failed to load agent attendance score profile`,

  // Account deletion
  REQUEST_ACCOUNT_DELETION_FAILURE: `${appV2EventPrefix} Failed to request account deletion`,
  CREATE_ACCOUNT_REACTIVATION_REQUEST_FAILURE: `${appV2EventPrefix} Failed to create account reactivation request`,
  EDIT_ACCOUNT_REACTIVATION_REQUEST_FAILURE: `${appV2EventPrefix} Failed to edit account reactivation request`,

  // Pdf viewer
  PDF_LIBRARY_SETUP_FAILURE: `${appV2EventPrefix} Failed to setup pdf.js library`,
  PDF_LOAD_FAILURE: `${appV2EventPrefix} Failed to load pdf`,
  PDF_LOAD_SUCCESS: `${appV2EventPrefix} Successfully loaded pdf`,
  PDF_DOWNLOAD_FAILURE: `${appV2EventPrefix} Failed to download pdf`,
  PDF_DOWNLOADED: `${appV2EventPrefix} Pdf downloaded`,
  PDF_PLATFORM_CHECK_FAILURE: `${appV2EventPrefix} Failed to check pdf platform`,
  PDF_PLATFORM_UNSUPPORTED_ONBOARDING: `${appV2EventPrefix} Pdf platform is unsupported at onboarding`,

  // Contractor Badge
  INDEPENDENT_CONTRACTOR_BADGE_SHARED: `${appV2EventPrefix} Independent contractor badge shared`,
  INDEPENDENT_CONTRACTOR_BADGE_OPENED: `${appV2EventPrefix} Independent contractor badge opened`,
  INDEPENDENT_CONTRACTOR_BADGE_GENERATION_FAILURE: `${appV2EventPrefix} Independent contractor badge generation failure`,
  INDEPENDENT_CONTRACTOR_BADGE_IMAGE_UPLOAD_SUCCESS: `${appV2EventPrefix} Independent contractor badge image upload success`,
  INDEPENDENT_CONTRACTOR_BADGE_IMAGE_UPLOAD_FAILURE: `${appV2EventPrefix} Independent contractor badge image upload failure`,
  INDEPENDENT_CONTRACTOR_BADGE_FETCH_IMAGE_FAILURE: `${appV2EventPrefix} Independent contractor badge fetch image failure`,
  INDEPENDENT_CONTRACTOR_BADGE_FETCH_FAILURE: `${appV2EventPrefix} Independent contractor badge fetch failure`,
  INDEPENDENT_CONTRACTOR_BADGE_TAKE_PHOTO_EMPTY_IMAGE: `${appV2EventPrefix} Independent contractor badge take photo empty image`,
  INDEPENDENT_CONTRACTOR_BADGE_TAKE_PHOTO_FAILURE: `${appV2EventPrefix} Independent contractor badge take photo failure`,
  INDEPENDENT_CONTRACTOR_BADGE_SAVE_BADGE_FAILURE: `${appV2EventPrefix} Independent contractor badge save badge failure`,
  INDEPENDENT_CONTRACTOR_BADGE_TAKE_PHOTO_CROPPING_FAILURE: `${appV2EventPrefix} Independent contractor badge take photo cropping failure`,
  INDEPENDENT_CONTRACTOR_BADGE_SAVE_AND_DOWNLOAD_TAPPED: `${appV2EventPrefix} Independent contractor badge save and download tapped`,
  INDEPENDENT_CONTRACTOR_BADGE_SAVE_AND_DOWNLOAD_SUCCESS: `${appV2EventPrefix} Independent contractor badge save and download success`,

  // NFC
  NFC_HASH_VALIDATION_REQUEST_FAILED: `${appV2EventPrefix} NFC hash validation request failed`,
  NFC_HASH_VALIDATION_REQUEST_SUCCEEDED: `${appV2EventPrefix} NFC hash validation request succeeded`,
  NFC_HASH_VALIDATION_ERROR: `${appV2EventPrefix} NFC hash validation error`,
  NFC_HASH_READ_FAILED: `${appV2EventPrefix} NFC hash read failed`,
  NFC_SCAN_WARNING: `${appV2EventPrefix} NFC scan warning`,
  NFC_SCAN_FAILED_UNEXPECTEDLY: `${appV2EventPrefix} NFC scan failed unexpectedly`,
  DISABLE_NFC_CHECK_FAILED: `${appV2EventPrefix} disable NFC check failed`,
  DISABLE_NFC_CHECK_ACCOUNT_LOG_FAILED: `${appV2EventPrefix} disable NFC check account log failed`,
  NFC_ATTACH_RESUME_LISTENER_FAILED: `${appV2EventPrefix} NFC attach resume listener failed`,

  // Agreements
  GET_SIGNED_AGREEMENTS_FAILURE: `${appV2EventPrefix} Failed to get signed agreements`,
  GET_AGREEMENTS_FAILURE: `${appV2EventPrefix} Failed to get agreements`,
  SEND_AGREEMENT_EMAIL_FAILURE: `${appV2EventPrefix} Failed to send agreement email`,
  SEND_JOB_SEARCH_AGREEMENT_EMAIL_FAILURE: `${appV2EventPrefix} Failed to send job search agreement email`,

  // Sign new agreement
  SIGN_NEW_AGREEMENT_FAILURE: `${appV2EventPrefix} Failed to sign new agreement`,
  SIGN_NEW_AGREEMENT_SUCCESS: `${appV2EventPrefix} Successfully signed new agreement`,
  SIGN_NEW_AGREEMENT_MODAL_VIEW: `${appV2EventPrefix} Viewed sign new agreement modal`,

  CONTRACTOR_AGREEMENT_RE_SIGNING_VIEWED: `${appV2EventPrefix} Contractor agreement re-signing viewed`,
  CONTRACTOR_AGREEMENT_RE_SIGNING_COMPLETED: `${appV2EventPrefix} Contractor agreement re-signing completed`,

  // Proof of Earnings
  POST_SEND_PROOF_OF_EARNINGS_EMAIL_FAILURE: `${appV2EventPrefix} Failed to send proof of earnings email`,

  // Debit Card Expiration Status
  GET_EXTERNAL_PAYMENT_ACCOUNTS_FAILURE: `${appV2EventPrefix} Failed to get external payment accounts`,

  // Debug
  USER_SIGN_OUT_INTERRUPTED: `${appV2EventPrefix} User was automatically signing out, but auth state has changed`,
  SCREEN_ORIENTATION_LOCK_FAILED: `${appV2EventPrefix} Screen Orientation Lock Failed`,

  // Rankings
  GET_WORKER_RANKINGS_FAILURE: `${appV2EventPrefix} Failed to get worker rankings`,

  // Shift Access Windows
  GET_SHIFT_ACCESS_WINDOWS_FAILURE: `${appV2EventPrefix} Failed to get shift access windows`,

  // Placement Candidate
  GET_PLACEMENT_CANDIDATE_FAILURE: `${appV2EventPrefix} Failed to get placement candidate`,
  CREATE_OR_GET_PLACEMENT_CANDIDATE_FAILURE: `${appV2EventPrefix} Failed to create or get placement candidate`,
  UPDATE_PLACEMENT_CANDIDATE_FAILURE: `${appV2EventPrefix} Failed to update placement candidate`,
  PLACEMENT_CANDIDATE_RESUME_UPLOAD_FAILURE: `${appV2EventPrefix} Failed to upload placement candidate resume`,
  PLACEMENT_CANDIDATE_RESUME_CREATE_FAILURE: `${appV2EventPrefix} Failed to create placement candidate resume`,
  PLACEMENT_CANDIDATE_PAGE_VIEWED: `${appV2EventPrefix} Placement candidate page viewed`,
  PLACEMENT_CANDIDATE_STATUS_UPDATED: `${appV2EventPrefix} Placement candidate status updated`,
  PLACEMENT_CANDIDATE_JOB_PREFERENCES_SUBMITTED: `${appV2EventPrefix} Placement candidate job preferences submitted`,
  PLACEMENT_CANDIDATE_VIDEOASK_SUBMITTED: `${appV2EventPrefix} Placement candidate videoask submitted`,
  PLACEMENT_CANDIDATE_VIDEOASK_VIA_BROWSER_CLICKED: `${appV2EventPrefix} Placement candidate videoask via browser clicked`,
  PLACEMENT_CANDIDATE_REQUIREMENTS_REUPLOAD_CLICKED: `${appV2EventPrefix} Placement candidate requirements reupload clicked`,
  PLACEMENT_CANDIDATE_RESUME_UPLOADED: `${appV2EventPrefix} Placement candidate resume uploaded`,
  PLACEMENT_CANDIDATE_CREATE_RESUME_CLICKED: `${appV2EventPrefix} Placement candidate create resume clicked`,
  PLACEMENT_CANDIDATE_CREATE_RESUME_FORM_DISCARDED: `${appV2EventPrefix} Placement candidate create resume form discarded`,
  PLACEMENT_CANDIDATE_RESUME_CREATED: `${appV2EventPrefix} Placement candidate resume created`,
  PLACEMENT_CANDIDATE_RESUME_DELETED: `${appV2EventPrefix} Placement candidate resume deleted`,
  PLACEMENT_CANDIDATE_PROFILE_UPDATE_CLICKED: `${appV2EventPrefix} Placement candidate profile update clicked`,
  PLACEMENT_CANDIDATE_CHAT_ACTION: `${appV2EventPrefix} Placement candidate chat action`,
  PLACEMENT_CANDIDATE_RESUME_UPLOAD_INVALID_FILE_TYPE: `${appV2EventPrefix} Placement candidate resume upload invalid file type`,
  PLACEMENT_MARKETING_LINK_CLICKED: `${appV2EventPrefix} Placement marketing link clicked`,
  PLACEMENT_CANDIDATE_PROFILE_PHOTO_UPDATE_CLICKED: `${appV2EventPrefix} Placement candidate profile photo update clicked`,
  PLACEMENT_CANDIDATE_PROFILE_PHOTO_UPLOADED: `${appV2EventPrefix} Placement candidate profile photo uploaded`,
  PLACEMENT_CANDIDATE_PROFILE_PHOTO_UPLOAD_FAILURE: `${appV2EventPrefix} Placement candidate profile photo upload failure`,
  PLACEMENT_CANDIDATE_JOBS_TAB_SWITCHED: `${appV2EventPrefix} Placement candidate jobs tab switched`,
  GET_PLACEMENT_CANDIDATE_BAN_FAILURE: `${appV2EventPrefix} Failed to load placement candidate ban`,

  PLACEMENT_CANDIDATE_STARTED_INITIAL_ONBOARDING: `${appV2EventPrefix} Placement candidate started initial onboarding`,
  PLACEMENT_CANDIDATE_INITIAL_ONBOARDING: `${appV2EventPrefix} Placement candidate initial onboarding`,

  PLACEMENT_SIGN_ON_BONUS_BANNER_VIEWED: `${appV2EventPrefix} Placement sign-on bonus banner viewed`,
  PLACEMENT_GET_A_JOB_MODAL_VIEWED: `${appV2EventPrefix} Placement get a job modal viewed`,
  PLACEMENT_GET_A_JOB_MODAL_SUBMITTED: `${appV2EventPrefix} Placement get a job modal submitted`,
  PLACEMENT_RESTRICTED_ACCESS_BANNER_VIEWED: `${appV2EventPrefix} Placement restricted access banner viewed`,
  PLACEMENT_RESTRICTED_ACCESS_BANNER_LEARN_MORE_CLICKED: `${appV2EventPrefix} Placement restricted access banner learn more clicked`,
  PLACEMENT_RESTRICTED_ACCESS_BANNER_CONTACT_SUPPORT_CLICKED: `${appV2EventPrefix} Placement restricted access banner contact support clicked`,
  PLACEMENT_RESTRICTED_ACCESS_BANNER_DISPUTE_CLICKED: `${appV2EventPrefix} Placement restricted access banner dispute clicked`,
  DISPUTE_BAN_SUBMITTED: `${appV2EventPrefix} Dispute ban submitted`,
  DISPUTE_BAN_SUBMITTED_FAILURE: `${appV2EventPrefix} Dispute ban submitted failure`,
  DISPUTE_BAN_CLOSED: `${appV2EventPrefix} Dispute ban closed`,

  INTERVIEW_ATTENDANCE_VERIFICATION_SUBMITTED: `${appV2EventPrefix} Interview attendance verification submitted`,
  INTERVIEW_ATTENDANCE_VERIFICATION_SUBMITTED_FAILURE: `${appV2EventPrefix} Interview attendance verification submitted failure`,
  INTERVIEW_ATTENDANCE_VERIFICATION_OPENED: `${appV2EventPrefix} Interview attendance verification opened`,
  INTERVIEW_ATTENDANCE_VERIFICATION_CLOSED: `${appV2EventPrefix} Interview attendance verification closed`,

  PLACEMENT_FAVORITED: `${appV2EventPrefix} Placement favorited`,
  PLACEMENT_FAVORITED_FAILURE: `${appV2EventPrefix} Placement favorited failure`,
  PLACEMENT_UNFAVORITED: `${appV2EventPrefix} Placement unfavorited`,
  PLACEMENT_UNFAVORITED_FAILURE: `${appV2EventPrefix} Placement unfavorited failure`,
  GET_WORKER_FAVORITE_PLACEMENTS_FAILURE: `${appV2EventPrefix} Failed to get worker favorite placements`,

  // Fill Machine
  FILL_MACHINE_LINK_CLICKED: `${appV2EventPrefix} Fill machine link clicked`,

  // Placement
  GET_PLACEMENT_FAILURE: `${appV2EventPrefix} Failed to load placement`,
  GET_PLACEMENT_WORKPLACES_FAILURE: `${appV2EventPrefix} Failed to load placement workplaces`,
  GET_PLACEMENT_PAY_FAILURE: `${appV2EventPrefix} Failed to load pay transparency data`,
  GET_TAG_FAILURE: `${appV2EventPrefix} Failed to load tags`,
  PLACEMENT_APPLICATION_CREATE_FAILURE: `${appV2EventPrefix} Failed to create placement application`,

  // External Application
  EXTERNAL_APPLICATION_DIALOG_CLOSED: `${appV2EventPrefix} External application dialog closed`,
  EXTERNAL_APPLICATION_DIALOG_APPLIED: `${appV2EventPrefix} External application dialog applied`,
  EXTERNAL_APPLICATION_DIALOG_DID_NOT_APPLY: `${appV2EventPrefix} External application dialog did not apply`,
  EXTERNAL_APPLICATION_CONFIRMATION_DIALOG_ACK: `${appV2EventPrefix} External application confirmation dialog acknowledge`,
  APPLY_FOR_CANDIDATE_DIALOG_ACTIONS: `${appV2EventPrefix} Apply for candidate actions`,

  PLACEMENTS_PAGE_VIEWED: `${appV2EventPrefix} Placements page viewed`,
  PLACEMENTS_PAGE_ACTIONS: `${appV2EventPrefix} Placements page actions`,
  PLACEMENT_CARD_VIEWED: `${appV2EventPrefix} Placement card viewed`,
  PLACEMENT_DETAILS_PAGE_VIEWED: `${appV2EventPrefix} Placement details page viewed`,
  PLACEMENT_DETAILS_PAGE_ACTIONS: `${appV2EventPrefix} Placement details page actions`,
  PLACEMENT_PRIMARY_CTA_CLICKED: `${appV2EventPrefix} Placement primary cta clicked`,
  PLACEMENT_PAY_AND_SCHEDULE_FORM_ACTIONS: `${appV2EventPrefix} Placement pay and schedule form actions`,
  PLACEMENT_PAY_AND_SCHEDULE_FORM_VIEWED: `${appV2EventPrefix} Placement pay and schedule form viewed`,
  PLACEMENT_APPLICATION_CREATED: `${appV2EventPrefix} Placement application created`,
  PLACEMENT_CANDIDATE_RESUME_DOWNLOAD_CLICKED: `${appV2EventPrefix} Placement candidate resume downloaded`,
  PLACEMENT_CHAT_PAGE_VIEWED: `${appV2EventPrefix} Placement chat page viewed`,
  // no longer used since the UI was removed
  PLACEMENT_PAY_BREAKDOWN_DESCRIPTION_CLICKED: `${appV2EventPrefix} Pay transparency breakdown description clicked`,
  PLACEMENT_PAY_VIEWED: `${appV2EventPrefix} Placement Pay viewed`,
  PLACEMENT_PAY_SURVEY_VIEWED: `${appV2EventPrefix} Pay survey viewed`,
  PLACEMENT_PAY_BREAKDOWN_VIEWED: `${appV2EventPrefix} Pay transparency breakdown viewed`,
  PLACEMENT_PAY_TRANSPARENCY_CALL_MODAL_OPENED: `${appV2EventPrefix} Pay transparency contribution call started modal viewed`,
  PLACEMENT_PAY_TRANSPARENCY_CALL_ISSUES: `${appV2EventPrefix} Pay transparency contribution call issue reported`,
  PLACEMENT_PAY_DATA_UPLOAD_STARTED: `${appV2EventPrefix} Pay data upload started`,
  PLACEMENT_PAY_DATA_UPLOAD_SUCCESS: `${appV2EventPrefix} Pay data upload success`,
  PLACEMENT_PAY_DATA_UPLOAD_FAILURE: `${appV2EventPrefix} Pay data upload failure`,
  PLACEMENT_PAY_SURVEY_RESPONSE_SUCCESS: `${appV2EventPrefix} Pay survey response success`,
  PLACEMENT_PAY_SURVEY_RESPONSE_FAILURE: `${appV2EventPrefix} Pay survey response failure`,
  PLACEMENT_ONBOARDING_BANNER_VIEWED: `${appV2EventPrefix} Placement onboarding banner viewed`,
  PLACEMENT_ONBOARDING_BANNER_CTA_CLICKED: `${appV2EventPrefix} Placement onboarding banner cta clicked`,
  PLACEMENT_ONBOARDING_PAGE_VIEWED: `${appV2EventPrefix} Placement onboarding page viewed`,
  PLACEMENT_ONBOARDING_PAGE_ACTIONS: `${appV2EventPrefix} Placement onboarding page actions`,
  PLACEMENT_WORKPLACE_AD_CARD_CLICKED: `${appV2EventPrefix} Placement workplace ad card clicked`,
  PLACEMENT_TALK_TO_RECRUITER_CLICKED: `${appV2EventPrefix} Placement talk to recruiter clicked`,
  PLACEMENT_TALK_TO_RECRUITER_NEXT_STEPS_CLICKED: `${appV2EventPrefix} Placement talk to recruiter next steps clicked`,
  PLACEMENT_COMPLETE_SKILLS_COURSE_CLICKED: `${appV2EventPrefix} Placement complete skills course clicked`,
  PLACEMENT_CARD_TALK_TO_RECRUITER_CLICKED: `${appV2EventPrefix} Placement card talk to recruiter clicked`,
  PLACEMENT_CARD_UPSKILLING_CLICKED: `${appV2EventPrefix} Placement card upskilling clicked`,
  PLACEMENT_RECRUITER_SCREENING_CALL_MODAL_OPENED: `${appV2EventPrefix} Placement recruiter screening call modal opened`,
  PLACEMENT_RECRUITER_SCREENING_CALL_MODAL_CLOSED: `${appV2EventPrefix} Placement recruiter screening call modal closed`,
  PLACEMENT_RECRUITER_SCREENING_CALL_CONFIRMED: `${appV2EventPrefix} Placement recruiter screening call scheduled`,
  PLACEMENT_SCREEN_LAST_STEP_SCHEDULE_LATER_MISSING_LINK: `${appV2EventPrefix} Placement screen last step schedule later missing calendly link`,
  PLACEMENT_SCREEN_LAST_STEP_SCHEDULE_LATER_CLICKED: `${appV2EventPrefix} Placement screen last step schedule later clicked`,
  PLACEMENT_SCREEN_LAST_STEP_OPEN_BROWSER_FAILED: `${appV2EventPrefix} Placement screen last step open browser failed`,
  PLACEMENT_BOOK_FIRST_EXIT_CLICKED: `${appV2EventPrefix} Placement book first exit clicked`,
  PLACEMENT_BOOK_FIRST_EXIT_DIALOG_CONFIRMED: `${appV2EventPrefix} Placement book first exit dialog confirmed`,
  PLACEMENT_BOOK_FIRST_EXIT_DIALOG_CANCELLED: `${appV2EventPrefix} Placement book first exit dialog cancelled`,
  PLACEMENT_BOOK_FIRST_SCHEDULE_LATER_CLICKED: `${appV2EventPrefix} Placement book first schedule later clicked`,
  PLACEMENT_SCREEN_LAST_STEP_EXIT_CLICKED: `${appV2EventPrefix} Placement screen last step exit clicked`,
  PLACEMENT_SCREEN_LAST_STEP_EXIT_DIALOG_CONFIRMED: `${appV2EventPrefix} Placement screen last step exit dialog confirmed`,
  PLACEMENT_SCREEN_LAST_STEP_EXIT_DIALOG_CANCELLED: `${appV2EventPrefix} Placement screen last step exit dialog cancelled`,
  PLACEMENT_SCREEN_LAST_STEP_CALL_ME_NOW_CLICKED: `${appV2EventPrefix} Placement screen last step call me now clicked`,
  PLACEMENT_SCREEN_LAST_STEP_PHONE_CONFIRMED: `${appV2EventPrefix} Placement screen last step phone confirmed`,
  PLACEMENT_SCREEN_LAST_STEP_NOTIFY_RECRUITER_FAILED: `${appV2EventPrefix} Placement screen last step notify recruiter failed`,
  RECRUITER_SCREENING_PHONE_UPDATE_FAILED: `${appV2EventPrefix} Recruiter screening phone update failed`,
  PLACEMENT_SCREEN_LAST_STEP_BACK_CLICKED: `${appV2EventPrefix} Placement screen last step back clicked`,
  PLACEMENT_SCREEN_LAST_STEP_BROWSE_JOBS_CLICKED: `${appV2EventPrefix} Placement screen last step browse jobs clicked`,
  PLACEMENT_SHARE_JOB_CLICKED: `${appV2EventPrefix} Placement share job clicked`,
  PLACEMENT_SHARE_JOB_SUCCESS: `${appV2EventPrefix} Placement share job success`,
  PLACEMENT_SHARE_JOB_FAILURE: `${appV2EventPrefix} Placement share job failure`,
  PLACEMENT_INTERVIEW_ATTENDANCE_FEEDBACK_DIALOG_VIEWED: `${appV2EventPrefix} Interview attendance feedback dialog viewed`,
  PLACEMENT_INTERVIEW_ATTENDANCE_FEEDBACK_DIALOG_ACTIONS: `${appV2EventPrefix} Interview attendance feedback dialog actions`,
  PLACEMENT_INTERVIEW_ATTENDANCE_WORKPLACES_VIEWED: `${appV2EventPrefix} Interview attendance workplaces viewed`,
  PLACEMENT_INTERVIEW_ATTENDANCE_WORKPLACES_OPTION_CLICKED: `${appV2EventPrefix} Interview attendance workplaces option clicked`,
  PLACEMENT_INTERVIEW_ATTENDANCE_WORKPLACE_VIEWED: `${appV2EventPrefix} Interview attendance workplace viewed`,
  PLACEMENT_INTERVIEW_ATTENDANCE_WORKPLACE_OPTION_CLICKED: `${appV2EventPrefix} Interview attendance workplace option clicked`,
  PLACEMENT_INTERVIEW_ATTENDANCE_EXPERIENCE_VIEWED: `${appV2EventPrefix} Interview attendance experience viewed`,
  PLACEMENT_INTERVIEW_ATTENDANCE_EXPERIENCE_OPTION_CLICKED: `${appV2EventPrefix} Interview attendance experience option clicked`,
  PLACEMENT_INTERVIEW_ATTENDANCE_CONFIRMATION_VIEWED: `${appV2EventPrefix} Interview attendance confirmation viewed`,
  PLACEMENT_INTERVIEW_ATTENDANCE_CONFIRMATION_CTA_CLICKED: `${appV2EventPrefix} Interview attendance confirmation cta clicked`,
  PLACEMENT_INTERVIEW_ATTENDANCE_OPTIONS_VIEWED: `${appV2EventPrefix} Interview attendance options viewed`,
  PLACEMENT_INTERVIEW_ATTENDANCE_OPTIONS_CLICKED: `${appV2EventPrefix} Interview attendance options clicked`,
  PLACEMENT_INTERVIEW_ATTENDANCE_REFERRAL_VIEWED: `${appV2EventPrefix} Interview attendance referral viewed`,
  PLACEMENT_INTERVIEW_ATTENDANCE_REFERRAL_SHARE_CLICKED: `${appV2EventPrefix} Interview attendance referral share clicked`,
  PLACEMENT_INTERVIEW_ATTENDANCE_FEEDBACK_CARD_VIEWED: `${appV2EventPrefix} Placement interview attendance feedback card viewed`,
  PLACEMENT_INTERVIEW_ATTENDANCE_FEEDBACK_SHARE_CLICKED: `${appV2EventPrefix} Placement interview attendance feedback share clicked`,
  JOBS_PAGE_REFERRAL_BANNER_VIEWED: `${appV2EventPrefix} Jobs page referral banner viewed`,
  JOBS_PAGE_REFERRAL_BANNER_CTA_CLICKED: `${appV2EventPrefix} Jobs page referral banner cta clicked`,
  JOBS_PAGE_REFERRAL_VIEWED: `${appV2EventPrefix} Jobs page referral viewed`,
  JOBS_PAGE_REFERRAL_SHARE_CLICKED: `${appV2EventPrefix} Jobs page referral share clicked`,
  PLACEMENT_REFER_JOB_CLICKED: `${appV2EventPrefix} Placement hiring portal refer job clicked`,
  PLACEMENT_REFER_JOB_REFERRAL_PAGE_REDIRECT: `${appV2EventPrefix} Placement referral page redirect`,
  PLACEMENT_REFER_JOB_SHARE_SUCCESS: `${appV2EventPrefix} Placement hiring portal referral successfully shared`,
  PLACEMENT_REFER_JOB_SHARE_FAILURE: `${appV2EventPrefix} Placement hiring portal referral failed to share`,

  PLACEMENT_INTERVIEW_CANCEL_MODAL_VIEWED: `${appV2EventPrefix} Placement interview cancel modal viewed`,
  PLACEMENT_INTERVIEW_CANCEL_MODAL_ACTIONS: `${appV2EventPrefix} Placement interview cancel modal actions`,
  PLACEMENT_PAST_INTERVIEW_CANCEL_MODAL_VIEWED: `${appV2EventPrefix} Placement past interview cancel modal viewed`,
  PLACEMENT_PAST_INTERVIEW_CANCEL_MODAL_ACTIONS: `${appV2EventPrefix} Placement past interview cancel modal actions`,
  PLACEMENT_INTERVIEW_RELIABILITY_MODAL_VIEWED: `${appV2EventPrefix} Placement interview reliability modal viewed`,
  PLACEMENT_INTERVIEW_TODAY_RESCHEDULE_MODAL_VIEWED: `${appV2EventPrefix} Placement interview today reschedule modal viewed`,
  PLACEMENT_INTERVIEW_TODAY_RESCHEDULE_MODAL_ACTIONS: `${appV2EventPrefix} Placement interview today reschedule modal actions`,
  PLACEMENT_INTERVIEW_ADD_TO_CALENDAR_CLICKED: `${appV2EventPrefix} Placement interview add to calendar clicked`,
  PLACEMENT_CONNECTED_LISTING_VIEWED: `${appV2EventPrefix} Placement connected listing viewed`,

  // Generic In-App Ads
  AD_INJECTED_INTO_SHIFTS: `${appV2EventPrefix} In-app ad injected into shifts array`,
  AD_VIEWED: `${appV2EventPrefix} In-app ad seen`,
  AD_CLICKED: `${appV2EventPrefix} In-app ad clicked`,
  AD_BUTTON_CLICKED: `${appV2EventPrefix} In-app ad button clicked`,

  // Fortune Cookie
  FORTUNE_COOKIE_INJECTED_INTO_SHIFTS: `${appV2EventPrefix} Fortune cookie injected into shifts array`,
  FORTUNE_VIEWED: `${appV2EventPrefix} Fortune viewed`,

  // Worker Pay Survey
  WORKER_PAY_SURVEY_INJECTED_INTO_SHIFTS: `${appV2EventPrefix} Worker pay survey injected into shifts array`,
  WORKER_PAY_SURVEY_CARD_SHOWN: `${appV2EventPrefix} Worker pay survey card shown`,

  // Payments
  GET_BONUS_PAYMENTS_FAILURE: `${appV2EventPrefix} Failed to load bonus payments`,
  BONUS_PAYMENTS_VIEWED: `${appV2EventPrefix} Bonus payments viewed`,
  GET_PAYMENT_DETAILS_FAILURE: `${appV2EventPrefix} Failed to load payment details`,

  // Interview Availability
  GET_INTERVIEW_AVAILABILITY_FAILURE: `${appV2EventPrefix} Failed to load interview availability`,
  GET_WORKER_INTERVIEW_HISTORY_FAILURE: `${appV2EventPrefix} Failed to load worker interview history`,

  // Booked Interview
  BOOKED_INTERVIEW_CLICKED: `${appV2EventPrefix} Booked interview clicked`,
  INTERVIEW_CREATED: `${appV2EventPrefix} Interview created`,
  INTERVIEW_CREATION_FAILURE: `${appV2EventPrefix} Interview creation failure`,
  INTERVIEW_BOOKING_BOTTOMSHEET_OPENED: `${appV2EventPrefix} Interview booking bottomsheet opened`,
  INTERVIEW_DATE_SELECTED: `${appV2EventPrefix} Interview date selected`,
  INTERVIEW_TIME_SELECTED: `${appV2EventPrefix} Interview time selected`,
  INTERVIEW_BOOKING_SUBMITTED: `${appV2EventPrefix} Interview booking submitted`,
  INTERVIEW_RELIABILITY_BOTTOM_SHEET_CONTINUE_CLICKED: `${appV2EventPrefix} Interview reliability bottom sheet continue clicked`,
  INTERVIEW_LOCATION_PERMISSION_BOTTOM_SHEET_SHOWN_BEFORE_BOOKING: `${appV2EventPrefix} Interview location permission bottom sheet shown before booking`,
  INTERVIEW_LOCATION_PERMISSION_BOTTOM_SHEET_SHOWN_AFTER_BOOKING: `${appV2EventPrefix} Interview location permission bottom sheet shown after booking`,
  INTERVIEW_LOCATION_PERMISSION_CONTINUE_CLICKED: `${appV2EventPrefix} Interview location permission continue clicked`,
  EASY_SCHEDULING_DEEP_LINK_TRIGGERED: `${appV2EventPrefix} Easy Scheduling Deep Link Triggered`,
  INTERVIEW_DATE_PILL_TAPPED: `${appV2EventPrefix} Interview date pill tapped`,
  INTERVIEW_SEE_ALL_PILL_TAPPED: `${appV2EventPrefix} Interview see all pill tapped`,
  JOB_CARD_INTERVIEW_FLOW_DISMISSED: `${appV2EventPrefix} Job card interview flow dismissed`,

  // Submit Documents Later Flow
  SUBMIT_DOCUMENTS_LATER_BOTTOM_SHEET_VIEWED: `${appV2EventPrefix} Submit documents later bottom sheet viewed`,
  SUBMIT_DOCUMENTS_LATER_HOLD_STARTED: `${appV2EventPrefix} Submit documents later hold started`,
  SUBMIT_DOCUMENTS_LATER_HOLD_COMPLETED: `${appV2EventPrefix} Submit documents later hold completed`,
  SUBMIT_DOCUMENTS_LATER_DISMISSED: `${appV2EventPrefix} Submit documents later dismissed`,

  // Update Interview
  UPDATE_INTERVIEW_SUCCESS: `${appV2EventPrefix} Successfully updated interview`,
  UPDATE_INTERVIEW_FAILURE: `${appV2EventPrefix} Failed to update interview`,

  // Update Interview ETA
  UPDATE_INTERVIEW_ETA_FAILURE: `${appV2EventPrefix} Failed to update interview ETA`,
  UPDATE_INTERVIEW_ETA_SUBMITTED: `${appV2EventPrefix} Worker submitted interview ETA update`,

  // Google Maps SDK
  GOOGLE_MAPS_SDK_LOADED: `${appV2EventPrefix} Google Maps SDK Loaded`,
  GOOGLE_MAPS_SDK_LOAD_ERROR: `${appV2EventPrefix} Google Maps SDK Load Error`,
  GOOGLE_MAPS_RENDER_ERROR: `${appV2EventPrefix} Google Maps Render Error`,

  // Push Notification Permission Sync
  PUSH_NOTIFICATION_PERMISSION_SYNC_FAILURE: `${appV2EventPrefix} Push Notification Permission Sync Failure`,
  PUSH_NOTIFICATION_PERMISSION_CHANGED: `${appV2EventPrefix} Push Notification Permission Changed`,

  // Facility Timeclock Compliance
  FACILITY_TIMECLOCK_COMPLIANCE_ERROR: `${appV2EventPrefix} Facility Timeclock Compliance Error`,

  // Shift Time Proposal
  SHIFT_TIME_PROPOSAL_ACCEPTED: `${appV2EventPrefix} Shift Time Proposal Accepted`,
  SHIFT_TIME_PROPOSAL_DECLINED: `${appV2EventPrefix} Shift Time Proposal Declined`,
  SHIFT_TIME_PROPOSAL_ACCEPTED_ERROR: `${appV2EventPrefix} Shift Time Proposal Accepted Error`,
  SHIFT_TIME_PROPOSAL_DECLINED_ERROR: `${appV2EventPrefix} Shift Time Proposal Declined Error`,

  // White Screen Detection
  WHITE_SCREEN_DETECTED: `${appV2EventPrefix} White Screen Detected`,
  WHITE_SCREEN_DETECTION_ERROR: `${appV2EventPrefix} White Screen Detection Error`,

  // Shift Feedback
  SHIFT_FEEDBACK_URL_GENERATION_FAILED: `${appV2EventPrefix} Shift feedback url generation failed`,
  SHIFT_FEEDBACK_DYNAMIC_LINK_GENERATION_FAILED: `${appV2EventPrefix} Shift feedback dynamic link genration failed`,

  SHIFT_FEEDBACK_QR_CODE_OPENED_IN_APP: `${appV2EventPrefix} Shift feedback QR code opened in-app`,

  // In Home
  GET_VISIT_DATA_FAILURE: `${appV2EventPrefix} In Home Failed to load visit data`,
  BOOK_VISIT_FAILURE: `${appV2EventPrefix} In Home Failed to book visit`,
  IN_HOME_CONFIRMED_VISIT_ERROR: `${appV2EventPrefix} Confirmed Visit Error`,
  GET_BOOKED_CASES_FAILURE: `${appV2EventPrefix} In Home Failed to get booked cases`,

  // Zendesk SSO Bridge
  ZENDESK_SSO_ERROR_GETTING_TOKEN: `${appV2EventPrefix} Zendesk SSO error getting token`,
  ZENDESK_ARTICLE_OPENED: `${appV2EventPrefix} Zendesk article opened`,
  ZENDESK_ARTICLE_OPENED_ERROR: `${appV2EventPrefix} Zendesk article opened error`,
  ZENDESK_USER_SIGNOUT: `${appV2EventPrefix} Zendesk user signed out`,

  // Shift verification
  SHIFT_VERIFICATION_REQUEST_CREATION_FAILED: `${appV2EventPrefix} Shift verification request creation failed`,

  // App Loading Page Debugging
  APP_LOADING_PAGE_PRIVATE_ROUTE_PROPS: `${appV2EventPrefix} App loading page private route props`,
  APP_LOADING_PAGE_PUBLIC_PAGE_PROPS: `${appV2EventPrefix} App loading page public page props`,
  APP_LOADING_PAGE_PUBLIC_ROUTES_PROPS: `${appV2EventPrefix} App loading page public routes props`,

  // Debugging auth process and remounting entire react tree on resume
  FORCE_APP_RESET_ON_RESUME: `${appV2EventPrefix} Force app reset on resume (debugging enabled)`,

  // Worker Credentials
  GET_WORKER_CREDENTIALS_FAILURE: `${appV2EventPrefix} Failed to get worker credentials`,
  UPDATE_WORKER_CREDENTIALS_FAILURE: `${appV2EventPrefix} Failed to update worker credentials`,

  // Deep Links
  BRANCH_IO_INIT: `${appV2EventPrefix} BranchIo init`,
  BRANCH_IO_INVALID_LINK: `${appV2EventPrefix} BranchIo invalid link`,
  BRANCH_IO_READ_DEEP_LINK_FAILED: `${appV2EventPrefix} BranchIo read deep link failed`,
  INVALID_DEEP_LINK: `${appV2EventPrefix} Invalid deep link`,
  UNSUPPORTED_CBH_CARE_DEEP_LINK: `${appV2EventPrefix} Unsupported cbh.care deep link opened`,

  FIREBASE_ON_ID_TOKEN_CHANGED_LISTENER_ADDED: `${appV2EventPrefix} Firebase onIdTokenChanged Listener Added`,
  FIREBASE_ON_ID_TOKEN_CHANGED_ERROR: `${appV2EventPrefix} Firebase onIdTokenChanged error`,

  // Travel Blocks
  TRAVEL_BLOCKS_PAGE_VIEWED: `${appV2EventPrefix} Travel Blocks page viewed`,

  // Payout Settings
  PAYOUT_SETTINGS_GET_SETTINGS_FAILURE: `${appV2EventPrefix} Payout Settings Get Settings Failure`,
  PAYOUT_SETTINGS_GET_EXTERNAL_ACCOUNTS_FAILURE: `${appV2EventPrefix} Payout Settings Get External Accounts Failure`,
  PAYOUT_SETTINGS_UPDATE_SETTINGS_FAILURE: `${appV2EventPrefix} Payout Settings Update Settings Failure`,

  GET_LAST_PAYOUT_FAILURE: `${appV2EventPrefix} Get Last Payout Failure`,

  STRIPE_DEEP_LINK_FALLBACK_USED: `${appV2EventPrefix} Stripe Deep Link Fallback Used`,
  GENERATE_STRIPE_EXPRESS_SIGN_IN_LINK_FAILURE: `${appV2EventPrefix} Generate Stripe Express Sign In Link Failure`,
  GENERATE_STRIPE_ONBOARDING_LINK_FAILURE: `${appV2EventPrefix} Generate Stripe Onboarding Link Failure`,

  // Shift Recommendations
  GET_SHIFT_RECOMMENDATIONS_FAILURE: `${appV2EventPrefix} Failed to get shift recommendations`,

  // Shift Transfer
  GET_SHIFT_TRANSFER_ELIGIBLE_FRIENDS_FAILURE: `${appV2EventPrefix} Failed to get eligible friends`,
  CREATE_SHIFT_TRANSFER_FAILURE: `${appV2EventPrefix} Failed to create shift transfer`,
  GET_SHIFT_TRANSFER_FAILURE: `${appV2EventPrefix} Failed to get shift transfer`,
  UPDATE_SHIFT_TRANSFER_FAILURE: `${appV2EventPrefix} Failed to update shift transfer`,

  // Roles
  ADD_ROLE_FAILURE: `${appV2EventPrefix} Failed to add role`,
  REMOVE_ROLE_FAILURE: `${appV2EventPrefix} Failed to remove role`,

  // Clipboard Score
  CLIPBOARD_SCORE_PROFILE_ERROR: `${appV2EventPrefix} Failed to get Clipboard Score Profile`,
  CLIPBOARD_SCORE_HISTORY_ERROR: `${appV2EventPrefix} Failed to get Clipboard Score History`,

  SET_PREFERRED_PERSISTENCE_FOR_FIREBASE_AUTH: `${appV2EventPrefix} Set preferred persistence for firebase auth`,

  // Timekeeping integrations
  TIMEKEEPING_INTEGRATIONS_INTERNAL_TIMECLOCK_NOT_WORKING: `${appV2EventPrefix} Internal timeclock not working`,

  // Temporary events for debugging
  APP_STATE_CHANGE: `${appV2EventPrefix} App State Change`,
  APP_STATE_CHANGE_INVALIDATE_GET_WORKER_QUERY: `${appV2EventPrefix} App State Change Invalidate Get Worker Query`,
  WORKER_INITIALIZATION_QUERY_DEBUGGING: `${appV2EventPrefix} Worker Initialization Query Debugging`,
  GET_WORKER_ABORT_SIGNAL_RECEIVED: `${appV2EventPrefix} Get Worker Abort Signal Received`,

  // Geofence
  GEOFENCE_POLLING_FAILED: `${appV2EventPrefix} Geofence Polling Failed`,
  HYPERTRACK_SUBSCRIPTION_SETUP_FAILED: `${appV2EventPrefix} HyperTrack Subscription Setup Failed`,

  // Collect Placement Application Preference Form
  PLACEMENT_APPLICATION_PREFERENCE_FORM_DETAILS: `${appV2EventPrefix} Placement application preference form details`,

  // Charting Noncompliance
  GET_CHARTING_NONCOMPLIANCES_FAILURE: `${appV2EventPrefix} Charting Noncompliance - get failure`,
  PATCH_CHARTING_NONCOMPLIANCE_FAILURE: `${appV2EventPrefix} Charting Noncompliance - patch failure`,
  GET_CHAT_DETECTED_CHARTING_CREDENTIALS_FAILURE: `${appV2EventPrefix} Get Chat Detected Charting Credentials - Failure`,
  DISMISS_CHAT_DETECTED_CHARTING_CREDENTIALS_FAILURE: `${appV2EventPrefix} Dismiss Chat Detected Charting Credentials - Failure`,

  // Notification Preferences
  GET_NOTIFICATION_PREFERENCES_FAILURE: `${appV2EventPrefix} failed to get notification preferences`,
  SET_NOTIFICATION_PREFERENCES_FAILURE: `${appV2EventPrefix} failed to set notification preferences`,

  // Background Check
  BACKGROUND_CHECK_STARTED_WITH_MISSING_SHIFT_ID: `${appV2EventPrefix} Background check started with missing shift id`,
  BACKGROUND_CHECK_STARTED_WITH_MISSING_REQUIRED_DATA: `${appV2EventPrefix} Background check started with missing required data`,
  BACKGROUND_CHECK_FAILED_TO_UPDATE_WORKER_DETAILS: `${appV2EventPrefix} Background check failed to update worker details`,
  BACKGROUND_CHECK_CONSENT_SUBMITTED: `${appV2EventPrefix} Background check consent submitted`,
  BACKGROUND_CHECK_CONSENT_SUBMIT_ERROR: `${appV2EventPrefix} Background check consent submit error`,
  BACKGROUND_CHECK_CONSENT_LOAD_ERROR: `${appV2EventPrefix} Background check consent load error`,
  CHECKR_SDK_LOAD_ERROR: `${appV2EventPrefix} Checkr SDK load error`,
  CHECKR_SDK_LOADED: `${appV2EventPrefix} Checkr SDK loaded`,
  GET_BACKGROUND_CHECK_CONSENT_CONFIGURATIONS_FAILURE: `${appV2EventPrefix} Failed to get background check consent configurations`,
  BACKGROUND_CHECK_CONSENT_PAGE_VIEWED: `${appV2EventPrefix} Background check consent page viewed`,
  FAILED_TO_GET_AUTH_TOKEN_FOR_BACKGROUND_CHECK_CONSENT: `${appV2EventPrefix} Failed to get auth token for background check consent`,
  POST_BACKGROUND_CHECK_CONSENT_FAILURE: `${appV2EventPrefix} Failed to post background check consent`,
  POST_BACKGROUND_CHECK_CANDIDATE_FAILURE: `${appV2EventPrefix} Failed to post background check candidate`,
  CLICKED_BACKGROUND_CHECK_BUTTON: `${appV2EventPrefix} Clicked background check submit button`,
  BACKGROUND_CHECK_CONSENT_CONFIGURATIONS_ERROR: `${appV2EventPrefix} Background check consent configurations error`,
  BACKGROUND_CHECK_INTRO_PAGE_VIEWED: `${appV2EventPrefix} Background check intro page viewed`,
  BACKGROUND_CHECK_DETAILS_PAGE_VIEWED: `${appV2EventPrefix} Background check details page viewed`,
  BACKGROUND_CHECK_COMPLETED_PAGE_VIEWED: `${appV2EventPrefix} Background check completed page viewed`,
  FAILED_TO_CREATE_BACKGROUND_CHECK_CANDIDATE: `${appV2EventPrefix} Failed to create background check candidate`,
  FAILED_TO_CALCULATE_AUTO_UNASSIGNMENT_VALIDITY_WINDOW: `${appV2EventPrefix} Failed to calculate auto unassignment validity window`,
  DELAYED_BACKGROUND_CHECK_NOTICE_SHOWN: `${appV2EventPrefix} Delayed background check notice shown`,
  FILTER_BACKGROUND_CHECK_REQUIREMENTS_V2_MISMATCH: `${appV2EventPrefix} Filter background check requirements V2 mismatch`,

  // Knock
  KNOCK_TOKEN_REFRESH_FAILED: `${appV2EventPrefix} Knock token refresh failed`,
  KNOCK_TOKEN_REFRESH_REQUESTED: `${appV2EventPrefix} Knock token refresh requested`,
  KNOCK_COMPONENT_ERROR_BOUNDARY: `${appV2EventPrefix} Knock component error boundary`,
  KNOCK_GUIDES_REFETCH_ON_RESUME_FAILED: `${appV2EventPrefix} Knock guides refetch on resume failed`,
  KNOCK_GUIDES_REFETCH_ON_ROUTE_CHANGE_FAILED: `${appV2EventPrefix} Knock guides refetch on route change failed`,
  KNOCK_GUIDES_ATTACH_RESUME_LISTENER_FAILED: `${appV2EventPrefix} Knock guides attach resume listener failed`,
  KNOCK_BROWSER_OPEN_FAILED: `${appV2EventPrefix} Knock browser open failed`,
  KNOCK_GUIDE_ACTION_NOT_HANDLED: `${appV2EventPrefix} Knock guide action not handled`,
  KNOCK_PUSH_TOKEN_REGISTERED: `${appV2EventPrefix} Knock push token registered`,
  KNOCK_PUSH_TOKEN_REGISTRATION_FAILED: `${appV2EventPrefix} Knock push token registration failed`,
  KNOCK_PUSH_TOKEN_UNREGISTERED: `${appV2EventPrefix} Knock push token unregistered`,
  KNOCK_PUSH_TOKEN_UNREGISTRATION_FAILED: `${appV2EventPrefix} Knock push token unregistration failed`,
  KNOCK_MESSAGE_STATUS_UPDATED: `${appV2EventPrefix} Knock message status updated`,
  KNOCK_MESSAGE_STATUS_UPDATE_FAILED: `${appV2EventPrefix} Knock message status update failed`,

  // Connectivity
  INITIAL_CONNECTION_STATUS_REPORTED: `${appV2EventPrefix} Initial connection status reported`,
  CONNECTION_STATUS_CHANGED: `${appV2EventPrefix} Connection status changed`,

  // Jobs Market Launch Countdown Page
  JOB_FAIR_COUNTDOWN_PAGE_VIEWED: `${appV2EventPrefix} Job fair countdown page viewed`,
  JOB_FAIR_COUNTDOWN_PAGE_INVITE_CLICKED: `${appV2EventPrefix} Job fair countdown page invite clicked`,

  // Address Autocomplete
  ADDRESS_AUTOCOMPLETE_PLACE_DETAILS_ERROR: `${appV2EventPrefix} Address autocomplete place details error`,

  // Ten99 Policy
  GET_TEN99_POLICY_ASSIGNMENT_BY_SHIFT_ID_FAILURE: `${appV2EventPrefix} Failed to get ten99 policy assignment by shift id`,

  // Payout
  PAYOUT_REMAINING_BALANCE_FAILURE: `${appV2EventPrefix} Failed to payout remaining balance`,

  // Live Activity
  LIVE_ACTIVITY_SET_UP_LISTENER_ERROR: `${appV2EventPrefix} Failed to set up listener for live activity push token events`,
  LIVE_ACTIVITY_CREATE_OR_UPDATE_ERROR: `${appV2EventPrefix} Failed to create or update live activity`,
  LIVE_ACTIVITIES_FAILED_TO_START_ERROR: `${appV2EventPrefix} Failed to start live activity`,
  LIVE_ACTIVITIES_SKIPPING_CREATION: `${appV2EventPrefix} Live activities skipping creation`,
  LIVE_ACTIVITIES_STARTING_CREATION: `${appV2EventPrefix} Live activities starting creation`,

  // Tax Information
  GET_WORKER_INCOME_FAILURE: `${appV2EventPrefix} Failed to get worker income`,

  // Travel Time
  ESTIMATED_TRAVEL_TIME_CALCULATED: `${appV2EventPrefix} Estimated travel time calculated`,
  ESTIMATED_TRAVEL_TIME_CALCULATION_FAILED: `${appV2EventPrefix} Estimated travel time calculation failed`,

  // Holiday Gift
  HOLIDAY_GIFT_SHARE_SUCCESS: `${appV2EventPrefix} Holiday Gift Share Success`,
  HOLIDAY_GIFT_SHARE_FAILURE: `${appV2EventPrefix} Holiday Gift Share Failure`,

  // Support
  FAILED_TO_OPEN_HELP_CENTER_ARTICLE: `${appV2EventPrefix} Failed to open help center article`,

  // Work Badges
  WORK_BADGE_PDF_GENERATION_FAILURE: `${appV2EventPrefix} Work badge pdf generation failure`,
  WORK_BADGE_PHOTO_UPLOAD_FAILURE: `${appV2EventPrefix} Work badge photo upload failure`,
  WORK_BADGE_PDF_UPLOAD_FAILURE: `${appV2EventPrefix} Work badge pdf upload failure`,
  WORK_BADGE_EMAIL_SEND_FAILURE: `${appV2EventPrefix} Work badge email send failure`,
  WORK_BADGE_EMAIL_WITH_PDF_FAILURE: `${appV2EventPrefix} Work badge email with pdf failure`,
  BADGE_SMITH_CHECKOUT_OPEN_FAILURE: `${appV2EventPrefix} Badge Smith checkout open failure`,
  BADGE_SMITH_ORDER_CREATE_FAILURE: `${appV2EventPrefix} Badge Smith order create failure`,

  // Worker Pay Survey
  CREATE_WORKER_PAY_SURVEY_ANSWER_FAILURE: `${appV2EventPrefix} Failed to create worker pay survey answer`,

  // Badge Verification (Clock-In)
  BADGE_VERIFICATION_TAKE_PHOTO_FAILURE: `${appV2EventPrefix} Badge Verification Take Photo Failure`,
  BADGE_VERIFICATION_SUBMIT_FAILURE: `${appV2EventPrefix} Badge Verification Submit Failure`,
  BADGE_VERIFICATION_GET_FAILURE: `${appV2EventPrefix} Badge Verification Get Failure`,
  BADGE_VERIFICATION_CREATE_FAILURE: `${appV2EventPrefix} Badge Verification Create Failure`,
  BADGE_VERIFICATION_UPDATE_FAILURE: `${appV2EventPrefix} Badge Verification Update Failure`,
  BADGE_VERIFICATION_S3_UPLOAD_FAILURE: `${appV2EventPrefix} Badge Verification S3 Upload Failure`,

  // Early Access Facilities
  GET_EARLY_ACCESS_FACILITIES_FAILURE: `${appV2EventPrefix} Failed to get early access facilities`,
  EARLY_ACCESS_FACILITIES_INTEREST_FORM_ERROR: `${appV2EventPrefix} Early access facilities interest form error`,

  // Shift Bundles
  SHIFT_BUNDLE_BOOKING_FAILURE: `${appV2EventPrefix} Shift Bundle Booking Failure`,
  SHIFT_BUNDLE_NO_OFFER_FOUND_FAILURE: `${appV2EventPrefix} Shift Bundle No Offer Found Failure`,
  SHIFT_BUNDLE_NO_SHIFT_PAY_FOUND_FAILURE: `${appV2EventPrefix} Shift Bundle No Shift Pay Found Failure`,
  SHIFT_BUNDLE_GET_BATCH_OFFERS_FAILURE: `${appV2EventPrefix} Shift Bundle Get Batch Offers Failure`,
  SHIFT_BUNDLE_FAILED_TO_LOAD: `${appV2EventPrefix} Shift Bundle Failed to Load`,

  // Stripe Restriction
  STRIPE_RESTRICTION_BANNER_GET_STATUS_FAILURE: `${appV2EventPrefix} Stripe restriction banner get status failure`,

  // PandaDoc
  PANDADOC_SESSION_EXCEPTION: `${appV2EventPrefix} PandaDoc session exception`,
  PANDADOC_SDK_DOCUMENT_RENDERED: `${appV2EventPrefix} PandaDoc SDK document rendered`,

  // TB Test Guided Upload
  TB_TEST_GUIDED_UPLOAD_UPLOAD_FAILED: `${appV2EventPrefix} TB test guided upload upload failed`,

  // Suggest InstantPay
  SUGGEST_INSTANT_PAY_SWITCH_FAILURE: `${appV2EventPrefix} Suggest InstantPay Switch Failure`,
  // Impersonation
  IMPERSONATION_STARTED: `${appV2EventPrefix} Impersonation started`,
  IMPERSONATION_TOKEN_RECEIVED: `${appV2EventPrefix} Impersonation token received`,
  IMPERSONATION_AUTH_SUCCESS: `${appV2EventPrefix} Impersonation auth success`,
  IMPERSONATION_AUTH_FAILURE: `${appV2EventPrefix} Impersonation auth failure`,
  IMPERSONATION_SESSION_EXPIRED: `${appV2EventPrefix} Impersonation session expired`,
  IMPERSONATION_SESSION_ENDED: `${appV2EventPrefix} Impersonation session ended`,
  IMPERSONATION_CLEANUP_STARTED: `${appV2EventPrefix} Impersonation cleanup started`,
  IMPERSONATION_CLEANUP_COMPLETE: `${appV2EventPrefix} Impersonation cleanup complete`,

  // Shifts Stats
  GET_SHIFTS_STATS_FAILURE: `${appV2EventPrefix} Get Shifts Stats Failure`,

  // For You Shifts
  FOR_YOU_SHIFTS_PAST_SHIFT_MISSING_SCHEDULE: `${appV2EventPrefix} For You Shifts - Past Shift Missing Schedule`,
  FOR_YOU_SHIFTS_PAST_SHIFT_MISSING_REQUIRED_FIELDS: `${appV2EventPrefix} For You Shifts - Past Shift Missing Required Fields`,
  FOR_YOU_SHIFTS_NO_SHIFTS_SELECTED: `${appV2EventPrefix} For You Shifts - No Shifts Selected`,

  // Employment Verifications
  GET_EMPLOYMENT_VERIFICATIONS_FAILURE: `${appV2EventPrefix} Failed to get employment verifications`,
  EMPLOYMENT_VERIFICATION_FILE_UPLOAD_FAILURE: `${appV2EventPrefix} Failed to upload employment verification file`,
  EMPLOYMENT_VERIFICATION_PRESIGNED_URL_FAILURE: `${appV2EventPrefix} Failed to get employment verification presigned upload URL`,
} as const;
